import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useTransition,
} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Swal from "sweetalert2";
import FormPayment from "../../forms/FormPayment";
import BarcodeReader from "react-barcode-reader";
import { get } from "../../services/apiService";
import DatePicker from "react-datepicker";

import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import warrantyIcon from "./../../assets/images/warranty-icon.png";
import ProductVariationIcon from "./../../assets/images/product-variation.png";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineSearch,
} from "react-icons/ai";
import { MdClose } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { Modal } from "../../utils/Modal";
import "../OrderProduct/OrderProduct.css";
//import categoryDymmyImaage from "../../assits/product1.png";
import { GrFormClose } from "react-icons/gr";
import Pagination from "../../utils/pagination"; // Adjust the path accordingly
import { useFlashMessage } from "../../context/FlashMessageContext";
import { AppContext } from "../../context/context.js";
import InvoiceCustomerForm from "../../forms/InvoiceCustomerForm.js";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import cardIcon from "../../assets/images/card.svg";
import moneyIcon from "../../assets/images/coin-hand.svg";
import qrIcon from "../../assets/images/qr_code.svg";
import wholeSale from "../../assets/images/wholesale.png";
import { formatPrice, eclipse, formatNumber } from "../../utils/Common";
import ItemSelectBox from "../../forms/ItemSelectBox.js";
import EditFormPayment from "../../forms/EditFormPayment.js";
import { useLocation } from "react-router-dom";
import CustomerInfoModal from "./CustomerInfoModal.js";
import SelectBox2 from "../../forms/Select2.js";
import ItemSelectBox2 from "../../forms/ItemSelectBox2.js";
import { distance } from "fastest-levenshtein";
import Type4BillingGrid from "../OrderProduct/Type4BillingGrid.jsx";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;

  return (
    <div
      className="p-[6px] rounded-full absolute top-[40%] -right-[8px]"
      style={{ ...style, display: "inline-block", background: "#7F8098" }}
      onClick={onClick}
    >
      <AiOutlineArrowRight className="text-[#FFF] text-base font-bold"></AiOutlineArrowRight>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      className="p-[6px] rounded-full absolute top-[40%] -left-[9px] z-50"
      style={{ ...style, display: "inline-block", background: "#7F8098" }}
      onClick={onClick}
    >
      <AiOutlineArrowLeft className="text-[#FFF] text-base font-bold"></AiOutlineArrowLeft>
    </div>
  );
}
const BASE_URL = process.env.REACT_APP_ROOT_URL;
const shop_logo = `${BASE_URL}/layoutlogo.svg`;

const EditOrderProduct = (props) => {
  const {
    type,
    invoiceData,
    salesType,
    initialDiscount,
    setInitialDiscount,
    paidAmount,
    setPaidAmount,
  } = props;
  const [cashChange, setCashChange] = useState(invoiceData?.cash_change ?? 0);
  console.log("Invoice Data: ", invoiceData);

  const [isShowModal, setIsShowModal] = useState(false);
  const [reference, setReference] = useState(
    invoiceData?.multiple_payment || null
  );
  const location = useLocation();

  const {
    state,
    setPaperSize,
    setDeliveryMode,
    updateBrandList,
    updateWarrantyList,
  } = useContext(AppContext);

  const [paymentList, setPaymentList] = useState([]);
  const [deliveryList, setDeliveryList] = useState([]);
  const [deliveryAccountList, setDeliveryAccountList] = useState([]);
  const [isSave, setIsSave] = useState(1);
  const [selectedImei, setSelectedImei] = useState(null);
  const [status, setStatus] = useState(1);
  const [transactionDate, setTransactionDate] = useState(
    invoiceData.created_at
  );
  const {
    getFlashMessageStyle,
    setSuccessFlashMessage,
    flashMessage,
    setErrorFlashMessage,
  } = useFlashMessage(); // Retrieve the dispatch function from your state management library

  const { currentUser, invoiceSetting } = state;
  const [category, setCategory] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [filterItem, setFilterItem] = useState([]);
  const [invoice, setInvoice] = useState(invoiceData);
  const [customer, setCustomer] = useState({
    customer_id: invoiceData?.customer_id,
    customer_name: invoiceData?.customer_name,
    customer_phone: invoiceData?.customer_phone,
  });
  const [seller, setSeller] = useState(invoiceData?.saler);
  const [vendor, setVendor] = useState(invoiceData?.vendor);
  const [warningMessage, setWarningMessage] = useState(false);
  const [vat, setVat] = useState(
    invoiceSetting?.vat != "" ? Number(invoiceSetting?.vat) : 0
  );
  const [tax, setTax] = useState(
    invoiceSetting?.tax != "" ? Number(invoiceSetting?.tax) : 0
  );
  const [moodActive, setMoodActive] = useState(null);
  const [sizeActive, setSizeActive] = useState(null);
  const [sugarActive, setSugarActive] = useState(null);
  const [iceActive, setIceActive] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [selectedFood, setSelectedFood] = useState(null);
  // const [orderList, setOrderList] = useState(invoiceData ? invoiceData.sales_details : []);
  const [orderList, setOrderList] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [moreDiscount, setMoreDiscount] = useState(invoiceData?.discount || 0);
  const [totalMoreDiscount, setTotalMoreDiscount] = useState(invoiceData?.discount || initialDiscount);
  const [selectedDiscountType, setSelectedDiscountType] = useState();
  const [grandTotal, setGrandTotal] = useState(
    invoiceData.sub_total + invoiceData.vat + invoiceData.tax
  );
  const [subTotalNew, setSubTotalNew] = useState(invoiceData.sub_total);
  const [grandTotalAfterDiscount, setGrandTotalDiscounted] = useState(0);
  const [deliveryAmount, setDeliveryAmount] = useState(
    invoiceData.delivery_fee ? invoiceData.delivery_fee : "0.00"
  );
  const [change, setChange] = useState(false);
  const [loader, setLoader] = useState(true);
  const [paymentAccountList, setPaymentAccountList] = useState([]);
  const defaultPayment = paymentList.find(
    (p) => p.type_name.toLowerCase() == "cash"
  );

  // Initialize state with the default payment
  const [
    selectedPaymentAccountListForExchange,
    setSelectedPaymentAccountListForExchange,
  ] = useState({});

  useEffect(() => {
    console.log(
      "selectedPaymentAccountListForExchange......... ",
      selectedPaymentAccountListForExchange
    );
    console.log("defaultPayment......... ", defaultPayment);

    // Ensure default payment is set when component mounts or paymentList updates
    // if (!selectedPaymentAccountListForExchange) {
    //   setSelectedPaymentAccountListForExchange(defaultPayment);
    // }
    console.log(
      "selectedPaymentAccountListForExchange.........After ",
      selectedPaymentAccountListForExchange
    );
  }, [paymentList]);
  const [due, setDue] = useState(
    invoiceData.sub_total -
      invoiceData.discount +
      invoiceData.vat +
      invoiceData.tax -
      invoiceData.paid_amount
  );

  // console.log(filteredProducts)
  // const [paidAmount, setPaidAmount] = useState(invoiceData.paid_amount);
  // const [selectedProductWarrantyList, setSelectedProductWarrantyList] = useState([]);
  const [selectedProductWarrantyList, setSelectedProductWarrantyList] =
    useState([]);
  const [productVariation, setProductVariation] = useState(false);
  const [warrantyModal, setWarrantyModal] = useState(false);
  const [warrantyList, setWarrantyList] = useState([]);
  const [searchVarientItem, setSearchVarientItem] = useState("");
  const [productVariants, setProductVariants] = useState([]);
  const [productVariantIndex, setProductVariantIndex] = useState(0);
  const [productVariantListModal, setProductVariantListModal] = useState(false);

  // Added by saif for editing for user type 1 & 2
  const [editableSubtotals, setEditableSubtotals] = useState({});
  const [editablePrices, setEditablePrices] = useState({});
  const [selectedSearchIndex, setSelectedSearchIndex] = useState(0);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);

  const [selectedItem, setSelectedItem] = useState({});
  const user = JSON.parse(localStorage.getItem("user"));
  const locationPurchase = useLocation();
  const typePurchase = locationPurchase.pathname.includes("purchase-invoice");
  const typeEcommerce = locationPurchase.pathname.includes("edit-ecommerce");
  const typeSaleEdit = locationPurchase.pathname.includes("invoice/edit");
  useEffect(() => {}, [orderList]);

  console.log(typeEcommerce);

  const [selectedImeis, setSelectedImeis] = useState([]);
  const [imeis, setImeis] = useState([]);
  const [isPriceChanged, setIsPriceChanged] = useState(false);

    // billing type 4
  const isType4EditBillingView = user?.type == "4" && type == "billing";

  // const handleSelectedItemQty129 = (item, field, e) => {
  //   // console.log(orderList);
  //   let qty = e.target.value;
  //   // console.log(qty);
  //   // if(isNaN(qty)){
  //   //   qty = 0
  //   // }

  //   // console.log(qty);
  //   const modifiedQty = qty.split("x")[1];
  //   const parsedQty = parseInt(modifiedQty, 10);
  //   const parsedPrice = parseInt(e.target.value);

  //   if (parsedPrice === paidAmount) {
  //     setIsPriceChanged(false);
  //   } else {
  //     setIsPriceChanged(true);
  //   }

  //   const existingIndex = orderList.findIndex(
  //     (orderItem) => orderItem?.id === item.id
  //   );
  //   console.log("inside handleSelectedItemQty129...",existingIndex,orderList[existingIndex], parsedQty)

  //   if (
  //     orderList[existingIndex] &&
  //     orderList[existingIndex].current_stock < parsedQty
  //   ) {
  //     showModalWarning("This product is stockout!", item);
  //     return;
  //   }

  //   if (field === "qty") {
  //     if (existingIndex !== -1) {
  //       const updatedOrderList = [...orderList];
  //       if(item.selectedVariantId){
  //         if (parsedQty > item.selectedVariantQuantity) {
  //           showModalWarning("Product variant stock out");
  //           return;
  //         } else {
  //           updatedOrderList[existingIndex].qty = parsedQty;
  //         }
  //       }else{
  //           updatedOrderList[existingIndex].qty = parsedQty;
  //       }
  //       setOrderList(updatedOrderList);
  //     }
  //   }

  //   if (field === "price") {
  //     if (existingIndex !== -1) {
  //       const updatedOrderList = [...orderList];
  //       if (type === "billing") {
  //         updatedOrderList[existingIndex].price = parsedPrice;
  //         updatedOrderList[existingIndex].product_info.retails_price =
  //           parsedPrice;
  //         setOrderList(updatedOrderList);
  //       }
  //       updatedOrderList[existingIndex].price = parsedPrice;
  //       setOrderList(updatedOrderList);
  //     }
  //   }
  // };

  // added by saif for editing for user type 1 & 2

  const handleSelectedItemQty129 = (item, field, e) => {
    let qty = e.target.value;
    const modifiedQty = qty.split("x")[1];
    const parsedQty = parseInt(modifiedQty, 10);
    const parsedPrice = parseInt(e.target.value);

    const existingIndex = orderList.findIndex(
      (orderItem) => orderItem?.id === item.id
    );

    if (field === "qty") {
      if (existingIndex !== -1) {
        const updatedOrderList = [...orderList];
        if (item.selectedVariantId) {
          if (parsedQty > item.selectedVariantQuantity) {
            showModalWarning("Product variant stock out");
            return;
          } else {
            updatedOrderList[existingIndex].qty = parsedQty;
          }
        } else {
          updatedOrderList[existingIndex].qty = parsedQty;
        }

        // Update subtotal when quantity changes for user types 1 & 2
        if (type === "purchase" && (user?.type == "1" || user?.type == "2")) {
          const updatedItem = updatedOrderList[existingIndex];
          const newSubtotal = (updatedItem.price * updatedItem.qty).toFixed(2);
          setEditableSubtotals((prev) => ({
            ...prev,
            [item.id]: newSubtotal,
          }));
          setEditablePrices((prev) => ({ ...prev, [item.id]: undefined }));
        }

        setOrderList(updatedOrderList);
      }
    }

    if (field === "price") {
      if (existingIndex !== -1) {
        const updatedOrderList = [...orderList];
        if (type === "billing") {
          updatedOrderList[existingIndex].price = parsedPrice;
          if (updatedOrderList[existingIndex].product_info) {
            updatedOrderList[existingIndex].product_info.retails_price =
              parsedPrice;
          }
        }
        updatedOrderList[existingIndex].price = parsedPrice;
        setOrderList(updatedOrderList);
      }
    }
  };

  useEffect(() => {}, [type]);
  useEffect(() => {
    console.log("Orderlist....", orderList);
  }, [orderList]);

  const handleCloseModal = () => setIsShowModal(false);

  // useEffect(()=>{console.log("selectedFood", selectedFood);},[selectedFood])

  useEffect(() => {
    const newData = location.pathname.startsWith("/purchase-invoice/edit")
      ? invoiceData.purchase_details
      : invoiceData.sales_details;
    // console.log("newData ", newData);
    console.log("invoiceData..... ", invoiceData);
    const newDataList = [];
    newData?.map((item) => {
      // const newItem = filteredProducts.filter( (t)=>t.id== item.product_id );
      newDataList.push({ ...item, id: item.id, product_id: item.product_id});
      // newDataList.push(newItem)
    });

    // If sales_details is selected, also add exchange_purchase.purchase_details
    if (!location.pathname.startsWith("/purchase-invoice/edit") && invoiceData?.exchange_purchase?.purchase_details) {
      invoiceData.exchange_purchase.purchase_details.forEach((item) => {
        newDataList.push({ ...item, id: item.id, product_id: item.product_id , onExchange: true});
      });
    }

    // console.log("mapping Data", newDataList);
    console.log("newDataList.................. ", newDataList);
    const updatedDataList = newDataList.map((item) => {
      if (item.product_variant_id) {
        return {
          ...item,
          selectedVariantId: item.product_variant_id,
          selectedVariantQuantity: item.product_variant.quantity,
          have_product_variant: 1,
        };
      }
      return item;
    });
    console.log("newDataList.................. ", updatedDataList);
    setOrderList(updatedDataList);
  }, []);

  useEffect(() => {
    const uniqueMap = new Set();
    const warrantyData = [];

    orderList.forEach((item) => {
      if (item?.invoice_id) {
        invoiceData?.defaultwarranties?.map((item) => {
          if (!uniqueMap.has(item?.product_id)) {
            uniqueMap.add(item?.product_id);
            const newWarranty = invoiceData.defaultwarranties
              .filter((t) => t.warranty && t.product_id === item.product_id)
              .map((t) => t.warranty);
            if (newWarranty !== "null") {
              warrantyData.push({ id: item.product_id, warranty: newWarranty });
            }
          }
        });
      } else {
        const value = {
          id: item?.id,
          warranty: [
            {
              id: "",
              product_id: item?.id,
              warranty_id: "",
              warranties_count: item.warranties_count
                ? item.warranties_count
                : "",
              name: item.warrenty ? item.warrenty : "",
            },
          ],
        };

        //  if (newWarranty !== "null") {
        warrantyData.push(value);
        //  }
        if (
          selectedProductWarrantyList &&
          selectedProductWarrantyList?.length
        ) {
          const newWarrantyList = [...selectedProductWarrantyList, value];
          setSelectedProductWarrantyList(newWarrantyList);
        } else {
          setSelectedProductWarrantyList([value]);
        }
      }
    });

    setSelectedProductWarrantyList(warrantyData);
  }, [warrantyModal]);

  const [isMobile, setIsMobile] = useState(false);
  const MAX_MOBILE_SCREEN_WIDTH = 767;
  let subtotal = 0;
  // Calculate totals

  // useEffect(()=>{
  //   setDeliveryAmount(invoiceData.delivery_fee)
  // }, [type])

  useEffect(() => {
    if (orderList.length == 0) {
      setSubTotalNew(0);
      setGrandTotal(0);
      setGrandTotalDiscounted(0);
      setPaidAmount(0);
      setTotalMoreDiscount(invoiceData?.discount || 0);
      setMoreDiscount(invoiceData?.discount || 0);
      setDue(0);
      setMoney("");
      return;
    }
    // console.log("order List", invoiceData);/
    let discountTotal = 0;
    let subtotaln = 0;
    let exchangeAmount = 0;
    // console.log("orderList ", orderList);
    orderList?.forEach((orderFood) => {
      let discount = 0;
      if (
        type == "purchase" ||
        (type == "billing" && salesType == "wholesale" && (typeSaleEdit && !orderFood.onExchange))
      ) {
        discount = 0;
      } else {
        if (
          (orderFood?.product_info?.discount_type === "Percentage" ||
            orderFood?.product_info?.discount_type === "2") &&
          orderFood?.product_info?.discount
        ) {
          // Discount is specified under product_info
          discount = formatPrice(
            orderFood?.product_info.retails_price *
              (orderFood?.product_info.discount / 100)
          );
        } else if (
          (orderFood?.discount_type === "Percentage" ||
            orderFood?.discount_type === "2") &&
          orderFood?.discount
        ) {
          // Discount is specified under orderFood
          discount = formatPrice(
            orderFood?.retails_price * (orderFood?.discount / 100)
          );
        } else {
          // No discount found
          discount =
            orderFood?.product_info?.discount || orderFood?.discount || 0;
        }
      }
      let subtotalPrice = 0;
      if (type == "purchase" && !typePurchase && (typeSaleEdit && !orderFood.onExchange)) {
        subtotalPrice = formatPrice(
          orderFood.invoice_id
            ? orderFood.qty *
                (orderFood?.product_info.purchase_price - discount)
            : orderFood.qty * (orderFood?.purchase_price - discount)
        );
        subtotaln += Number(subtotalPrice);
      } else if (type == "purchase" && typePurchase && (typeSaleEdit && !orderFood.onExchange)) {
        subtotalPrice = formatPrice(
          orderFood.invoice_id
            ? orderFood.qty * (orderFood?.price - discount)
            : orderFood.qty * (orderFood?.purchase_price - discount)
        );
        subtotaln += Number(subtotalPrice);
      } else if (invoiceData.sales_type == "wholesale" && (typeSaleEdit && !orderFood.onExchange)) {
        // subtotalPrice = formatPrice(
        //   orderFood.qty *
        //     ((orderFood?.product_info?.wholesale_price ||
        //       orderFood?.wholesale_price) -
        //       discount)
        // );
        subtotalPrice = formatPrice(
          orderFood.qty *
            (orderFood?.product_info?.wholesale_price ||
              orderFood?.wholesale_price)
        );
        subtotaln += Number(subtotalPrice);
      } /* else if((typeSaleEdit && orderFood.onExchange)){
          console.log("Inside................ 1st (typeSaleEdit && !orderFood.onExchange)")
          subtotalPrice =  orderFood.onExchange
            ? orderFood.qty * orderFood.price * -1
            : orderFood.qty *
                  ((orderFood?.price || orderFood?.retails_price) -
                    discount)
          console.log("subtotalPrice... ",subtotalPrice)

          subtotal += Number(subtotalPrice);
          console.log("subtotal... ",subtotal)
      } */ else {
        // subtotalPrice = formatPrice(
        //   orderFood.qty *
        //     ((orderFood?.price ||
        //       orderFood?.price) -
        //       discount)
        // );

        subtotalPrice =
          user.type == 8
            ? formatPrice(orderFood.qty * orderFood?.price)
            : orderFood.onExchange
            ? orderFood.qty * orderFood.price * -1
            : orderFood.qty *
                  ((orderFood?.price || orderFood?.retails_price) -
                    discount)
        exchangeAmount = orderFood.onExchange ? orderFood.qty * orderFood.price * -1 : 0
        console.log("discount....................",Number(discount))
        console.log("orderFood?.retails_price....................",Number(orderFood?.retails_price))
        console.log("orderFood?.price....................",Number(orderFood?.price))
        console.log("SUBTOTAL....................",Number(subtotalPrice))
        subtotaln += Number(subtotalPrice);
      }
      //discountTotal += formatPrice(orderFood.current_stock * discount);
    });
    // console.log("billing", type, salesType);

    setSubTotalNew(subtotaln);
    const vats = vat && vat > 0 ? (vat / 100) * subtotaln : 0;
    const taxes = tax && tax > 0 ? (tax / 100) * subtotaln : 0;
    const grandTotalnew = formatPrice(subtotaln + Number(vats) + Number(taxes) - exchangeAmount);
    setGrandTotal(grandTotalnew);
    setGrandTotalDiscounted(
      formatPrice(
        Number(grandTotalnew) + Number(deliveryAmount) - Number(initialDiscount)
      )
    );

    // setPaidAmount(formatPrice(paidAmount));
    setDue(
      Number(grandTotalnew) +
        Number(deliveryAmount) -
        Number(paidAmount) -
        Number(initialDiscount)
    );
    console.log("IsPriceChanged ", isPriceChanged);
  }, [orderList, initialDiscount, deliveryAmount]);

  // console.log("paid amount", paidAmount);

  useEffect(() => {
    setPaidAmount(paidAmount);
    setDue(Number(grandTotalAfterDiscount) - paidAmount);
  }, [paidAmount]);

  const notify = (msg, type) => {
    if (type == "success") {
      toast.success(msg, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        // transition: Bounce,
      });
    }
    if (type == "error") {
      toast.error(msg, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        // transition: Bounce,
      });
    }
  };

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      document.documentElement.clientWidth <= MAX_MOBILE_SCREEN_WIDTH
    ) {
      setIsMobile(true);
    }

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);

  const handleResize = () => {
    if (
      typeof window !== "undefined" &&
      document.documentElement.clientWidth <= MAX_MOBILE_SCREEN_WIDTH
    ) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  const handleChangePaidAmount = (value) => {
    //if value is number then set the value
    if (!isNaN(value)) {
      // if (value <= Number(grandTotalAfterDiscount)) {
      // console.log(value);
      if (value[0] == "0") {
        value = String(value).slice(1, value.length);
        setPaidAmount(value);
      } else {
        if (value > Number(grandTotalAfterDiscount)) {
          return;
        } else {
          setPaidAmount(value);
        }
      }
      setDue(Number(grandTotalAfterDiscount) - value);
      // }
      // else {
      //   return;
      // }
    } else {
      return;
    }
  };
  // useEffect(()=>{
  //   handleChangePaidAmount(paidAmount)
  // },[paidAmount])

  const handleChangeDiscount = (value) => {
    // if not integer then return
    if (isNaN(value)) {
      setMoreDiscount();
      setInitialDiscount();
      return;
    }
    if (selectedDiscountType === "Percentage" || selectedDiscountType === "2") {
      // Check if the discount percentage is 100%
      if (value > 100) {
        // Set the discount equal to the grand total
        setTotalMoreDiscount(0);
        setMoreDiscount(0);
        setInitialDiscount(0);
      } else {
        // Apply other percentage discount
        setTotalMoreDiscount(formatPrice(Number(grandTotal) * (value / 100)));
        setMoreDiscount(value);
        setInitialDiscount(value);
      }
    } else {
      // If discount type is not percentage, set the discount directly
      //but discount should not be more than grand total
      if (value > Number(grandTotal)) {
        setTotalMoreDiscount(0);
        setMoreDiscount(0);
        setInitialDiscount(0);
      } else {
        setTotalMoreDiscount(value);
        setMoreDiscount(value);
        setInitialDiscount(value);
      }
    }
  };

  const handleChangeDiscountType = (e) => {
    const { name, value } = e.target;
    setSelectedDiscountType(value);
  };
  const [loading, setLoading] = useState(false);
  const loadingCallback = (loading) => {
    setLoading(loading);
  };
  const navigate = useNavigate();

  const [money, setMoney] = useState(invoiceData?.pay_mode);

  let vats = 0;
  let taxes = 0;
  let discountTotal = 0;
  //let grandTotal = 0;
  const discountType = ["Fixed", "Percentage"];
  const token = localStorage.getItem("token");

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedValue, setSelectedValue] = useState("A4");
  const [firstTime, setfirstTime] = useState(true);
  const [isPending, startTransition] = useTransition();
  const perPage = 10;

  const [prevSearchKeyword, setPrevSearchKeyword] = useState("");

  const getTopSaleProductlist = (page, searchKeyword = null) => {
    if (searchKeyword) {
      getFilteredProductlist(page);
    } else {
      // if (firstTime) {
      //   setLoader(true);
      //   //loadingCallback(true);
      //   setfirstTime(false);
      // }
      axios
        .get(
          `${process.env.REACT_APP_API_URL}top-sales?page=${page}&limit=${perPage}`,
          {
            headers: {
              authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          setLoader(false);
          if (response.data.success) {
            loadingCallback(false);
            setFilterItem(response.data.data.data);
            setFilteredProducts(response.data.data.data);
            setPagination(response.data.data);
            setSelectedFood(response.data.data.data[0]);
            if (response.data.data.data[0]?.image_path) {
              setSelectedFoodImg(response.data.data.data[0].image_path);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          loadingCallback(false);
          if (error?.response?.status === 401) {
            localStorage.clear();
            localStorage.setItem("token", false);
            // Clear session and local storage
            localStorage.setItem("isPinVerify", false);

            navigate("/login");
          }
        });
    }
  };
  useEffect(() => {
    // // Check if the search keyword has changed
    // const isSearchKeywordChanged = searchKeyword !== prevSearchKeyword;

    // // Update the previous search keyword
    // setPrevSearchKeyword(searchKeyword);

    // // If it's a new search keyword, set the page to 1
    // if (isSearchKeywordChanged) {
    //   setCurrentPage(1);
    //   setfirstTime(true);
    // } else {
    //   // It's the same search keyword, proceed with your logic
    //   if (firstTime) {
    //     setfirstTime(false);
    //   }
    getTopSaleProductlist(currentPage, searchKeyword);
    // }
  }, [currentPage, searchKeyword]);

  // useEffect(() => {
  //   // getProductData();
  //   const updateProduct = filterItem?.filter((curElement) => {
  //     return curElement?.category_id === category;
  //   });
  //   //setFilteredProducts(updateProduct);
  // }, [category, filterItem]);
  const [selectedPaymentAccountList, setSelectedPaymentAccountList] = useState(
    invoiceData?.multiple_payment
  );
  const [filteredAccountList, setFilteredAccountList] = useState({});

  const getPayment = () => {
    loadingCallback(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}payment-type-list`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setPaymentList(response.data.data.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        console.log(error);
      });
  };

  useEffect(() => {
    getPayment();
    getPaymentAccountList();
    getWarranty();
    getDelivery();
    getDeliveryAccountList();
  }, []);

  useEffect(() => {
    getWarranty();
  }, []);

  const getPaymentAccountList = () => {
    const token = localStorage.getItem("token");
    loadingCallback(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}payment-type-category-list`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setPaymentAccountList(response.data.data.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        console.log(error);
      });
  };

  const handleSelectChange = (event) => {
    setChange(true);
    setSelectedValue(event.target.value);
    setPaperSize(event.target.value);
  };

  const getFilteredProductlist = (page) => {
    loadingCallback(true);
    const token = localStorage.getItem("token");

    axios
      .post(
        `${process.env.REACT_APP_API_URL}search-product?page=${page}&limit=${perPage}`,
        { keyword: searchKeyword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        loadingCallback(false);
        console.log(response.data.data.data)
        if (response.status === 200) {
          //setCategoryData(response.data.data.data);
          setFilterItem(response.data.data.data);
          setFilteredProducts(response.data.data.data);
          setPagination(response.data.data);
          setSelectedFood(response.data.data.data[0]);
          if (response.data.data.data[0]?.image_path) {
            setSelectedFoodImg(response.data.data.data[0].image_path);
          }
        } else {
          console.log("Data Not Found!");
        }
      })
      .catch((error) => {
        loadingCallback(false);
        console.log(error);
        if (error?.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          // Clear session and local storage
          localStorage.setItem("isPinVerify", false);

          navigate("/login");
        }
      });
  };

  const showModalWarning = (msg, data = null) => {
    Swal.fire({
      title: msg,
      text: "",
      icon: "warning",
    });
  };

  // const handleSelectedFood = (item, order = "increment") => {
  //   if (item?.product_type != 'service' && type != "purchase" && item.current_stock == 0) {
  //     showModalWarning("This product is stockout!", item);
  //     return;
  //   }

  //   const existingIndex = orderList.findIndex(
  //     (orderItem) => orderItem?.id === item?.id
  //   );
  //   if (order == "decrement") {
  //     // Item already exists, update its current_stock
  //     const updatedOrderList = [...orderList];
  //     if (updatedOrderList[existingIndex].qty == 1) {
  //       handleDelete(existingIndex);
  //     } else {
  //       updatedOrderList[existingIndex].qty -= 1;
  //       setOrderList(updatedOrderList);
  //     }
  //   } else {
  //     //const current_stock = item.current_stock;
  //     if (existingIndex !== -1) {
  //       // Item already exists, update its current_stock
  //       const updatedOrderList = [...orderList];

  //       if (
  //         item?.product_type != 'service' &&
  //         type != "purchase" &&
  //         item.current_stock < updatedOrderList[existingIndex].qty + 1
  //       ) {
  //         showModalWarning("This product is stockout!", item);
  //         return;
  //       } else {
  //         updatedOrderList[existingIndex].qty += 1;
  //         setOrderList(updatedOrderList);
  //       }
  //     } else {
  //       item.qty = 1;
  //       // Item doesn't exist, add it to the orderList with current_stock 1
  //       let newOrderArr = [...orderList, item];
  //       setOrderList(newOrderArr);

  //       const value = {
  //         id: item?.id,
  //         warranty: [
  //           {
  //             id: "",
  //             product_id: item?.id,
  //             warranty_id: "",
  //             warranties_count: item.warranties_count,
  //             name: item.warrenty,
  //           },
  //         ],
  //       };

  //       // setSelectedProductWarrantyList([...selectedProductWarrantyList, value])
  //       if (selectedProductWarrantyList && selectedProductWarrantyList.length) {
  //         const newWarrantyList = [...selectedProductWarrantyList, value];
  //         setSelectedProductWarrantyList(newWarrantyList);
  //       } else {
  //         setSelectedProductWarrantyList([value]);
  //       }
  //     }
  //     //item.current_stock -= 1;
  //     if(item?.product_info){
  //       const indexItem = filteredProducts.findIndex((t)=> t.id == item.id);
  //       const newItem = {...filteredProducts[indexItem]}
  //       setSelectedFood(newItem);
  //       console.log("newFoodItem", newItem);
  //       if (newItem?.image_path) {
  //         setSelectedFoodImg(newItem.image_path);
  //       }
  //     }
  //     else {
  //       setSelectedFood(item);
  //       if (item?.image_path) {
  //         setSelectedFoodImg(item.image_path);
  //       }
  //     }
  //   }
  // };

  // added by mushfique
  // const handleSelectedFood = (item, order = "increment") => {
  //   if (
  //     item?.product_type != "service" &&
  //     type != "purchase" &&
  //     item.current_stock == 0
  //   ) {
  //     showModalWarning("This product is stockout!", item);
  //     return;
  //   }

  //   const existingIndex = orderList.findIndex(
  //     (orderItem) => orderItem?.id === item?.id
  //   );
  //   if (order == "decrement") {
  //     // Item already exists, update its current_stock

  //     // late edit for specific user
  //     const updatedOrderList = [...orderList];
  //     // if (updatedOrderList[existingIndex].qty == 1) {
  //     //   handleDelete(existingIndex);
  //     // } else {
  //     //   updatedOrderList[existingIndex].qty -= 1;
  //     //   setOrderList(updatedOrderList);
  //     // }

  //     if (updatedOrderList[existingIndex].qty == 1) {
  //       handleDelete(existingIndex);
  //     } else {
  //       updatedOrderList[existingIndex].qty -= 1;
  //       setOrderList(updatedOrderList);
  //     }
  //   } else {
  //     //const current_stock = item.current_stock;
  //     if (existingIndex !== -1) {
  //       // Item already exists, update its current_stock
  //       const updatedOrderList = [...orderList];

  //       // if (
  //       //   item?.product_type != 'service' &&
  //       //   type != "purchase" &&
  //       //   item.current_stock < updatedOrderList[existingIndex].qty + 1
  //       // ) {
  //       //   showModalWarning("This product is stockout!", item);
  //       //   return;
  //       // } else {
  //       //   updatedOrderList[existingIndex].qty += 1;
  //       //   setOrderList(updatedOrderList);
  //       // }

  //       if (
  //         item?.product_type != "service" &&
  //         type != "purchase" &&
  //         item.current_stock < updatedOrderList[existingIndex].qty + 1
  //       ) {
  //         showModalWarning("This product is stockout!", item);
  //         return;
  //       } else {
  //         updatedOrderList[existingIndex].qty += 1;
  //         setOrderList(updatedOrderList);
  //       }
  //     } else {
  //       item.qty = 1;
  //       // Item doesn't exist, add it to the orderList with current_stock 1
  //       let newOrderArr = [...orderList, item];
  //       setOrderList(newOrderArr);

  //       const value = {
  //         id: item?.id,
  //         warranty: [
  //           {
  //             id: "",
  //             product_id: item?.id,
  //             warranty_id: "",
  //             warranties_count: item.warranties_count,
  //             name: item.warrenty,
  //           },
  //         ],
  //       };

  //       // setSelectedProductWarrantyList([...selectedProductWarrantyList, value])
  //       if (selectedProductWarrantyList && selectedProductWarrantyList.length) {
  //         const newWarrantyList = [...selectedProductWarrantyList, value];
  //         setSelectedProductWarrantyList(newWarrantyList);
  //       } else {
  //         setSelectedProductWarrantyList([value]);
  //       }
  //     }
  //     //item.current_stock -= 1;
  //     if (item?.product_info) {
  //       const indexItem = filteredProducts.findIndex((t) => t.id == item.id);
  //       const newItem = { ...filteredProducts[indexItem] };
  //       setSelectedFood(newItem);
  //       console.log("newFoodItem", newItem);
  //       if (newItem?.image_path) {
  //         setSelectedFoodImg(newItem.image_path);
  //       }
  //     } else {
  //       setSelectedFood(item);
  //       if (item?.image_path) {
  //         setSelectedFoodImg(item.image_path);
  //       }
  //     }
  //   }
  // };

  const handleSelectedFood = (item, order = "increment", button = null) => {
    console.log("Item in handle selected food......... ", item);
    if (
      type != "purchase" &&
      item.have_product_variant === 1 &&
      !item.selectedVariantId
    ) {
      return;
    }
    const isVariantAlreadyInOrderList = orderList.some(
      (orderItem) => orderItem.selectedVariantId === item.selectedVariantId
    );
    console.log(
      " isVariantAlreadyInOrderList in handleSelectedFood ",
      isVariantAlreadyInOrderList
    );
    console.log(" orderList in handleSelectedFood ", orderList);
    if (
      item?.product_type != "service" &&
      type != "purchase" &&
      item.current_stock == 0
    ) {
      showModalWarning("This product is stockout!", item);
      return;
    }

    // const existingIndex = orderList.findIndex(
    //   (orderItem) => orderItem?.id === item?.id
    // );

    const existingIndex = orderList.findIndex((orderItem) => {
      if (orderItem?.id !== item?.id) return false;

      // If product has variant, check variant ID too
      if (orderItem?.have_product_variant == 1) {
        return orderItem?.selectedVariantId === item?.selectedVariantId;
      }

      // No variant, ID match is enough
      return true;
    });

    // console.log(item);
    // console.log(orderList);

    // return

    if (order == "decrement") {
      // Item already exists, update its current_stock

      // late edit for specific user
      const updatedOrderList = [...orderList];
      // console.log(updatedOrderList);
      // return
      // if (updatedOrderList[existingIndex].qty == 1) {
      //   handleDelete(existingIndex);
      // } else {
      //   updatedOrderList[existingIndex].qty -= 1;
      //   setOrderList(updatedOrderList);
      // }

      if (updatedOrderList[existingIndex].qty == 1) {
        handleDelete(existingIndex);
      } else if (item.have_product_variant == 1 && order === "decrement") {
        console.log(
          "ITEM EXIST Decrement AND PRODUCT VARIANT......................"
        );
        const updatedOrderList = [...orderList];
        const parseQty = parseFloat(updatedOrderList[existingIndex]?.qty);
        updatedOrderList[existingIndex].qty = parseQty - 1;
        setOrderList(updatedOrderList);
      } else {
        updatedOrderList[existingIndex].qty -= 1;
        setOrderList(updatedOrderList);
      }
    } else {
      //const current_stock = item.current_stock;
      if (parseFloat(existingIndex) !== -1) {
        // Item already exists, update its current_stock
        const updatedOrderList = [...orderList];
        console.log(
          "Reached ....Inside increament,.....",
          isVariantAlreadyInOrderList,
          (item?.product_info?.have_product_variant ??
            item?.have_product_variant) == 1,
          type != "purchase"
        );
        // return

        // if (
        //   item?.product_type != 'service' &&
        //   type != "purchase" &&
        //   item.current_stock < updatedOrderList[existingIndex].qty + 1
        // ) {
        //   showModalWarning("This product is stockout!", item);
        //   return;
        // } else {
        //   updatedOrderList[existingIndex].qty += 1;
        //   setOrderList(updatedOrderList);
        // }

        if (
          item?.product_type != "service" &&
          type != "purchase" &&
          item.current_stock < updatedOrderList[existingIndex].qty + 1
        ) {
          showModalWarning("This product is stockout!", item);
          return;
        } else if (
          item?.product_info?.have_variant == 1 &&
          button === "increment" &&
          type === "purchase"
        ) {
          item.qty = 1;
          // Item doesn't exist, add it to the orderList with current_stock 1
          const initialVariationData = Array.from(
            { length: Number.parseInt(1) },
            () => ({
              ...variationForm,
              product_id: item.product_id,
              purchase_price: item.purchase_price,
              wholesale_price: item.wholesale_price,
              retails_price: item.retails_price,
            })
          );
          item.variants = initialVariationData;
          item.variantsSum = 0;
          let newOrderArr = [...orderList, item];
          setOrderList(newOrderArr);
        } else if (
          (item?.product_info?.have_product_variant ??
            item?.have_product_variant) == 1 &&
          button === "increment" &&
          type === "purchase"
        ) {
          console.log("ITEM EXIST AND PRODUCT VARIANT......................");
          const updatedOrderList = [...orderList];
          const parseQty = parseFloat(updatedOrderList[existingIndex]?.qty);
          updatedOrderList[existingIndex].qty = parseQty + 1;
          setOrderList(updatedOrderList);
        } else if (
          (item?.product_info?.have_product_variant ??
            item?.have_product_variant) == 1 &&
          isVariantAlreadyInOrderList &&
          type != "purchase"
        ) {
          console.log(
            "ITEM EXIST AND PRODUCT VARIANT FOR SALE INCREASE......................"
          );
          console.log("Reached ....Inside increament Sale,.....");
          const updatedOrderList = [...orderList];
          console.log(
            " updatedOrderList[existingIndex] ... ",
            updatedOrderList[existingIndex],
            "existingIndex ... ",
            existingIndex
          );
          const parseQty = parseFloat(updatedOrderList[existingIndex]?.qty);
          console.log("Reached ....edit vairant,.....");
          console.log("item.selectedVariantId,.... ", item.selectedVariantId);
          console.log(
            "item.selectedVariantQuantity... ",
            item.selectedVariantQuantity
          );

          if (item.selectedVariantId) {
            console.log(
              "inside...item.selectedVariantId check... ",
              parseQty >=
                (item.selectedVariantQuantity ?? item.product_variant.quantity)
            );
            console.log(
              "inside...item.selectedVariantId check... item.product_variant.quantity ",
              item.product_variant.quantity
            );
            console.log(
              "inside...item.selectedVariantId check... item.selectedVariantQuantity ",
              item.selectedVariantQuantity
            );
            if (
              parseQty >=
              (item.selectedVariantQuantity ?? item.product_variant.quantity)
            ) {
              showModalWarning("Product variant stock out");
              return;
            } else {
              updatedOrderList[existingIndex].qty = parseQty + 1;
            }
          } else {
            updatedOrderList[existingIndex].qty = parseQty + 1;
          }
          setOrderList(updatedOrderList);
        } else if (
          (typeEcommerce || typeSaleEdit) &&
          (item?.product_info?.have_product_variant ??
            item?.have_product_variant) == 1 &&
          isVariantAlreadyInOrderList == false
        ) {
          // console.log("I am here");
          item.qty = 1;
          // Item doesn't exist, add it to the orderList with current_stock 1
          console.log("Item DOESNT EXISTS...... ");
          console.log("Item... ", item);
          const newItem = {
            id: item.id,
            sales_id: null,
            invoice_id: null,
            product_id: item.product_id,
            qty: item.qty,
            have_product_variant: item?.have_product_variant,
            //           price: item.retails_price.toString(),
            //           // For purchase type, use purchase_price in both price and purchase_price fields
            // // price: type === "purchase" ? item.purchase_price.toString() : item.retails_price.toString(),
            //           purchase_price: item.purchase_price.toFixed(2),

            // CRITICAL: For purchase type, ensure price matches purchase_price
            price:
              type === "purchase"
                ? item.purchase_price.toString()
                : item.retails_price.toString(),
            purchase_price:
              type === "purchase"
                ? item.purchase_price.toFixed(2)
                : item.purchase_price.toFixed(2),
            // CRITICAL: Set retails_price properly for new items
            retails_price: item.retails_price
              ? item.retails_price.toFixed(2)
              : "0.00",
            mode: null,
            size: null,
            product_variant: {
              id: item?.selectedVariantId,
              name: item?.selectedVariantName,
              price: item?.selectedVariantPrice,
              product_id: item?.product_id,
              quantity: item?.selectedVariantQuantity,
              user_id: item?.user_id,
            },
            product_variant_id: item.selectedVariantId,
            selectedVariantId: item.selectedVariantId,
            created_at: item.created_at,
            updated_at: item.updated_at,
            remaining_qty: item.qty,
            product_info: {
              id: item?.product_id,
              name: item?.name,
              barcode: item?.barcode,
              category_id: item?.category_id,
              others: item?.others,
              sub_category_id: item?.sub_category_id,
              brand_id: item?.brand_id,
              unit_id: item?.unit_id,
              currency_id: item?.currency_id,
              image_path: item?.image_path,
              image_path1: item?.image_path1,
              image_path2: item?.image_path2,
              image_path3: item?.image_path3,
              purchase_price: item?.purchase_price,
              wholesale_price: item?.wholesale_price,
              retails_price: item?.retails_price,
              regular_price: item?.regular_price,
              discount_type: item?.discount_type,
              discount: item?.discount,
              description: item?.description,
              warrenty: item?.warrenty,
              quantity: item?.quantity,
              discount_id: item?.discount_id,
              warranty_id: item?.warranty_id,
              deleted: item?.deleted,
              user_id: item?.user_id,
              created_at: item?.created_at,
              updated_at: item?.updated_at,
              product_id: item?.product_id,
              have_variant: item?.have_variant,
              have_product_variant: item?.have_product_variant,
              serial: item?.serial,
              color: item?.color,
              warranties_count: item?.warranties_count,
              manufactory_date: item?.manufactory_date,
              expiry_date: item?.expiry_date,
              is_variable_weight: item?.is_variable_weight,
              minimum_stock: item?.minimum_stock,
              product_type: item?.product_type,
              is_ecommerce: item?.is_ecommerce,
              color_code: item?.color_code,
              is_specification: item?.is_specification,
              brands: {
                id: item?.brands?.id,
                name: item?.brands?.name,
                description: item?.brands?.description,
                image_path: item?.brands?.image_path,
                is_topbrand: item?.brands?.is_topbrand,
                user_id: item?.brands?.user_id,
                created_at: item?.brands?.created_at,
                updated_at: item?.brands?.updated_at,
              },
              category: {
                id: item?.category?.id,
                name: item?.category?.name,
                description: item?.category?.description,
                user_id: item?.category?.user_id,
                created_at: item?.category?.created_at,
                updated_at: item?.category?.updated_at,
              },
              unit: {
                id: item?.unit?.id,
                name: item?.unit?.name,
                description: item?.unit?.description,
                user_id: item?.unit?.user_id,
                created_at: item?.unit?.created_at,
                updated_at: item?.unit?.updated_at,
              },
            },
            product_imei: item.imeis || [],
            isNew: 1
          };
          let newOrderArr = [...orderList, newItem];
          // console.log(newOrderArr);
          if (item.selectedVariantId) {
            setProductVariantIndex(null);
          }
          setOrderList(newOrderArr);
          // return

          const value = {
            id: item?.id,
            warranty: [
              {
                id: "",
                product_id: item?.id,
                warranty_id: "",
                warranties_count: item.warranties_count,
                name: item.warrenty,
              },
            ],
          };

          // setSelectedProductWarrantyList([...selectedProductWarrantyList, value])
          if (
            selectedProductWarrantyList &&
            selectedProductWarrantyList.length
          ) {
            const newWarrantyList = [...selectedProductWarrantyList, value];
            setSelectedProductWarrantyList(newWarrantyList);
          } else {
            setSelectedProductWarrantyList([value]);
          }
        } else {
          updatedOrderList[existingIndex].qty += 1;
          setOrderList(updatedOrderList);
        }
      } else {
        // console.log("I am here");
        item.qty = 1;
        // Item doesn't exist, add it to the orderList with current_stock 1
        console.log("Item DOESNT EXISTS...... ");
        console.log("Item... ", item);
        const newItem = {
          id: item.id,
          sales_id: null,
          invoice_id: null,
          product_id: item.product_id,
          have_product_variant: item?.have_product_variant,
          qty: item.qty,
          price: item.retails_price.toString(),
          purchase_price: item.purchase_price.toFixed(2),
          mode: null,
          size: null,
          created_at: item.created_at,
          updated_at: item.updated_at,
          remaining_qty: item.qty,
          product_variant:
            item.have_product_variant == 1
              ? {
                  id: item?.selectedVariantId,
                  name: item?.selectedVariantName,
                  price: item?.selectedVariantPrice,
                  product_id: item?.id,
                  quantity: item?.selectedVariantQuantity,
                  user_id: item?.user_id,
                }
              : null,

          product_variant_id:
            item.have_product_variant == 1 ? item?.selectedVariantId : null,
          selectedVariantId:
            item.have_product_variant == 1 ? item?.selectedVariantId : null,
          selectedVariantQuantity:
            item.have_product_variant == 1
              ? item?.selectedVariantQuantity
              : null,
          product_info: {
            id: item?.product_id,
            name: item?.name,
            barcode: item?.barcode,
            category_id: item?.category_id,
            others: item?.others,
            sub_category_id: item?.sub_category_id,
            brand_id: item?.brand_id,
            unit_id: item?.unit_id,
            currency_id: item?.currency_id,
            image_path: item?.image_path,
            image_path1: item?.image_path1,
            image_path2: item?.image_path2,
            image_path3: item?.image_path3,
            purchase_price: item?.purchase_price,
            wholesale_price: item?.wholesale_price,
            retails_price: item?.retails_price,
            regular_price: item?.regular_price,
            discount_type: item?.discount_type,
            discount: item?.discount,
            description: item?.description,
            warrenty: item?.warrenty,
            quantity: item?.quantity,
            discount_id: item?.discount_id,
            warranty_id: item?.warranty_id,
            deleted: item?.deleted,
            user_id: item?.user_id,
            created_at: item?.created_at,
            updated_at: item?.updated_at,
            product_id: item?.product_id,
            have_variant: item?.have_variant,
            have_product_variant: item?.have_product_variant,
            serial: item?.serial,
            color: item?.color,
            warranties_count: item?.warranties_count,
            manufactory_date: item?.manufactory_date,
            expiry_date: item?.expiry_date,
            is_variable_weight: item?.is_variable_weight,
            minimum_stock: item?.minimum_stock,
            product_type: item?.product_type,
            is_ecommerce: item?.is_ecommerce,
            color_code: item?.color_code,
            is_specification: item?.is_specification,
            brands: {
              id: item?.brands?.id,
              name: item?.brands?.name,
              description: item?.brands?.description,
              image_path: item?.brands?.image_path,
              is_topbrand: item?.brands?.is_topbrand,
              user_id: item?.brands?.user_id,
              created_at: item?.brands?.created_at,
              updated_at: item?.brands?.updated_at,
            },
            category: {
              id: item?.category?.id,
              name: item?.category?.name,
              description: item?.category?.description,
              user_id: item?.category?.user_id,
              created_at: item?.category?.created_at,
              updated_at: item?.category?.updated_at,
            },
            unit: {
              id: item?.unit?.id,
              name: item?.unit?.name,
              description: item?.unit?.description,
              user_id: item?.unit?.user_id,
              created_at: item?.unit?.created_at,
              updated_at: item?.unit?.updated_at,
            },
          },
          product_imei: item.imeis || [],
          isNew: 1
        };
        let newOrderArr = [...orderList, newItem];
        // console.log(newOrderArr);
        if (item.selectedVariantId) {
          setProductVariantIndex(0);
        }
        setOrderList(newOrderArr);
        // return

        const value = {
          id: item?.id,
          warranty: [
            {
              id: "",
              product_id: item?.id,
              warranty_id: "",
              warranties_count: item.warranties_count,
              name: item.warrenty,
            },
          ],
        };

        // setSelectedProductWarrantyList([...selectedProductWarrantyList, value])
        if (selectedProductWarrantyList && selectedProductWarrantyList.length) {
          const newWarrantyList = [...selectedProductWarrantyList, value];
          setSelectedProductWarrantyList(newWarrantyList);
        } else {
          setSelectedProductWarrantyList([value]);
        }
      }
      //item.current_stock -= 1;
      if (item?.product_info) {
        const indexItem = filteredProducts?.findIndex((t) => t.id == item.id);
        const newItem = { ...filteredProducts[indexItem] };
        setSelectedFood(newItem);
        // console.log("newFoodItem", newItem);
        if (newItem?.image_path) {
          setSelectedFoodImg(newItem.image_path);
        }
      } else {
        setSelectedFood(item);
        if (item?.image_path) {
          setSelectedFoodImg(item.image_path);
        }
      }
    }
  };

  // for imei selection

  const variationForm = {
    product_id: "",
    name: "",
    serial: "",
    note: "",
    purchase_price: 0,
    wholesale_price: 0,
    retails_price: 0,
    discount_type: 0,
    storage: "",
    ram: "",
    battery_life: "",
    region: "",
    image_path: "",
    product_condition: "",
    quantity: 1,
  };

  const handleSelectedFoodForImei = (newItem, order = "increment") => {
    // console.log("selected Product", item);
    const item = { ...newItem };

    const existingIndex = orderList.findIndex(
      (orderItem) => orderItem?.imei_id === item?.imei_id
    );
    // return

    // Need to start working from it ====================================
    // Need to start working from it ====================================
    // Need to start working from it ====================================

    if (order == "decrement") {
      // Item already exists, update its current_stock
      const updatedOrderList = [...orderList];
      const parseQty =
        user.type == 8
          ? parseFloat(updatedOrderList[existingIndex].product129Qty)
          : parseFloat(updatedOrderList[existingIndex])
          ? parseFloat(updatedOrderList[existingIndex]?.qty)
          : null;
      if (parseQty <= 1) {
        handleDelete(existingIndex);
      } else {
        const initialVariationData = Array.from(
          { length: Number.parseInt(parseQty - 1) },
          () => ({
            ...variationForm,
            product_id: item.id,
            purchase_price: item.purchase_price,
            wholesale_price: item.wholesale_price,
            retails_price: item.retails_price,
            storage: item.storage,
            note: item?.note,
            ram: item.ram,
            battery_life: item.battery_life,
            region: item?.region ? item?.region : "",
            image_path: item?.image_path ? item?.image_path : "",
            product_condition: item?.product_condition
              ? item?.product_condition
              : "",
          })
        );
        updatedOrderList[existingIndex].variantsSum = 0;
        updatedOrderList[existingIndex].variants = initialVariationData;
        updatedOrderList[existingIndex].qty = parseQty - 1;
        setOrderList(updatedOrderList);
      }
    } else {
      //const current_stock = item.current_stock;
      if (existingIndex !== -1) {
        // Item already exists, update its current_stock
        const updatedOrderList = [...orderList];
        const parseQty =
          user.type == 8
            ? parseFloat(updatedOrderList[existingIndex].product129Qty)
            : parseFloat(updatedOrderList[existingIndex])
            ? parseFloat(updatedOrderList[existingIndex]?.qty)
            : null;
        if (
          item?.product_type != "service" &&
          type != "purchase" &&
          item.stock_unit_no < parseQty + 1
        ) {
          showModalWarning("This product is stockout!", item);
          return;
        } else {
          const initialVariationData = Array.from(
            { length: Number.parseInt(parseQty + 1) },
            () => ({
              ...variationForm,
              product_id: item.id,
              have_variant: item.have_variant,
              purchase_price: item.purchase_price,
              wholesale_price: item.wholesale_price,
              retails_price: item.retails_price,
              storage: item.storage,
              note: item.note,
              ram: item.ram,
              battery_life: item.battery_life,
              region: item?.region ? item?.region : "",
              image_path: item?.image_path ? item?.image_path : "",
              product_condition: item?.product_condition
                ? item?.product_condition
                : "",
            })
          );
          updatedOrderList[existingIndex].variantsSum = 0;
          updatedOrderList[existingIndex].variants = initialVariationData;
          if (user.type == 8) {
            updatedOrderList[existingIndex].product129Qty = parseQty + 1;
            // console.log(updatedOrderList[existingIndex].product129Qty);
          } else {
            updatedOrderList[existingIndex].qty = parseQty + 1;
          }
          setOrderList(updatedOrderList);
        }
      } else {
        item.qty = 1;
        // Item doesn't exist, add it to the orderList with current_stock 1
        console.log("item in hndla imeifood ........ else ", item)
        const initialVariationData = Array.from(
          { length: Number.parseInt(1) },
          () => ({
            ...variationForm,
            product_id: item.id,
            purchase_price: item.purchase_price,
            wholesale_price: item.wholesale_price,
            retails_price: item.retails_price,
            have_variant: item.have_variant,
          })
        );
        item.variants = initialVariationData;
        item.variantsSum = 0;
        let newOrderArr = [...orderList, item];
        setOrderList(newOrderArr);

        const value = {
          id: item?.id,
          warranty: [
            {
              id: "",
              product_id: item?.id,
              warranty_id: "",
              warranties_count: item.warranties_count
                ? item.warranties_count
                : "",
              name: item.warrenty ? item.warrenty : "",
            },
          ],
        };

        if (
          selectedProductWarrantyList &&
          selectedProductWarrantyList?.length
        ) {
          const newWarrantyList = [...selectedProductWarrantyList, value];
          setSelectedProductWarrantyList(newWarrantyList);
        } else {
          setSelectedProductWarrantyList([value]);
        }
      }
      //item.current_stock -= 1;
      setSelectedFood(item);
      if (item?.image_path) {
        setSelectedFoodImg(item.image_path);
      }
    }
  };

  const handleImeisSelect = (imei, selectedFood) => {
    // console.log("imei: ", imei, " || ", "selectedFood: ", selectedFood )

    // console.log(imei.imei);
    // setBarcodeImei(imei.imei);
    const newItems = { ...selectedFood };

    // console.log(imei)

    // return
    newItems.checked = 1;

    // console.log("selectPrime", newItems, imei);
    //newItems.retails_price = imei.sale_price;

    // if(type === 'wholesale'){
    //   newItems.retails_price = imei?.currency_rate !== null
    //   ? Number.parseFloat(
    //     imei?.wholesale_price
    //   ).toFixed(2)
    //   : Number.parseFloat(
    //     imei?.wholesale_price
    //   ).toFixed(2);
    // newItems.currency_code = imei?.currency_rate !== null ? imei?.base_currency_code : imei.purchase_currency_code;
    // newItems.imei_id = imei.id;

    // const findImei = imeis.find(e => e.id === imei.id);
    // if (findImei) {
    //   handleSelectedFoodForImei(newItems, "decrement", 1);
    //   const newImeis = imeis.filter(e => e.id !== imei.id);
    //   // const transformArray =  newImeis.map( e=>({ id: e.id, product_id: e.product_id}))
    //   setImeis(newImeis)
    // }
    // else {
    //   handleSelectedFoodForImei(newItems, "increment", 1);
    //   setImeis(e => [...e, { id: imei.id, product_id: imei.product_id }]);
    // }
    // }
    newItems.retails_price =
      imei?.currency_rate !== null
        ? Number.parseFloat(imei?.sale_price).toFixed(2)
        : Number.parseFloat(imei?.sale_price).toFixed(2);
    newItems.currency_code =
      imei?.currency_rate !== null
        ? imei?.base_currency_code
        : imei.purchase_currency_code;
    //newItems.purchase_price = imei.purchase_price;

    newItems.purchase_price =
      imei?.currency_rate !== null
        ? Number.parseFloat(imei?.purchase_price).toFixed(2)
        : Number.parseFloat(imei?.purchase_price).toFixed(2);
    newItems.wholesale_price =
      imei?.currency_rate !== null
        ? Number.parseFloat(imei?.wholesale_price).toFixed(2)
        : Number.parseFloat(imei?.wholesale_price).toFixed(2);
    newItems.imei_id = imei.id;
    const findImei = imeis.find((e) => e.id === imei.id);
    if (findImei) {
      handleSelectedFoodForImei(newItems, "decrement", 1);
      const newImeis = imeis.filter((e) => e.id !== imei.id);
      // const transformArray =  newImeis.map( e=>({ id: e.id, product_id: e.product_id}))
      setImeis(newImeis);
    } else {
      handleSelectedFoodForImei(newItems, "increment", 1);
      setImeis((e) => [...e, { id: imei.id, product_id: imei.product_id }]);
    }
  };

  useEffect(() => {
    // console.log("imei list", imeis);
  }, [imeis]);

  // console.log(selectedFood);
  // Filter the IMEIs based on the search term
  const filteredImeis = selectedFood?.imeis?.filter((imei) =>
    imei?.imei?.includes(searchVarientItem)
  );

  const handleSelectedImeis = (item) => {
    // console.log(item);
    // console.log(item);
    setSelectedFood(item);
    if (item?.image_path) {
      setSelectedFoodImg(item.image_path);
    }
  };

  const toggleImeiSelection = (imei) => {
    const isSelected = selectedImeis.includes(imei.id);

    const updatedSelections = isSelected
      ? selectedImeis.filter((id) => id !== imei.id)
      : [...selectedImeis, imei.id];
    setSelectedImeis(updatedSelections);

    handleImeisSelect(imei, selectedFood); // You might need to update this logic if you handle selection differently
  };

  const [selectedFoodImg, setSelectedFoodImg] = useState(null);
  const handleSelectedFoodImage = (imgPath = "") => {
    setSelectedFoodImg(imgPath);
  };
  // const handleSelectedFoodQty = (item, e) => {
  //   const qty = e.target.value.startsWith("x")
  //     ? e.target.value.slice(1)
  //     : e.target.value;
  //   const parsedQty = parseInt(qty, 10);
  //   const existingIndex = orderList.findIndex(
  //     (orderItem) => orderItem?.id === item.id
  //   );
  //   if (qty && parsedQty && existingIndex !== -1 && !isNaN(parsedQty)) {
  //     const existingProductIndex = filteredProducts.filter(
  //       (filteredItem) => filteredItem?.id === item?.id
  //     );
  //     // Item already exists, update its current_stock
  //     const updatedOrderList = [...orderList];
  //     if (
  //       item?.product_type != "service" &&
  //       type != "purchase" &&
  //       existingProductIndex &&
  //       existingProductIndex[0] &&
  //       existingProductIndex[0].current_stock < parsedQty
  //     ) {
  //       showModalWarning("This product is stockout!", item);
  //       return;
  //     } else {
  //       updatedOrderList[existingIndex].qty = parsedQty;
  //       setOrderList(updatedOrderList);
  //     }
  //   } else {
  //     const updatedOrderList = [...orderList];
  //     updatedOrderList[existingIndex].qty = 0;
  //     setOrderList(updatedOrderList);
  //   }
  // };

  // added by saif for purchase price change

  const handleSelectedFoodQty = (item, e) => {
    const qty = e.target.value.startsWith("x")
      ? e.target.value.slice(1)
      : e.target.value;
    const parsedQty = parseInt(qty, 10);
    const existingIndex = orderList.findIndex(
      (orderItem) => orderItem?.id === item.id
    );

    if (qty && parsedQty && existingIndex !== -1 && !isNaN(parsedQty)) {
      const existingProductIndex = filteredProducts?.filter(
        (filteredItem) => filteredItem?.id === item?.id
      );

      // Item already exists, update its current_stock
      const updatedOrderList = [...orderList];

      if (
        item?.product_type != "service" &&
        type != "purchase" &&
        existingProductIndex &&
        existingProductIndex[0] &&
        existingProductIndex[0].current_stock < parsedQty
      ) {
        showModalWarning("This product is stockout!", item);
        return;
      } else {
        // Update the quantity first
        updatedOrderList[existingIndex].qty = parsedQty;

        // THEN update subtotal for user types 1 & 2 (MOVED HERE)
        if (type === "purchase" && (user?.type == "1" || user?.type == "2")) {
          const updatedItem = updatedOrderList[existingIndex];
          const currentPrice =
            updatedItem.price || updatedItem.purchase_price || 0;
          const newSubtotal = (currentPrice * parsedQty).toFixed(2);
          setEditableSubtotals((prev) => ({
            ...prev,
            [item.id]: newSubtotal,
          }));
          // Clear the price edit state to show updated calculated price
          setEditablePrices((prev) => ({ ...prev, [item.id]: undefined }));
        }

        setOrderList(updatedOrderList);
      }
    } else {
      const updatedOrderList = [...orderList];
      updatedOrderList[existingIndex].qty = 0;

      // Also update subtotal to 0 for user types 1 & 2
      if (type === "purchase" && (user?.type == "1" || user?.type == "2")) {
        setEditableSubtotals((prev) => ({
          ...prev,
          [item.id]: "0.00",
        }));
      }

      setOrderList(updatedOrderList);
    }
  };

  const handleSelectedFoodPrice = (item, price, idx) => {
    const newPriceStr = String(price);
    const existingIndex = orderList.findIndex(
      (orderItem) => orderItem?.id === item?.id
    );
    const existingProduct = orderList.findIndex(
      (orderItem) => orderItem?.product_id === item?.product_id
    );
    console.log("existingProduct ", existingProduct);
    console.log("existingIndex ", existingIndex);
    console.log("price ", price);
    console.log("paidAmount ", paidAmount);
    console.log("parseInt(price) ", parseInt(price));
    console.log(
      "parseInt(price) === paidAmount ",
      parseInt(price) === paidAmount
    );
    if (parseInt(price) == paidAmount) {
      setIsPriceChanged(false);
    } else {
      setIsPriceChanged(true);
    }
    // if(newPriceStr.slice(-1)=='.'){
    //   const updatedOrderList = [...orderList];
    //   updatedOrderList[existingIndex].purchase_price = newPriceStr;
    //   setOrderList(updatedOrderList);
    //   return;
    // }
    if (
      item?.product_imei &&
      item?.product_imei.length > 0 &&
      type !== "purchase" &&
      !typePurchase
    ) {
      const updatedOrderList = [...orderList];
      updatedOrderList[existingProduct].price = parseInt(price);
      updatedOrderList[existingProduct].product_imei[0].sale_price =
        parseInt(price);
      setOrderList(updatedOrderList);
      return;
    } else if (item?.imeis && item?.imeis.length > 0 && type !== "purchase") {
      const updatedOrderList = [...orderList];
      updatedOrderList[idx].retails_price = parseInt(price);
      setOrderList(updatedOrderList);
      return;
    } else if (type === "purchase" && !typePurchase) {
      const updatedOrderList = [...orderList];
      updatedOrderList[existingIndex].price = parseInt(price);
      updatedOrderList[existingIndex].product_info.purchase_price =
        parseInt(price);
      setOrderList(updatedOrderList);
    }

    const newPrice = parseFloat(newPriceStr) / parseInt(item.qty);
    if (price && newPrice && existingIndex !== -1 && !isNaN(newPrice)) {
      console.log("inside flag...", idx);
      console.log("newPrice...", newPrice);
      const updatedOrderList = [...orderList];
      console.log("updatedOrderList ", updatedOrderList);
      console.log("OrderList ", orderList);
      updatedOrderList[idx ?? existingIndex].purchase_price = newPrice;
      updatedOrderList[idx ?? existingIndex].price = newPrice;
      const imeiObj = updatedOrderList[idx ?? existingIndex]?.product_imei?.[0];

      // For billing, update the actual price that will be used in calculations
      if ((user?.type == "1" || user?.type == "2") && type === "billing") {
        updatedOrderList[existingIndex].price = newPrice;
        updatedOrderList[existingIndex].retails_price = newPrice;
        // Also update product_info if it exists
        if (updatedOrderList[existingIndex].product_info) {
          updatedOrderList[existingIndex].product_info.retails_price = newPrice;
        }
      }

      // For purchase type, update purchase_price field
      if ((user?.type == "1" || user?.type == "2") && type === "purchase") {
        updatedOrderList[existingIndex].purchase_price = newPrice;
        if (updatedOrderList[existingIndex].product_info) {
          updatedOrderList[existingIndex].product_info.purchase_price =
            newPrice;
        }
      }

      if (imeiObj) {
        imeiObj.purchase_price = newPrice;
      }
      console.log("updatedOrderList oafter Update ", updatedOrderList);
      setOrderList(updatedOrderList);
    } else {
      const updatedOrderList = [...orderList];
      updatedOrderList[existingIndex].purchase_price = 0;
      setOrderList(updatedOrderList);
    }

    const updateTotalPrice = orderList.reduce(
      (prev, curr) => (prev + curr?.price ? curr.price : curr?.retails_price),
      0
    );
    setGrandTotalDiscounted(updateTotalPrice);
  };

  const [paymentData, setPaymentData] = useState([]);

  const handleClicks = (e, data) => {
    e.preventDefault();
    if (!orderList.length) {
      showModalWarning("Please Select A product");
      return;
    }
    // else{
    setShowPaymentModal(!showPaymentModal);
    //setPaidAmount(0);
    let val = paymentList.find((items) => {
      return items?.type_name == data?.type_name;
    });
    setFilteredAccountList(val.payment_type_category);
    if (val) {
      setFormData({ ...formData, payment_id: data?.id });
      setMoney(data?.type_name);
    }
    if (showPaymentModal) {
      setPaymentData((prevPaymentData) => [...prevPaymentData, data]);

      // setSelectedPaymentAccountList([]);
    } else {
      setPaymentData([data]);
    }
    // }
  };

  const isExchange = orderList?.some(item => item.onExchange);

  const handlePurchesClicks = (active) => {
    if (active === "cash" || active === "card" || active === "qr") {
      return setMoney(active);
    }
  };

  const handleDelete = (index) => {
    // console.log(index);
    const newOrderList = [...orderList];
    newOrderList.splice(index, 1); // Remove the item from the copied array
    setOrderList(newOrderList);

    if (selectedProductWarrantyList && selectedProductWarrantyList.length) {
      // console.log("selected warranty", selectedProductWarrantyList);
      const newWarrantyList = [...selectedProductWarrantyList];
      newWarrantyList.splice(index, 1);
      setSelectedProductWarrantyList(newWarrantyList);
    }
  };
  //  const handleDelete=(index)=>{
  //   console.log(index)
  //   const newOrderList = [...orderList];
  //   newOrderList.splice(index, 1); // Remove the item from the copied array
  //   setOrderList(newOrderList);
  //  }

  // Calculate the number of products to show in the carousel
  const numberOfProducts = Math.min(filteredProducts?.length - 2, 5); // Set a maximum number of 7 products

  let settings = {};

  if (isMobile) {
    settings = {
      className: "sliderArea w-[300px]",
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1, // Adjust slidesToShow based on the number of products
      slidesToScroll: 1, // Adjust slidesToScroll as well
      variableWidth: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
  } else {
    settings = {
      //className: "sliderArea w-[920px]",
      className:
        "sliderArea md:max-w-[550px] lg:max-w-[600px] 2xl:max-w-[800px]",
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 3,
      variableWidth: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
  }

  // console.log(invoiceData);

  const [deliveryFormData, setDeliveryFormData] = useState({
    deliveryName: "",
    deliveryId: invoiceData.delivery_method_id,
    companyName: "",
    companyId: invoiceData.delivery_info_id ?? invoiceData.delivery_method_id,
    customerName: invoiceData.delivery_customer_name,
    customerAddress: invoiceData.delivery_customer_address,
    customerPhone: invoiceData.delivery_customer_phone,
    deliveryFee: invoiceData.delivery_fee,
    deliveryNote: invoiceData.delivery_note,
  });

  const [formData, setFormData] = useState({
    name: "",
    method_id: 0,
    account_id: 0,
    account_number: "",
    methodLabel: "",
    accountLabel: "",
  });

  // const [paymentMap, setPaymentMap] = useState([])
  const handleSubmitOrder = async (value) => {
    // console.log("value", value);
    // loadingCallback(true);
    if (change === false) {
      setSelectedValue("A4");
      setPaperSize("A4");
    }

    // const transformedProductArray = orderList.map((item) => ({
    //   product_id: item?.id,
    //   qty: item.qty,
    //   price:
    //     type === "purchase"
    //       ? item?.product_info &&
    //         (item?.product_info.discount_type === "Percentage" ||
    //           item?.product_info.discount_type === "2")
    //         ? item?.product_info.purchase_price
    //         : item?.product_info
    //         ? item?.product_info.purchase_price
    //         : item?.purchase_price
    //       : item?.product_info &&
    //         (item?.product_info?.discount_type === "Percentage" ||
    //           item?.product_info?.discount_type === "2")
    //       ? item?.price -
    //         item?.price * (item?.product_info?.discount / 100)
    //       : item?.product_info
    //       ? item?.price - item?.product_info?.discount
    //       : item?.discount_type === "Percentage" || item?.discount_type === "2"
    //       ? item?.retails_price - item?.retails_price * (item?.discount / 100)
    //       : item?.retails_price - item?.discount,

    //   mode: 1,
    //   size: 1,
    //   sales_id: 1,
    // }));

    // orderList.map((item)=> {
    //   console.log(item);
    // })
    console.log("orderList ", orderList);

    const isExchange = orderList?.some(item => item.onExchange);

    console.log("before isExchange");

    if(isExchange) {

      const transformedProductArray = orderList.filter(item => !item?.onExchange).map((item, index) => ({
        product_id: item?.product_id,
        qty: item.qty,
        have_variant: item?.product_info?.have_variant,
        product_variant_id: item?.selectedVariantId
          ? item?.selectedVariantId
          : null,
        price:
          type === "purchase" && !typePurchase
            ? item?.invoice_id &&
              (item?.product_info.discount_type === "Percentage" ||
                item?.product_info.discount_type === "2")
              ? item?.product_info.purchase_price
              : item?.invoice_id
              ? item?.product_info.purchase_price || item?.purchase_price
              : item?.purchase_price || item?.price
            : type === "purchase" && typePurchase
            ? item?.invoice_id &&
              (item?.product_info.discount_type === "Percentage" ||
                item?.product_info.discount_type === "2")
              ? item?.product_info.purchase_price
              : item?.invoice_id
              ? item?.price ||
                item?.product_info?.purchase_price ||
                item?.purchase_price
              : item?.purchase_price || item?.price
            : item?.product_info &&
              (item?.product_info?.discount_type === "Percentage" ||
                item?.product_info?.discount_type === "2")
            ? item?.price - item?.price * (item?.product_info?.discount / 100)
            : item?.product_info
            ? item?.price - item?.product_info?.discount
            : item?.discount_type === "Percentage" || item?.discount_type === "2"
            ? user.type == 8
              ? item?.price - item?.price * (item?.discount / 100)
              : item?.retails_price - item?.retails_price * (item?.discount / 100)
            : user.type == 8
            ? item?.price - item?.discount
            : item?.retails_price - item?.discount,
        retails_price:
          type === "purchase"
            ? item?.retails_price || item?.product_info?.retails_price || 0
            : item?.retails_price || 0,
        mode: 1,
        size: 1,
        sales_id: item.sales_id,
        // imei_id: item?.product_imei
        //   ? item.product_imei[0]?.id
        //   : item?.imei_id
        //   ? item?.imei_id
        //   : '',
        imei_id: item?.product_imei?.length && item?.invoice_id
          ? item.product_imei[0]?.id || ""
          : item?.imei_id || "",
        imei: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.imei
              ? item?.variants[index]?.product_imei[0]?.imei
              : item?.variants[index]?.product_imei[0]?.serial
            : item?.imeis
            ? item.imeis.filter((fitem) => fitem.imei_id === item.imei_id)[0]
                ?.imei
            : ""
          : "",

        // purchase_price: item?.variants
        //   ? item.variants[index]?.product_imei
        //     ? item?.variants[index]?.product_imei[0]?.purchase_price
        //     : ""
        //   : invoiceData.sales_details[index]?.purchase_price
        //   ? invoiceData.sales_details[index]?.purchase_price
        //   : "",

        purchase_price:
          type === "purchase"
            ? item?.variants
              ? item.variants[index]?.product_imei
                ? item?.variants[index]?.product_imei[0]?.purchase_price
                : item?.purchase_price ||
                  item?.product_info?.purchase_price ||
                  item?.price
              : item?.purchase_price ||
                item?.product_info?.purchase_price ||
                item?.price
            : invoiceData.sales_details && invoiceData.sales_details[index]
            ? invoiceData.sales_details[index]?.purchase_price
            : item?.purchase_price || item?.product_info?.purchase_price || "",

        sale_price: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.sale_price
            : ""
          : "",
        wholesale_price: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.wholesale_price
            : ""
          : "",
        color: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.color
            : ""
          : "",
        color_code: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.color_code
            : ""
          : "",
        storage: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.storage
            : ""
          : "",
        battery_life: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.battery_life
            : ""
          : "",
        region: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.region
            : ""
          : "",
        image_path: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.image_path
            : ""
          : "",
        product_condition: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.product_condition
            : ""
          : "",
        note: item?.variants
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.note
            : ""
          : "",
      }));


      //for exchange
      const transformedProductArrayForExchange = orderList.filter(item => item?.onExchange).map((item, index) => ({
        product_id: item?.product_id,
        qty: item.qty,
        have_variant: item?.product_info?.have_variant,
        purchase_id: invoiceData?.exchange_purchase.id,
        product_variant_id: item?.selectedVariantId
          ? item?.selectedVariantId
          : null,
        price:
          type === "purchase" && !typePurchase
            ? item?.invoice_id &&
              (item?.product_info.discount_type === "Percentage" ||
                item?.product_info.discount_type === "2")
              ? item?.product_info.purchase_price
              : item?.invoice_id
              ? item?.product_info.purchase_price || item?.purchase_price
              : item?.purchase_price || item?.price
            : type === "purchase" && typePurchase
            ? item?.invoice_id &&
              (item?.product_info.discount_type === "Percentage" ||
                item?.product_info.discount_type === "2")
              ? item?.product_info.purchase_price
              : item?.invoice_id
              ? item?.price ||
                item?.product_info?.purchase_price ||
                item?.purchase_price
              : item?.purchase_price || item?.price
            : typeSaleEdit && item.onExchange ? item.price
            : item?.product_info &&
              (item?.product_info?.discount_type === "Percentage" ||
                item?.product_info?.discount_type === "2")
            ? item?.price - item?.price * (item?.product_info?.discount / 100)
            : item?.product_info
            ? item?.price - item?.product_info?.discount
            : item?.discount_type === "Percentage" || item?.discount_type === "2"
            ? user.type == 8
              ? item?.price - item?.price * (item?.discount / 100)
              : item?.retails_price - item?.retails_price * (item?.discount / 100)
            : user.type == 8
            ? item?.price - item?.discount
            : item?.retails_price - item?.discount,
        retails_price:
          type === "purchase"
            ? item?.retails_price || item?.product_info?.retails_price || 0
            : item?.retails_price || 0,
        mode: 1,
        size: 1,
        // imei_id: item?.product_imei
        //   ? item.product_imei[0]?.id
        //   : item?.imei_id
        //   ? item?.imei_id
        //   : '',
        imei_id: item?.product_imei?.length && item?.invoice_id
          ? item.product_imei[0]?.id || ""
          : item?.imei_id || "",
        imei: item?.variants && !item?.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.imei
              ? item?.variants[index]?.product_imei[0]?.imei
              : item?.variants[index]?.product_imei[0]?.serial
            : item?.imeis
            ? item.imeis.filter((fitem) => fitem.imei_id === item.imei_id)[0]
                ?.imei
            : ""
          : item.onExchange ? item.product_imei[0].imei : "",

        // purchase_price: item?.variants
        //   ? item.variants[index]?.product_imei
        //     ? item?.variants[index]?.product_imei[0]?.purchase_price
        //     : ""
        //   : invoiceData.sales_details[index]?.purchase_price
        //   ? invoiceData.sales_details[index]?.purchase_price
        //   : "",

        purchase_price:
          type === "purchase" && !item.onExchange
            ? item?.variants
              ? item.variants[index]?.product_imei
                ? item?.variants[index]?.product_imei[0]?.purchase_price
                : item?.purchase_price ||
                  item?.product_info?.purchase_price ||
                  item?.price
              : item?.purchase_price ||
                item?.product_info?.purchase_price ||
                item?.price
            : invoiceData.sales_details && invoiceData.sales_details[index] && !item.onExchange
            ? invoiceData.sales_details[index]?.purchase_price
            : item.onExchange ? item.product_imei[0].purchase_price : item?.purchase_price || item?.product_info?.purchase_price || "",

        sale_price: item?.variants && !item.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.sale_price
            : ""
          : item.onExchange ? item.product_imei[0].sale_price : "",
        wholesale_price: item?.variants && !item.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.wholesale_price
            : ""
          : item.onExchange ? item.product_imei[0].wholesale_price : "",
        color: item?.variants && !item.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.color
            : ""
          : item.onExchange ? item.product_imei[0].color : "",
        color_code: item?.variants && !item.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.color_code
            : ""
          : item.onExchange ? item.product_imei[0].color_code : "",
        storage: item?.variants && !item.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.storage
            : ""
          : item.onExchange ? item.product_imei[0].storage : "",
        battery_life: item?.variants && !item.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.battery_life
            : ""
          : item.onExchange ? item.product_imei[0].battery_life : "",
        region: item?.variants && !item.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.region
            : ""
          : item.onExchange ? item.product_imei[0].region : "",
        image_path: item?.variants && !item.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.image_path
            : ""
          : item.onExchange ? item.product_imei[0].image_path : "",
        product_condition: item?.variants && !item.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.product_condition
            : ""
          : item.onExchange ? item.product_imei[0].product_condition : "",
        note: item?.variants && !item.onExchange
          ? item.variants[index]?.product_imei
            ? item?.variants[index]?.product_imei[0]?.note
            : ""
          : item.onExchange ? item.product_imei[0].note : "",
      }));


      const totalPrice = transformedProductArray.filter(item => !item?.onExchange).reduce((total, item) => {
      const itemTotalPrice = item.qty * item.price;
        return total + itemTotalPrice;
      }, 0);
      const vatsN = vat && vat > 0 ? (vat / 100) * totalPrice : 0;
      const taxN = tax && tax > 0 ? (tax / 100) * totalPrice : 0;
      const sub_total_c = totalPrice - Number(totalMoreDiscount) + vatsN + taxN;

      //for exchange
      const totalPriceForExchange = transformedProductArrayForExchange.filter(item => item?.onExchange).reduce((total, item) => {
        console.log(item.price)
        console.log(item.qty)
        console.log("itemTotalPriceForExchange... ",itemTotalPriceForExchange)
      const itemTotalPriceForExchange = item.qty * item.price;
        return total + itemTotalPriceForExchange;
      }, 0);
      const vatsNForExchange = vat && vat > 0 ? (vat / 100) * totalPriceForExchange : 0;
      const taxNForExchange = tax && tax > 0 ? (tax / 100) * totalPriceForExchange : 0;
      const sub_total_c_ForExchange = totalPriceForExchange /* - Number(totalMoreDiscount) */ + vatsNForExchange + taxNForExchange;


      const paymentMap =
        typePurchase && selectedPaymentAccountList?.length == 0
          ? invoiceData.multiple_payments.map((item) => ({
              payment_type_id: item.payment_type_id,
              payment_type_category_id: item.payment_type_category_id,
              payment_amount: item?.payment_amount
                ? item?.payment_amount
                : item?.Amount
                ? item?.Amount
                : 0,
            }))
          : selectedPaymentAccountList?.map((item, index) => ({
              payment_type_id: item.payment_type_id,
              payment_type_category_id: item.payment_type_category_id,
              reference:
                reference && reference[index]
                  ? reference[index]?.reference
                  : null,
              payment_amount: item?.payment_amount
                ? parseInt(user?.type) === 4
                  ? item?.payment_amount - cashChange
                  : item?.payment_amount
                : item?.Amount
                ? parseInt(user?.type) === 4
                  ? item?.Amount - cashChange
                  : item?.Amount
                : 0,
            }));

      //for exchange
      const paymentMapForExchange =  invoiceData?.exchange_purchase?.multiple_payments.map((item) => ({
              payment_type_id: item.payment_type_id,
              payment_type_category_id: item.payment_type_category_id,
              payment_amount: item?.payment_amount
                ? item?.payment_amount
                : item?.Amount
                ? item?.Amount
                : 0,
            }))

      const firstCategory =
        selectedPaymentAccountListForExchange?.payment_type_category?.[0];

      const paymentMapForExchangeProduct = firstCategory
        ? [
            {
              payment_type_id: selectedPaymentAccountListForExchange?.id,
              payment_type_category_id: firstCategory?.id,
              payment_amount: orderList
                .filter(item => item?.onExchange)
                .reduce((sum, item) => {
                  return sum + (item?.product_imei?.[0]?.purchase_price || 0);
                }, 0),
            },
          ]
        : [];

      const data = {
        invoice_id: invoiceData?.invoice_id,
        pay_mode: money,
        paid_amount: Number(paidAmount),
        cash_change: parseInt(cashChange),
        sub_total: totalPrice,
        vat:
          vat && vat > 0
            ? Number(formatNumber((vat / 100) * Number(totalPrice)))
            : 0,
        tax:
          tax && tax > 0
            ? Number(formatNumber((tax / 100) * Number(totalPrice)))
            : 0,
        discount: Number(initialDiscount),
        product: transformedProductArray,
        delivery_method_id: deliveryFormData.deliveryId,
        delivery_info_id: deliveryFormData.companyId,
        delivery_customer_name: deliveryFormData.customerName,
        delivery_customer_address: deliveryFormData.customerAddress,
        delivery_customer_phone: deliveryFormData.customerPhone,
        delivery_fee: deliveryAmount ?? deliveryFormData.deliveryFee,
        delivery_note: deliveryFormData.deliveryNote ?? "",
        payment_method: paymentMap,
        table_id: selectedTable,
        sales_id: 1,
        status: 0,
        created_at: transactionDate,
        //warranty: defaultWarrantyList,
      };

      //for exchang
      const dataForExchange = {
        invoice_id: invoiceData?.exchange_purchase.invoice_id,
        pay_mode: money,
        paid_amount: Number(invoiceData?.exchange_purchase.paid_amount),
        cash_change: parseInt(cashChange),
        sub_total: totalPriceForExchange,
        vat:
          vat && vat > 0
            ? Number(formatNumber((vat / 100) * Number(totalPriceForExchange)))
            : 0,
        tax:
          tax && tax > 0
            ? Number(formatNumber((tax / 100) * Number(totalPriceForExchange)))
            : 0,
        discount: Number(initialDiscount),
        product: transformedProductArrayForExchange,
        payment_method: paymentMapForExchangeProduct?.length
          ? paymentMapForExchangeProduct
          : paymentMapForExchange,
        sales_id: 1,
        status: 1,
        created_at: transactionDate,
        //warranty: defaultWarrantyList,
      };

      data.customer_id = customer
        ? customer?.customer_id
          ? customer?.customer_id
          : customer?.id
        : null;
      data.customer_name = customer
        ? customer?.customer_name
          ? customer?.customer_name
          : customer?.name
        : null;
      data.customer_phone = customer
        ? customer?.customer_phone
          ? customer?.customer_phone
          : customer?.mobile_number
        : null;
      if (currentUser) {
        data.sales_id = seller?.id ? seller?.id : currentUser.id;
      } else {
        data.sales_id = seller?.id ? seller?.id : null;
      }

      data.status = 1;

      setDeliveryMode(deliveryFormData.deliveryName);

      if(1){
        console.log("Data for sale...", data)
        console.log("Data for exchange...", dataForExchange)
        return
      }
      await axios
        .post(`${process.env.REACT_APP_API_URL}update-sales`, data, {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then(async (response) => {
          loadingCallback(false);
          console.log("response.data.success... ", response.data.success);
          if (response.data.success) {
            //----------------------------------------------------STEAD FAST BLOCK-------------------------------
            const invoice_id =
              response.data?.data?.invoice_id ?? invoiceData.invoice_id ?? null;
            const sale_id = response.data?.data?.sales_id ?? null;
            console.log("response.data.data... ", response.data.data);
            console.log("after response.data.data... ");
            console.log(
              "deliveryFormData?.deliveryName",
              deliveryFormData?.deliveryName
            );
            console.log("invoice_id", invoice_id);
            console.log("!typePurchase", !typePurchase);
            console.log("type !== purchase", type !== "purchase");
            if (
              deliveryFormData?.deliveryName?.toLowerCase() === "steadfast" &&
              invoice_id &&
              !typePurchase &&
              type !== "purchase"
            ) {
              const steadFastOrder = {
                invoice: invoice_id,
                recipient_name: deliveryFormData?.customerName,
                recipient_phone: deliveryFormData?.customerPhone,
                recipient_address: deliveryFormData?.customerAddress,
                // parcel_type: deliveryFormData?.parcel_type,
                cod_amount: Number.parseFloat(due).toFixed(2),
                // delivery_area: deliveryFormData?.delivery_area,
                note: deliveryFormData?.note,
              };

              await axios
                .post(
                  `${process.env.REACT_APP_API_URL}courier/create-order`,
                  steadFastOrder,
                  {
                    headers: {
                      authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then(async (response) => {
                  console.log("✅ Order placed successfully:", response.data);
                  const steadFastOrderResponse = {
                    consignment_id:
                      response.data?.data?.consignment?.consignment_id,
                    invoice: invoice_id,
                    sale_id: sale_id,
                    tracking_code:
                      response.data?.data?.consignment?.tracking_code,
                    recipient_name: deliveryFormData?.customerName,
                    recipient_phone: deliveryFormData?.customerPhone,
                    recipient_address: deliveryFormData?.customerAddress,
                    cod_amount: Number.parseFloat(due).toFixed(2),
                    delivery_status:
                      response.data?.data?.consignment?.delivery_status,
                    note: deliveryFormData?.deliveryNote ?? "",
                  };
                  try {
                    const courierResponse = await axios.post(
                      `${process.env.REACT_APP_API_URL}steadfast-couriers`,
                      steadFastOrderResponse,
                      {
                        headers: {
                          authorization: `Bearer ${token}`,
                          "Content-Type": "application/json",
                        },
                      }
                    );
                    console.log("📦 Courier order placed:", courierResponse.data);
                  } catch (courierError) {
                    if (courierError.response) {
                      console.error(
                        "Courier Error (response):",
                        courierError.response.data
                      );
                    } else if (courierError.request) {
                      console.error(
                        "Courier Error (no response):",
                        courierError.request
                      );
                    } else {
                      console.error(
                        "Courier Error (setup):",
                        courierError.message
                      );
                    }
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    // Server responded with a status other than 2xx
                    console.error(
                      "🛑 Server responded with an error:",
                      error.response.status
                    );
                    console.error("Error data:", error.response.data);
                  } else if (error.request) {
                    // Request was made but no response received
                    console.error("🛑 No response received:", error.request);
                  } else {
                    // Something else happened while setting up the request
                    console.error("🛑 Error in request setup:", error.message);
                  }
                });
            }
            //----------------------------------------------------STEAD FAST BLOCK END-------------------------------
            //----------------------------------------------------PATHAO BLOCK-------------------------------

            if (
              deliveryFormData?.deliveryName?.toLowerCase() === "pathao" &&
              invoice_id &&
              !typePurchase &&
              type !== "purchase"
            ) {
              console.log("Pathao Block in Edit ");
              const namesString = {
                names: orderList
                  .map((item) => {
                    const baseName =
                      item.product_info?.name || item.name || "Unnamed Product";
                    const variantName =
                      item.product_variant_id && item.product_variant?.name
                        ? ` (${item.product_variant.name})`
                        : "";
                    return baseName + variantName;
                  })
                  .filter(Boolean)
                  .join(", "),
              };
              const totalQty = orderList.reduce(
                (sum, item) => sum + (item.qty || 0),
                0
              );

              const pathaoOrder = {
                store_id: pathaoStore.store_id,
                merchant_order_id: invoice_id,
                recipient_name: deliveryFormData?.customerName,
                recipient_phone: deliveryFormData?.customerPhone,
                recipient_address: deliveryFormData?.customerAddress,
                recipient_city: pathaoCity.city_id,
                recipient_zone: pathaoZone.zone_id,
                special_instruction: deliveryFormData?.deliveryNote ?? "",
                item_quantity: totalQty,
                item_description: namesString.names,
                amount_to_collect: Number.parseFloat(due).toFixed(2),
              };
              console.log(
                "Pathao ",
                invoice_id,
                " Due ",
                Number.parseFloat(due).toFixed(2)
              );

              await axios
                .post(
                  `${process.env.REACT_APP_API_URL}pathao/create-order`,
                  pathaoOrder,
                  {
                    headers: {
                      authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then(async (response) => {
                  console.log("✅ Order placed successfully:", response.data);
                  const steadFastOrderResponse = {
                    consignment_id: response.data?.data?.consignment_id,
                    invoice: invoice_id,
                    sale_id: sale_id,
                    recipient_name: deliveryFormData?.customerName,
                    recipient_phone: deliveryFormData?.customerPhone,
                    recipient_address: deliveryFormData?.customerAddress,
                    cod_amount: Number.parseFloat(due).toFixed(2),
                    delivery_status:
                      response.data?.data?.order_status.toLowerCase(),
                    note: deliveryFormData?.note,
                  };
                  try {
                    const courierResponse = await axios.post(
                      `${process.env.REACT_APP_API_URL}steadfast-couriers`,
                      steadFastOrderResponse,
                      {
                        headers: {
                          authorization: `Bearer ${token}`,
                          "Content-Type": "application/json",
                        },
                      }
                    );
                    console.log("📦 Courier order placed:", courierResponse.data);
                  } catch (courierError) {
                    if (courierError.response) {
                      console.error(
                        "Courier Error (response):",
                        courierError.response.data
                      );
                    } else if (courierError.request) {
                      console.error(
                        "Courier Error (no response):",
                        courierError.request
                      );
                    } else {
                      console.error(
                        "Courier Error (setup):",
                        courierError.message
                      );
                    }
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    // Server responded with a status other than 2xx
                    console.error(
                      "🛑 Server responded with an error:",
                      error.response.status
                    );
                    console.error("Error data:", error.response.data);
                  } else if (error.request) {
                    // Request was made but no response received
                    console.error("🛑 No response received:", error.request);
                  } else {
                    // Something else happened while setting up the request
                    console.error("🛑 Error in request setup:", error.message);
                  }
                });
            }
            //----------------------------------------------------PATHAO BLOCK END-------------------------------
            console.log("before setOrderList");
            setOrderList([]);
            console.log("before setInvoice");
            setInvoice(response.data.data);
            console.log("after setInvoice");
            console.log("Response...", response.data.data);
            console.log("TYPE == ", type);
            if (type === "purchase") {
              navigate(`/purchase-invoice/${invoiceData.invoice_id}`);
            } else if (type === "booking") {
              if (value) {
                navigate(`/invoice/${response.data.data.invoice_id}`);
                // navigate(`/advance-bookings/${invoiceData.invoice_id}`);
              } else {
                navigate("/advance-bookings");
                // notify("Edited successfully.Go to booking list to update", 'success');
              }
            } else {
              if (value == 1) {
                // console.log("Done", isSave, status, deliveryFormData, type);
                navigate(`/invoice/${invoiceData.invoice_id}`);
              } else {
                console.log("Hold", isSave, status, deliveryFormData, type);
                setStatus(1);
                setIsSave(false);
                // notify("Edited successfully.Go to hold list to update", 'success');
                if (type === "billing" && salesType == "wholesale") {
                  navigate("/hold-wholesale-invoice-list");
                } else if (type === "billing" && value == 0) {
                  navigate(`/invoice/${invoiceData.invoice_id}`);
                } else {
                  navigate(`/purchase-invoice/${response.data.data.purchase_id}`);
                }
              }
            }
          } else {
            if (response.data.message) {
              // setErrorFlashMessage("something went wrong!");
              notify(response.data.message, "error");
            }
            if (response.data.errors) {
              // setErrorFlashMessage(response.data.errors?.customer_id[0]);
              notify(response.data.errors?.customer_id[0], "error");
            }
          }
        })
        .catch((error) => {
          loadingCallback(false);
          if (error?.response?.status === 401) {
            localStorage.clear();
            localStorage.setItem("token", false);
            // Clear session and local storage
            localStorage.setItem("isPinVerify", false);

            navigate("/login");
          }
        });

        //for exchange

        await axios
        .post(`${process.env.REACT_APP_API_URL}update-purchase`, dataForExchange, {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then(async (response) => {
          loadingCallback(false);
          console.log("response.data.success... ", response.data.success);
          if (response.data.success) {
            const invoice_id =
              response.data?.data?.invoice_id ?? invoiceData.invoice_id ?? null;
            const sale_id = response.data?.data?.sales_id ?? null;
            console.log("response.data.data... ", response.data.data);
            console.log("after response.data.data... ");
            console.log(
              "deliveryFormData?.deliveryName",
              deliveryFormData?.deliveryName
            );
            console.log("invoice_id", invoice_id);
            console.log("!typePurchase", !typePurchase);
            console.log("type !== purchase", type !== "purchase");
            console.log("before setOrderList");
            setOrderList([]);
            console.log("before setInvoice");
            setInvoice(response.data.data);
            console.log("after setInvoice");
            console.log("Response...", response.data.data);
            console.log("TYPE == ", type);
            if (type === "purchase") {
              navigate(`/purchase-invoice/${invoiceData.invoice_id}`);
            } else if (type === "booking") {
              if (value) {
                navigate(`/invoice/${response.data.data.invoice_id}`);
                // navigate(`/advance-bookings/${invoiceData.invoice_id}`);
              } else {
                navigate("/advance-bookings");
                // notify("Edited successfully.Go to booking list to update", 'success');
              }
            } else {
              if (value == 1) {
                // console.log("Done", isSave, status, deliveryFormData, type);
                navigate(`/invoice/${invoiceData.invoice_id}`);
              } else {
                console.log("Hold", isSave, status, deliveryFormData, type);
                setStatus(1);
                setIsSave(false);
                // notify("Edited successfully.Go to hold list to update", 'success');
                if (type === "billing" && salesType == "wholesale") {
                  navigate("/hold-wholesale-invoice-list");
                } else if (type === "billing" && value == 0) {
                  navigate(`/invoice/${invoiceData.invoice_id}`);
                } else {
                  navigate(`/purchase-invoice/${response.data.data.purchase_id}`);
                }
              }
            }
          } else {
            if (response.data.message) {
              // setErrorFlashMessage("something went wrong!");
              notify(response.data.message, "error");
            }
            if (response.data.errors) {
              // setErrorFlashMessage(response.data.errors?.customer_id[0]);
              notify(response.data.errors?.customer_id[0], "error");
            }
          }
        })
        .catch((error) => {
          loadingCallback(false);
          if (error?.response?.status === 401) {
            localStorage.clear();
            localStorage.setItem("token", false);
            // Clear session and local storage
            localStorage.setItem("isPinVerify", false);

            navigate("/login");
          }
        });


      return


    }


    const transformedProductArray = orderList.map((item, index) => ({
      product_id: item?.product_id ?? item?.id,
      qty: item.qty,
      have_variant: item?.product_info?.have_variant ?? item?.have_variant,
      product_variant_id: item?.selectedVariantId
        ? item?.selectedVariantId
        : null,
      price:
        type === "purchase" && !typePurchase
          ? item?.invoice_id &&
            (item?.product_info.discount_type === "Percentage" ||
              item?.product_info.discount_type === "2")
            ? item?.product_info.purchase_price
            : item?.invoice_id
            ? item?.product_info.purchase_price || item?.purchase_price
            : item?.purchase_price || item?.price
          : type === "purchase" && typePurchase
          ? item?.invoice_id &&
            (item?.product_info.discount_type === "Percentage" ||
              item?.product_info.discount_type === "2")
            ? item?.product_info.purchase_price
            : item?.invoice_id
            ? item?.price ||
              item?.product_info?.purchase_price ||
              item?.purchase_price
            : item?.purchase_price || item?.price
          : item?.product_info &&
            (item?.product_info?.discount_type === "Percentage" ||
              item?.product_info?.discount_type === "2")
          ? item?.price - item?.price * (item?.product_info?.discount / 100)
          : item?.product_info
          ? item?.price - item?.product_info?.discount
          : item?.discount_type === "Percentage" || item?.discount_type === "2"
          ? user.type == 8
            ? item?.price - item?.price * (item?.discount / 100)
            : item?.retails_price - item?.retails_price * (item?.discount / 100)
          : user.type == 8
          ? item?.price - item?.discount
          : item?.retails_price - item?.discount,
      retails_price:
        type === "purchase"
          ? item?.retails_price || item?.product_info?.retails_price || 0
          : item?.retails_price || 0,
      mode: 1,
      size: 1,
      sales_id: item.sales_id,
      // imei_id: item?.product_imei
      //   ? item.product_imei[0]?.id
      //   : item?.imei_id
      //   ? item?.imei_id
      //   : '',
      imei_id: item?.product_imei?.length && item?.invoice_id
        ? item.product_imei[0]?.id || ""
        : item?.imei_id || "",
      imei: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.imei
            ? item?.variants[index]?.product_imei[0]?.imei
            : item?.variants[index]?.product_imei[0]?.serial
          : item?.imeis
          ? item.imeis.filter((fitem) => fitem.imei_id === item.imei_id)[0]
              ?.imei
          : ""
        : "",

      // purchase_price: item?.variants
      //   ? item.variants[index]?.product_imei
      //     ? item?.variants[index]?.product_imei[0]?.purchase_price
      //     : ""
      //   : invoiceData.sales_details[index]?.purchase_price
      //   ? invoiceData.sales_details[index]?.purchase_price
      //   : "",

      purchase_price:
        type === "purchase"
          ? item?.variants
            ? item.variants[index]?.product_imei
              ? item?.variants[index]?.product_imei[0]?.purchase_price
              : item?.purchase_price ||
                item?.product_info?.purchase_price ||
                item?.price
            : item?.purchase_price ||
              item?.product_info?.purchase_price ||
              item?.price
          : invoiceData.sales_details && invoiceData.sales_details[index]
          ? invoiceData.sales_details[index]?.purchase_price
          : item?.purchase_price || item?.product_info?.purchase_price || "",

      sale_price: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.sale_price
          : ""
        : "",
      wholesale_price: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.wholesale_price
          : ""
        : "",
      color: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.color
          : ""
        : "",
      color_code: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.color_code
          : ""
        : "",
      storage: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.storage
          : ""
        : "",
      battery_life: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.battery_life
          : ""
        : "",
      region: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.region
          : ""
        : "",
      image_path: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.image_path
          : ""
        : "",
      product_condition: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.product_condition
          : ""
        : "",
      note: item?.variants
        ? item.variants[index]?.product_imei
          ? item?.variants[index]?.product_imei[0]?.note
          : ""
        : "",
    }));

    // console.log(transformedProductArray);

    const totalPrice = transformedProductArray.reduce((total, item) => {
      const itemTotalPrice = item.qty * item.price;
      return total + itemTotalPrice;
    }, 0);
    const vatsN = vat && vat > 0 ? (vat / 100) * totalPrice : 0;
    const taxN = tax && tax > 0 ? (tax / 100) * totalPrice : 0;
    const sub_total_c = totalPrice - Number(totalMoreDiscount) + vatsN + taxN;

    console.log(reference);

    const paymentMap =
      typePurchase && selectedPaymentAccountList?.length == 0
        ? invoiceData.multiple_payments.map((item) => ({
            payment_type_id: item.payment_type_id,
            payment_type_category_id: item.payment_type_category_id,
            payment_amount: item?.payment_amount
              ? item?.payment_amount
              : item?.Amount
              ? item?.Amount
              : 0,
          }))
        : selectedPaymentAccountList?.map((item, index) => ({
            payment_type_id: item.payment_type_id,
            payment_type_category_id: item.payment_type_category_id,
            reference:
              reference && reference[index]
                ? reference[index]?.reference
                : null,
            payment_amount: item?.payment_amount
              ? parseInt(user?.type) === 4
                ? item?.payment_amount - cashChange
                : item?.payment_amount
              : item?.Amount
              ? parseInt(user?.type) === 4
                ? item?.Amount - cashChange
                : item?.Amount
              : 0,
          }));

    // const defaultWarrantyList = selectedProductWarrantyList.flatMap((item) => {
    //   const { id, warranty } = item;
    //   return warranty.map((warrantyItem) => ({
    //     product_id: id,
    //     warranty_id: warrantyItem?.id,
    //     default_warranties_count: warrantyItem.warranties_count,
    //   }));
    // });

    if (!selectedPaymentAccountList?.length && !typePurchase) {
      showModalWarning("Select At-least one payment method!");
      return;
    }
    console.log("Transforemed Product Array ", transformedProductArray);
    console.log("CUSTOMER.............. ", customer);
    console.log("Selected payment.... ", selectedPaymentAccountList);
    console.log("CashChange.............. ", cashChange);
    console.log("Payment Map ", paymentMap);
    console.log("Delivery Form Data...... ", deliveryFormData);
    console.log(transformedProductArray);
    const data = {
      invoice_id: invoiceData?.invoice_id,
      pay_mode: money,
      paid_amount: Number(paidAmount),
      cash_change: parseInt(cashChange),
      sub_total: totalPrice,
      vat:
        vat && vat > 0
          ? Number(formatNumber((vat / 100) * Number(totalPrice)))
          : 0,
      tax:
        tax && tax > 0
          ? Number(formatNumber((tax / 100) * Number(totalPrice)))
          : 0,
      discount: Number(initialDiscount),
      product: transformedProductArray,
      delivery_method_id: deliveryFormData.deliveryId,
      delivery_info_id: deliveryFormData.companyId,
      delivery_customer_name: deliveryFormData.customerName,
      delivery_customer_address: deliveryFormData.customerAddress,
      delivery_customer_phone: deliveryFormData.customerPhone,
      delivery_fee: deliveryAmount ?? deliveryFormData.deliveryFee,
      delivery_note: deliveryFormData.deliveryNote ?? "",
      payment_method: paymentMap,
      table_id: selectedTable,
      sales_id: 1,
      status: 0,
      created_at: transactionDate,
      //warranty: defaultWarrantyList,
    };

    if (type === "purchase") {
      data.vendor_id = vendor?.id;
      data.vendor_name = vendor.name;
    } else {
      data.customer_id = customer
        ? customer?.customer_id
          ? customer?.customer_id
          : customer?.id
        : null;
      data.customer_name = customer
        ? customer?.customer_name
          ? customer?.customer_name
          : customer?.name
        : null;
      data.customer_phone = customer
        ? customer?.customer_phone
          ? customer?.customer_phone
          : customer?.mobile_number
        : null;
      if (currentUser) {
        data.sales_id = seller?.id ? seller?.id : currentUser.id;
      } else {
        data.sales_id = seller?.id ? seller?.id : null;
      }
    }
    if ((type == "billing" || typePurchase) && value) {
      data.status = 1;
    }
    if (type == "booking" && value) {
      data.status = 1;
    }

    // console.log("discount", initialDiscount, totalMoreDiscount);
    // const url = type === "purchase" ? "save-purchase" : type === "booking" ? "update-advance-sales" : "update-sales"; save-sale
    const url = typePurchase
      ? "update-purchase"
      : typeEcommerce
      ? "update-ecommerce-sales"
      : type === "booking"
      ? value
        ? "save-sales"
        : "update-advance-sales"
      : "update-sales";

    // console.log("url", url);

    // console.log("============");
    // console.log("check data", data, type);
    setDeliveryMode(deliveryFormData.deliveryName);

    console.log(
      "Final transformedProductArray for purchase:",
      transformedProductArray
    );
    console.log("OrderList before submit:", orderList);

    // return
    await axios
      .post(`${process.env.REACT_APP_API_URL}${url}`, data, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(async (response) => {
        loadingCallback(false);
        console.log("response.data.success... ", response.data.success);
        if (response.data.success) {
          //----------------------------------------------------STEAD FAST BLOCK-------------------------------
          const invoice_id =
            response.data?.data?.invoice_id ?? invoiceData.invoice_id ?? null;
          const sale_id = response.data?.data?.sales_id ?? null;
          console.log("response.data.data... ", response.data.data);
          console.log("after response.data.data... ");
          console.log(
            "deliveryFormData?.deliveryName",
            deliveryFormData?.deliveryName
          );
          console.log("invoice_id", invoice_id);
          console.log("!typePurchase", !typePurchase);
          console.log("type !== purchase", type !== "purchase");
          if (
            deliveryFormData?.deliveryName?.toLowerCase() === "steadfast" &&
            invoice_id &&
            !typePurchase &&
            type !== "purchase"
          ) {
            const steadFastOrder = {
              invoice: invoice_id,
              recipient_name: deliveryFormData?.customerName,
              recipient_phone: deliveryFormData?.customerPhone,
              recipient_address: deliveryFormData?.customerAddress,
              // parcel_type: deliveryFormData?.parcel_type,
              cod_amount: Number.parseFloat(due).toFixed(2),
              // delivery_area: deliveryFormData?.delivery_area,
              note: deliveryFormData?.note,
            };

            await axios
              .post(
                `${process.env.REACT_APP_API_URL}courier/create-order`,
                steadFastOrder,
                {
                  headers: {
                    authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                }
              )
              .then(async (response) => {
                console.log("✅ Order placed successfully:", response.data);
                const steadFastOrderResponse = {
                  consignment_id:
                    response.data?.data?.consignment?.consignment_id,
                  invoice: invoice_id,
                  sale_id: sale_id,
                  tracking_code:
                    response.data?.data?.consignment?.tracking_code,
                  recipient_name: deliveryFormData?.customerName,
                  recipient_phone: deliveryFormData?.customerPhone,
                  recipient_address: deliveryFormData?.customerAddress,
                  cod_amount: Number.parseFloat(due).toFixed(2),
                  delivery_status:
                    response.data?.data?.consignment?.delivery_status,
                  note: deliveryFormData?.deliveryNote ?? "",
                };
                try {
                  const courierResponse = await axios.post(
                    `${process.env.REACT_APP_API_URL}steadfast-couriers`,
                    steadFastOrderResponse,
                    {
                      headers: {
                        authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                    }
                  );
                  console.log("📦 Courier order placed:", courierResponse.data);
                } catch (courierError) {
                  if (courierError.response) {
                    console.error(
                      "Courier Error (response):",
                      courierError.response.data
                    );
                  } else if (courierError.request) {
                    console.error(
                      "Courier Error (no response):",
                      courierError.request
                    );
                  } else {
                    console.error(
                      "Courier Error (setup):",
                      courierError.message
                    );
                  }
                }
              })
              .catch((error) => {
                if (error.response) {
                  // Server responded with a status other than 2xx
                  console.error(
                    "🛑 Server responded with an error:",
                    error.response.status
                  );
                  console.error("Error data:", error.response.data);
                } else if (error.request) {
                  // Request was made but no response received
                  console.error("🛑 No response received:", error.request);
                } else {
                  // Something else happened while setting up the request
                  console.error("🛑 Error in request setup:", error.message);
                }
              });
          }
          //----------------------------------------------------STEAD FAST BLOCK END-------------------------------
          //----------------------------------------------------PATHAO BLOCK-------------------------------

          if (
            deliveryFormData?.deliveryName?.toLowerCase() === "pathao" &&
            invoice_id &&
            !typePurchase &&
            type !== "purchase"
          ) {
            console.log("Pathao Block in Edit ");
            const namesString = {
              names: orderList
                .map((item) => {
                  const baseName =
                    item.product_info?.name || item.name || "Unnamed Product";
                  const variantName =
                    item.product_variant_id && item.product_variant?.name
                      ? ` (${item.product_variant.name})`
                      : "";
                  return baseName + variantName;
                })
                .filter(Boolean)
                .join(", "),
            };
            const totalQty = orderList.reduce(
              (sum, item) => sum + (item.qty || 0),
              0
            );

            const pathaoOrder = {
              store_id: pathaoStore.store_id,
              merchant_order_id: invoice_id,
              recipient_name: deliveryFormData?.customerName,
              recipient_phone: deliveryFormData?.customerPhone,
              recipient_address: deliveryFormData?.customerAddress,
              recipient_city: pathaoCity.city_id,
              recipient_zone: pathaoZone.zone_id,
              special_instruction: deliveryFormData?.deliveryNote ?? "",
              item_quantity: totalQty,
              item_description: namesString.names,
              amount_to_collect: Number.parseFloat(due).toFixed(2),
            };
            console.log(
              "Pathao ",
              invoice_id,
              " Due ",
              Number.parseFloat(due).toFixed(2)
            );

            await axios
              .post(
                `${process.env.REACT_APP_API_URL}pathao/create-order`,
                pathaoOrder,
                {
                  headers: {
                    authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                }
              )
              .then(async (response) => {
                console.log("✅ Order placed successfully:", response.data);
                const steadFastOrderResponse = {
                  consignment_id: response.data?.data?.consignment_id,
                  invoice: invoice_id,
                  sale_id: sale_id,
                  recipient_name: deliveryFormData?.customerName,
                  recipient_phone: deliveryFormData?.customerPhone,
                  recipient_address: deliveryFormData?.customerAddress,
                  cod_amount: Number.parseFloat(due).toFixed(2),
                  delivery_status:
                    response.data?.data?.order_status.toLowerCase(),
                  note: deliveryFormData?.note,
                };
                try {
                  const courierResponse = await axios.post(
                    `${process.env.REACT_APP_API_URL}steadfast-couriers`,
                    steadFastOrderResponse,
                    {
                      headers: {
                        authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                    }
                  );
                  console.log("📦 Courier order placed:", courierResponse.data);
                } catch (courierError) {
                  if (courierError.response) {
                    console.error(
                      "Courier Error (response):",
                      courierError.response.data
                    );
                  } else if (courierError.request) {
                    console.error(
                      "Courier Error (no response):",
                      courierError.request
                    );
                  } else {
                    console.error(
                      "Courier Error (setup):",
                      courierError.message
                    );
                  }
                }
              })
              .catch((error) => {
                if (error.response) {
                  // Server responded with a status other than 2xx
                  console.error(
                    "🛑 Server responded with an error:",
                    error.response.status
                  );
                  console.error("Error data:", error.response.data);
                } else if (error.request) {
                  // Request was made but no response received
                  console.error("🛑 No response received:", error.request);
                } else {
                  // Something else happened while setting up the request
                  console.error("🛑 Error in request setup:", error.message);
                }
              });
          }
          //----------------------------------------------------PATHAO BLOCK END-------------------------------
          console.log("before setOrderList");
          setOrderList([]);
          console.log("before setInvoice");
          setInvoice(response.data.data);
          console.log("after setInvoice");
          console.log("Response...", response.data.data);
          console.log("TYPE == ", type);
          if (type === "purchase") {
            navigate(`/purchase-invoice/${invoiceData.invoice_id}`);
          } else if (type === "booking") {
            if (value) {
              navigate(`/invoice/${response.data.data.invoice_id}`);
              // navigate(`/advance-bookings/${invoiceData.invoice_id}`);
            } else {
              navigate("/advance-bookings");
              // notify("Edited successfully.Go to booking list to update", 'success');
            }
          } else {
            if (value == 1) {
              // console.log("Done", isSave, status, deliveryFormData, type);
              navigate(`/invoice/${invoiceData.invoice_id}`);
            } else {
              console.log("Hold", isSave, status, deliveryFormData, type);
              setStatus(1);
              setIsSave(false);
              // notify("Edited successfully.Go to hold list to update", 'success');
              if (type === "billing" && salesType == "wholesale") {
                navigate("/hold-wholesale-invoice-list");
              } else if (type === "billing" && value == 0) {
                navigate(`/invoice/${invoiceData.invoice_id}`);
              } else {
                navigate(`/purchase-invoice/${response.data.data.purchase_id}`);
              }
            }
          }
        } else {
          if (response.data.message) {
            // setErrorFlashMessage("something went wrong!");
            notify(response.data.message, "error");
          }
          if (response.data.errors) {
            // setErrorFlashMessage(response.data.errors?.customer_id[0]);
            notify(response.data.errors?.customer_id[0], "error");
          }
        }
      })
      .catch((error) => {
        loadingCallback(false);
        if (error?.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          // Clear session and local storage
          localStorage.setItem("isPinVerify", false);

          navigate("/login");
        }
      });
  };
  const onPageChange = (page) => {
    setCurrentPage(page);
  };
  const shouldRenderPagination = pagination.total > perPage;
  const [showQuickProductAddForm, setShowQuickProductAddForm] = useState(false);
  const handleQuickProductFormClick = () => {
    setShowQuickProductAddForm(!showQuickProductAddForm);
  };

  const [showModal, setShowModal] = useState(false);
  const handleOpen = () => setShowModal(!showModal);
  const [showModalSeller, setShowModalSeller] = useState(false);
  const handleOpenSeller = () => setShowModalSeller(!showModalSeller);
  const [showModalVendor, setShowModalVendor] = useState(false);
  const handleOpenVendor = () => setShowModalVendor(!showModalVendor);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const handleOpenPayment = () => setShowPaymentModal(!showPaymentModal);

  // Gneral Focus Hook
  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };
  useEffect(() => {}, [selectedFood]);
  const selectedVariantId = orderList[productVariantIndex]?.selectedVariantId;
  const handleSelectVariant = (
    selectedVariantId,
    selectedVariantName,
    selectedVariantPrice,
    selectedVariantQuantity
  ) => {
    if (selectedVariantQuantity <= 0) {
      showModalWarning("This product variant is stockout!");
      return;
    }
    console.log(
      "selectedVariantId in handleSelect VAriant........ ",
      selectedVariantId
    );
    const isVariantAlreadyInOrderList = orderList.some(
      (orderItem) => orderItem.selectedVariantId === selectedVariantId
    );
    if (isVariantAlreadyInOrderList) {
      showModalWarning("This product variant already added in order list!");
      return;
    }

    const updatedSelectedFood = {
      ...selectedFood,
      selectedVariantId,
      selectedVariantName,
      selectedVariantPrice,
      selectedVariantQuantity,
    };
    handleSelectedFood(updatedSelectedFood);
  };
  const [inputRef, setInputFocus] = useFocus();
  const [filteredCustomers, setFilteredCustomers] = useState([{ id: 1 }]);
  const eclipse = (str, length) => {
    return str && str.length > 0 && str.length > length
      ? str.substring(0, length) + "..."
      : str;
  };
  const modifiedFilteredProducts = Array.isArray(filteredProducts)
    ? [...filteredProducts]
    : [];
  const filteredWithoutSelected = modifiedFilteredProducts.filter(
    (item) => item?.id !== selectedFood?.id
  );
  filteredWithoutSelected.unshift(selectedFood);
  useEffect(() => {
    getSellerListData();
  }, []);
  const [filteredSeller, setFilteredSeller] = useState([{ id: 1 }]);
  const [showSeller, setShowSeller] = useState(
    invoiceData?.sales_id != null ? true : false
  );

  const getSellerListData = async (searchKeyword = "") => {
    //loadingCallback(true);
    setFilteredSeller([]);
    const page1 = 1;

    const options = [{ id: "", name: "Select" }];
    axios
      .get(`${process.env.REACT_APP_API_URL}employee`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        loadingCallback(false);
        if (response.status === 200) {
          const sellers = response.data.data.data;
          // Append other options if there are sellers
          if (sellers.length > 0) {
            const sellerOptions = sellers.map((seller) => ({
              id: seller?.id,
              employee_type: seller.employee_type,
              name: seller.name,
              email: seller.email,
              country_code: seller.country_code,
              mobile_number: seller.mobile_number,
              address: seller.address,
              country: seller.country,
              district: seller.district,
              city: seller.city,
              zipcode: seller.zipcode,
              nid: seller.nid,
              joining_date: seller.joining_date,
              blood_group_id: seller.blood_group_id,
              emergency_contact_name: seller.emergency_contact_name,
              emergency_country_code: seller.emergency_country_code,
              emergency_mobile_numbers: seller.emergency_mobile_numbers,
              relation_with: seller.relation_with,
              status: seller.status,
            }));
            options.push(...sellerOptions);
            setShowSeller(true);
          } else {
            setSeller(currentUser ? currentUser?.id : null);
          }
        } else {
          console.log("Data Not Found!");
        }
        setFilteredSeller(options);
      })
      .catch((error) => {
        loadingCallback(false);
        console.log(error);
        if (error?.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          // Clear session and local storage
          localStorage.setItem("isPinVerify", false);

          navigate("/login");
        }
      });
  };
  const minWidth = 80; // Set a reasonable minimum width
  // const inputStyle = {
  //   width: `${Math.max(paidAmount.length * 10 + 30, minWidth)}px`,
  // };

  const [barcodeRead, setBarcodeRead] = useState("");

  const handleScan = (data) => {
    if (data) {
      //setBarcodeRead(data);
    }
  };

  const handleError = (error) => {
    console.log(error);
    setBarcodeRead(error);
  };

  const fetchProductData = (productId) => {
    //loadingCallback(true);
    // Make an API request to fetch product data by ID
    // Once data is retrieved, update the form fields with the data
    get("product-details/" + productId, token)
      .then((response) => {
        const productData = response.data; // Replace with your API response data

        loadingCallback(false);
        //setProductData(productData);
        handleSelectedFood(productData);
      })
      .catch((error) => {
        console.log(error);
        loadingCallback(false);
        if (error?.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          // Clear session and local storage
          localStorage.setItem("isPinVerify", false);

          navigate("/login");
          // Navigate to the '/login' route
        }
      });
  };

  const [methodIndex, setMethodIndex] = useState(null);

  useEffect(() => {
    if (barcodeRead.length > 0) {
      fetchProductData(barcodeRead);
    }
  }, [barcodeRead]);

  // useEffect(() => {
  //   if (status === 0) {
  //     handleSubmitOrder();
  //   }
  // }, [status]);

  // useEffect(() => {
  // }, [currentPage, methodIndex]);

  const handleChangeSelect = (name, option) => {
    const { value, label } = option; //some error in this code.
    setDeliveryFormData({
      ...deliveryFormData,
      deliveryId: value,
      deliveryName: label,
      companyId: value,
      companyName: label,
    });
  };

  useEffect(() => {
    if (deliveryList?.length) {
      let selectInitial = deliveryList.find(
        (item) => item?.id == invoiceData?.delivery_method_id
      );
      // console.log("delivery List", deliveryList, selectInitial, invoiceData);
      if (selectInitial?.type_name != "hand-to-hand") {
        let selectInialInfo = selectInitial?.delivery_infos.find(
          (item) => item.id == invoiceData?.delivery_info_id
        );
        setDeliveryFormData({
          ...deliveryFormData,
          deliveryId: selectInitial?.id,
          deliveryName: selectInitial?.type_name,
          companyId: selectInialInfo?.id,
          companyName: selectInialInfo?.company_name,
        });
      } else {
        setDeliveryFormData({
          ...deliveryFormData,
          deliveryId: selectInitial?.id,
          deliveryName: selectInitial?.type_name,
        });
      }
      console.log("selectDelivery", selectInitial);
    }
  }, [deliveryList]);

  const getDelivery = () => {
    loadingCallback(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}delivery-method-list`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setDeliveryList(response.data.data.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        console.log(error);
      });
  };

  const getDeliveryAccountList = () => {
    loadingCallback(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}delivery-info-list`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setDeliveryAccountList(response.data.data.data);
        }
      })
      .catch((error) => {
        navigate("/login");
        console.log(error);
      });
  };

  const getWarranty = () => {
    loadingCallback(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}get-warranty-list`, {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          loadingCallback(false);
          setWarrantyList(response.data.data);
          updateWarrantyList(response.data.data);
          // setSelectedProductWarrantyList(response.data.data)
        }
      })
      .catch((error) => {
        navigate("/login");
        // console.log(error);
      });
  };

  // console.log(warrantyList);

  const handleChangeDeliveryAmount = (value) => {
    if (!orderList.length) {
      showModalWarning("Please Select A product");
      return;
    }
    if (!/[0-9.]/.test(String(value).slice(-1))) {
      setDeliveryAmount(0);
      return;
    }
    const parseFlat = parseFloat(value);
    if (!isNaN(parseFlat) && parseFlat) {
      if (value[0] == "0") {
        value = String(value).slice(1, value?.length);
        setDeliveryAmount(value);
      } else {
        setDeliveryAmount(value);
      }
    } else {
      setDeliveryAmount(0);
    }
  };

  const debounceTimeout = useRef(null);

  const handleInputChange = (e) => {
    const { value } = e.target;

    // Clear the existing timeout to reset debounce
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Set a new timeout
    debounceTimeout.current = setTimeout(() => {
      setSearchKeyword(value);
    }, 700); // Adjust the debounce delay as needed (500ms here)
  };

  const [orderIndex, setOrderIndex] = useState(0);

  useEffect(() => {
    if (orderIndex !== null) {
      console.log("Updated orderIndex:", orderIndex);
      // Perform any action needed after orderIndex updates
    }
  }, [orderIndex]);

  const [restaurantTables, setRestaurantTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(invoiceData?.table_id);
  const getRestaurantTableList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}table-list`, {
        headers: {
          authorization: `Bearer ${token} `,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setRestaurantTables(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (user.type == 4) getRestaurantTableList();
  }, []);

  const [pathaoStores, setPathaoStores] = useState([]);
  const [pathaoStore, setPathaoStore] = useState({
    store_id: "",
    store_name: "Select store",
  });
  const getPathaoStoreList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}pathao/stores`, {
        headers: {
          authorization: `Bearer ${token} `,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Pathao Stores... ", response.data.data.data);
        setPathaoStores(response.data.data.data);
        setPathaoStore({
          store_id: response.data.data.data[0].store_id,
          store_name: response.data.data.data[0].store_name,
        })
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (deliveryFormData?.deliveryName?.toLowerCase() === "pathao")
      getPathaoStoreList();
  }, [deliveryFormData?.deliveryName]);

  const handlePathaoStoreChangeSelect = (name, option) => {
    const { value, label } = option; //some error in this code.

    setPathaoStore({
      store_id: value,
      store_name: label,
    });
  };

  const normalize = (str) =>
    str
      ?.toLowerCase()
      .replace(/[^a-z0-9\s]/gi, "")
      .trim() || "";
  const tokenize = (str) => normalize(str).split(/\s+/);

  //FOR CITIES
  const tokenBasedCityMatch = (address, cities) => {
    const addressTokens = tokenize(address);

    for (const city of cities) {
      const cityTokens = tokenize(city.city_name);
      const commonTokens = cityTokens.filter((token) =>
        addressTokens.includes(token)
      );

      if (commonTokens.length >= 1) {
        return city.city_id;
      }
    }

    return null;
  };

  const fuzzyCityMatch = (address, cities) => {
    const normalizedAddress = normalize(address);

    let bestMatch = null;
    let smallestDistance = Infinity;

    for (const city of cities) {
      const d = distance(normalize(city.city_name), normalizedAddress);

      if (d < smallestDistance && d < 8) {
        smallestDistance = d;
        bestMatch = city.city_id;
      }
    }

    return bestMatch;
  };

  //FOR ZONES
  // Step 1: Token-based smart match
  const tokenBasedMatch = (address, zones) => {
    const addressTokens = tokenize(address);

    for (const zone of zones) {
      const zoneTokens = tokenize(zone.zone_name);
      const commonTokens = zoneTokens.filter((token) =>
        addressTokens.includes(token)
      );

      if (commonTokens.length >= 2) {
        return zone.zone_id;
      }
    }

    return null;
  };

  // Step 2: Fuzzy fallback match
  const fuzzyMatch = (address, zones) => {
    const normalizedAddress = normalize(address);

    let bestMatch = null;
    let smallestDistance = Infinity;

    for (const zone of zones) {
      const d = distance(normalize(zone.zone_name), normalizedAddress);

      if (d < smallestDistance && d < 10) {
        // adjust threshold as needed
        smallestDistance = d;
        bestMatch = zone.zone_id;
      }
    }

    return bestMatch;
  };

  const [pathaoCities, setPathaoCities] = useState([]);
  const [pathaoCity, setPathaoCity] = useState({
    city_id: "",
    city_name: "Select city",
  });
  const getPathaoCityList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}pathao/cities`, {
        headers: {
          authorization: `Bearer ${token} `,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Pathao Cities... ", response.data.data.data);
        setPathaoCities(response.data.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getMatchedCityId = (address, cities, deliveryDistrict) => {
    if (!cities?.length) return null;

    // STEP 1: If delivery district exists, match directly
    if (deliveryDistrict) {
      const matchedDistrict = cities.find(
        (city) =>
          city.city_name?.toLowerCase().trim() ===
          deliveryDistrict.toLowerCase().trim()
      );

      if (matchedDistrict) return matchedDistrict.city_id;
    }

    // STEP 2: If address missing, return null
    if (!address) return null;

    // STEP 3: Fallback to original matching logic
    return (
      tokenBasedCityMatch(address, cities) ?? fuzzyCityMatch(address, cities)
    );
  };

  const matchedCityId = getMatchedCityId(
    invoiceData?.delivery_customer_address,
    pathaoCities
  );

  useEffect(() => {
    if (deliveryFormData?.deliveryName?.toLowerCase() === "pathao")
      getPathaoCityList();
  }, [deliveryFormData?.deliveryName]);

  useEffect(() => {
    if (
      invoiceData?.delivery_customer_address &&
      deliveryFormData?.deliveryName?.toLowerCase() === "pathao"
    ) {
      const matchedCityId = getMatchedCityId(
        invoiceData.delivery_customer_address,
        pathaoCities,
        invoiceData?.delivery_district
      );
      const matchedCity = pathaoCities.find((c) => c.city_id === matchedCityId);

      if (matchedCity) {
        setPathaoCity(matchedCity); // this triggers getPathaoZoneList
      }
    }
  }, [
    invoiceData?.delivery_customer_address,
    invoiceData?.delivery_district,
    pathaoCities,
    deliveryFormData?.deliveryName,
  ]);

  const handlePathaoCityChangeSelect = (name, option) => {
    const { value, label } = option; //some error in this code.

    setPathaoCity({
      city_id: value,
      city_name: label,
    });
  };

  const [pathaoZones, setPathaoZones] = useState([]);
  const [pathaoZone, setPathaoZone] = useState({
    zone_id: "",
    zone_name: "Select zone",
  });
  const getPathaoZoneList = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}pathao/zones/${pathaoCity?.city_id}`,
        {
          headers: {
            authorization: `Bearer ${token} `,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log("Pathao Zones... ", response.data.data.data);
        setPathaoZones(response.data.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (
      deliveryFormData?.deliveryName?.toLowerCase() === "pathao" &&
      pathaoCity.city_id !== ""
    )
      getPathaoZoneList();
  }, [pathaoCity.city_id]);

  useEffect(() => {
    if (
      pathaoZones.length &&
      invoiceData?.delivery_customer_address &&
      deliveryFormData?.deliveryName?.toLowerCase() === "pathao"
    ) {
      const matchedZoneId = getMatchedZoneId(
        invoiceData.delivery_customer_address,
        pathaoZones,
        invoiceData?.delivery_city
      );
      const matchedZone = pathaoZones.find((z) => z.zone_id === matchedZoneId);

      if (matchedZone) {
        setPathaoZone({
          zone_id: matchedZone.zone_id,
          zone_name: matchedZone.zone_name,
        });
      }
    }
  }, [
    pathaoZones,
    invoiceData?.delivery_customer_address,
    invoiceData?.delivery_city,
    deliveryFormData?.deliveryName,
  ]);

  const handlePathaoZoneChangeSelect = (name, option) => {
    const { value, label } = option; //some error in this code.

    setPathaoZone({
      zone_id: value,
      zone_name: label,
    });
  };

  const getMatchedZoneId = (address, zones, deliveryCity) => {
    if (!zones?.length) return null;

    // STEP 1: If delivery city exists → try direct match with zone_name
    if (deliveryCity) {
      const matchedZone = zones.find(
        (zone) =>
          zone.zone_name?.toLowerCase().trim() ===
          deliveryCity.toLowerCase().trim()
      );

      if (matchedZone) return matchedZone.zone_id;
    }

    // STEP 2: If no address, return null
    if (!address) return null;

    // STEP 3: Fallback to original match logic
    return tokenBasedMatch(address, zones) ?? fuzzyMatch(address, zones);
  };

  const matchedZoneId = getMatchedZoneId(
    invoiceData?.delivery_customer_address,
    pathaoZones
  );

  //Category List
  const getCategoryList = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}get-all-category`, {
        headers: {
          authorization: `Bearer ${token} `,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          console.log(response.data.data.data);
          setCategoryList(response.data.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getCategoryList();
  }, []);

  const handleChangeSelectCategory = (name, option) => {
    const { value, label } = option;
    console.log("name option ..", name, option);
    if (name === "category_id") {
      // If the selected category changes, filter and update the subcategories
      if (value != "Select Category") {
        setCategory(value);
      }
      if (value == "Select Category") {
        setCategory("");
      }
    }
  };

  const getCategoryProducts = () => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}top-sales-by-category`,
        {
          limit: 40,
          category_id: category,
        },
        {
          headers: {
            authorization: `Bearer ${token} `,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.success) {
          console.log("Response for filtered products..", filteredProducts);
          console.log(
            "Response for category products..",
            response.data.data.data
          );
          setFilteredProducts(response.data.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCategoryProducts();
  }, [category]);

  return (
    <div className="mt-[30px]">
      <BarcodeReader onScan={handleScan} onError={handleError} />

      <div className="flex gap-x-[2%] flex-col md:flex-row">
        <div className="w-full md:w-[60%] p-3 box-border shadow-xs bg-[#fff] rounded-[15px] mb-4 md:mb-0">
          <div className="pt-0 slider-area">
            <div className="flex justify-between md:flex-row flex-col px-0 md:px-4">
              <div>
                <p className="text-[#A0AEC0] font-nunito text-bases font-normal">
                  Home <span className="text-xs">/</span> POS
                </p>
                <p className="text-[#2D3748] font-nunito text-sm font-bold">
                  Point Of Sale
                </p>
              </div>
              <div className="flex flex-col md:flex-row gap-2 w-full md:w-[80%] items-center">
                <div className="flex relative w-full md:w-[50%]">
                                  {(type === "booking" || type === "billing") && (
                                    <div className="relative w-full flex-1">
                                      {/* <span className="absolute inset-y-0 left-0 flex items-center pl-3"></span> */}

                                      <InvoiceCustomerForm
                                        className="col-sm-12 col-md-12"
                                        formId="my_modal_2"
                                        loadingCallback={loadingCallback}
                                        navigate={navigate}
                                        setData={setCustomer}
                                        setCustomer={setCustomer}
                                        setWarningMessage={setWarningMessage}
                                        state={state}
                                        setShowModal={() => {}}
                                        filteredCustomers={state.customerList} // or any fallback, if necessary
                                        setFilteredCustomers={state.updateFilteredCustomer} // from context
                                        // showNestedModal={showNestedModal}
                                        // setShowNestedModal={setShowNestedModal}
                                        // setNestedModalData={setCustomerList}
                                        pageDesign="newSalesBilling"
                                        notify={notify}
                                      />
                                    </div>
                                  )}
                                </div>
                <div className="flex relative w-full md:w-[50%] h-[48px]">
                  <input
                    // added by saif for user type 1 & 2 keyboard navigation
                    tabIndex={1}
                    autoFocus
                    type="text"
                    className="bg-[#E5EDFF] rounded-[11px] w-[100%] pt-[17px] pr-[45px] pl-[21px] pb-[15px] placeholder:text-[#91919F]"
                    placeholder="Search Product"
                    onChange={(e) => handleInputChange(e)}
                    // added by saif for user type 1 & 2 keyboard navigation
                    onKeyDown={(e) => {
                      // Keyboard navigation for user type 1 & 2
                      if (user?.type == "1" || user?.type == "2") {
                        if (e.key === "ArrowDown") {
                          e.preventDefault();
                          setSelectedSearchIndex((prev) =>
                            prev < filteredProducts?.length - 1 ? prev + 1 : 0
                          );
                        } else if (e.key === "ArrowUp") {
                          e.preventDefault();
                          setSelectedSearchIndex((prev) =>
                            prev > 0 ? prev - 1 : filteredProducts?.length - 1
                          );
                        } else if (e.key === "Enter") {
                          e.preventDefault();
                          if (filteredProducts[selectedSearchIndex]) {
                            handleSelectedFood(
                              filteredProducts[selectedSearchIndex]
                            );
                          }
                        }
                      }
                      // Right arrow navigation to last product's quantity
                      if (
                        e.key === "ArrowRight" &&
                        e.target.selectionStart === e.target.value.length
                      ) {
                        if (orderList.length > 0) {
                          const lastProductIndex = orderList.length - 1;
                          const lastProductQuantityTabIndex =
                            type === "purchase"
                              ? lastProductIndex * 4 + 2 // Purchase: Qty, Price, Subtotal, MRP
                              : lastProductIndex * 3 + 2; // Billing: Qty, Price, Subtotal
                          document
                            .querySelector(
                              `[tabindex="${lastProductQuantityTabIndex}"]`
                            )
                            ?.focus();
                        }
                      }
                    }}
                    onFocus={() => {
                      if (user?.type == "1" || user?.type == "2") {
                        setSelectedSearchIndex(0);
                      }
                    }}
                  />
                  <div className="mx-auto my-auto absolute top-[20px] right-[17px] ">
                    <AiOutlineSearch className="text-base text-[#407BFF] font-bold"></AiOutlineSearch>
                  </div>
                </div>
                {/* <label
                  htmlFor="my_modal_product"
                  onClick={handleQuickProductFormClick}
                  className="flex w-[5%]  justify-center items-center bg-[#407BFF] text-[#FFF] text-[11px] font-nunito font-bold py-2 px-4 cursor-pointer rounded-[5px] capitalize"
                >
                  <i className="fa-solid fa-plus"></i>
                </label> */}
              </div>
            </div>
            {loading && (
              <div className="custom-loader-logo">
                <img
                  className=""
                  src={`${process.env.REACT_APP_ROOT_URL + "/smallLogo.png"}`}
                  alt="logo"
                />
              </div>
            )}

            {user?.type !== "1" && user?.type !== "2" && user?.type !== "4" && (
              <>
                {searchKeyword &&
                filteredProducts?.length > 0 &&
                filteredProducts?.length < 5 ? (
                  <div className="searchList sliderArea">
                    {filteredProducts?.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          console.log("Inside.... Search click of slider.");
                          if (item?.have_product_variant === 1) {
                            setSelectedFood(item);
                            setProductVariantIndex(index);
                            setProductVariants(item?.product_variants);
                          } else {
                            handleSelectedFood(item);
                          }
                        }}
                        className="flex flex-col gap"
                      >
                        {/* <div>{console.log(filteredProducts)}</div> */}
                        <div
                          className={`overflow-hidden border-2 ${
                            item?.current_stock === 0
                              ? "border-[#ca1830]"
                              : item?.current_stock <= 5
                              ? "border-[#FBBC05]"
                              : "border-[#18CA29]"
                          } bg-white mr-[20px] shadow-sm rounded-[16px] single-product hover:scale-[1.2] hover:sticky hover:z-10  transform duration-300  relative md:mr-[25px]`}
                        >
                          {/* <img src={item.foodImg} alt="" /> */}
                          <img
                            src={item?.image_path ? item.image_path : shop_logo}
                            alt="categoryDymmyImaage"
                            className="w-[130px] lg:w-[150px] object-contain rounded-tl-[16px] rounded-tr-[16px]"
                          />
                          <div className="mt-[10px] text-center flex justify-center items-center h-[62px] font-nunito text-sm px-1.5 w-[150px] font-bold">
                            <p className="break-words">
                              {item?.name?.length > 28
                                ? eclipse(item.name, 28)
                                : item.name}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (searchKeyword && filteredProducts?.length > 3) ||
                  filteredProducts?.length > 3 ? (
                  <div>
                    <div className="parent-sliderArea mb-[40px] md:mb-[0px]">
                      <Slider {...settings}>
                        {filteredProducts?.map((item, index) => (
                          <div
                            key={index}
                            // onClick={() => {
                            //   // setCategory(item.id);
                            //   // setCategoryName(item.name);
                            //   handleSelectedFood(item);
                            // }}

                            onClick={() => {
                              console.log(
                                "Inside.... Search second click of slider.",
                                item
                              );

                              if (item?.imeis?.length) {
                                //handleSelectedImeis(item);
                                handleSelectedFood(item);
                              } else if (item?.have_product_variant === 1) {
                                setSelectedFood(item);
                              } else {
                                handleSelectedFood(item);
                              }
                            }}
                            className="flex flex-col justify-center items-center"
                          >
                            <div
                              className={`overflow-hidden border-2 ${
                                item?.current_stock === 0
                                  ? "border-[#ca1830]"
                                  : item?.current_stock <= 5
                                  ? "border-[#FBBC05]"
                                  : "border-[#18CA29]"
                              } bg-white mr-[20px] shadow-sm rounded-[16px] single-product hover:scale-[1.2] hover:sticky hover:z-10  transform duration-300  relative md:mr-[25px]`}
                            >
                              {/* <img
                            src={item?.image_path ? item.image_path : shop_logo}
                            alt="categoryDymmyImaage"
                            className="w-[130px] lg:w-[125px] object-cover rounded-tl-[16px] rounded-tr-[16px]"
                          /> */}
                              <div className="w-[150px] flex justify-center ">
                                <img
                                  src={
                                    item.image_path
                                      ? item.image_path
                                      : shop_logo
                                  }
                                  alt="categoryDymmyImaage"
                                  className="h-[140px] object-contain"
                                />
                              </div>
                              <div className="mt-[10px] text-center flex justify-center items-center h-[62px] font-nunito text-sm px-1.5 w-[150px] font-bold">
                                {/*  */}
                                <p className="break-words">
                                  {item.name.length > 28
                                    ? eclipse(item.name, 28)
                                    : item.name}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>
                ) : (
                  <div className="searchList sliderArea !justify-start">
                    {loader && (
                      <div className="w-full relative px-[27px] overflow-x-auto sm:rounded-lg">
                        {" "}
                        <div className="custom-loader"></div>{" "}
                      </div>
                    )}

                    {console.log("CUSTOMER.... ", customer)}
                    {console.log("filteredProducts...", filteredProducts)}

                    {Array.isArray(filteredProducts) && filteredProducts?.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          // setCategory(item.id);
                          // setCategoryName(item.name);
                          console.log("inside...........onClick,", item);
                          if (item.have_product_variant === 1) {
                            console.log("selectedfood selected.........");
                            setSelectedFood(item);
                            setProductVariantIndex(index);
                            setProductVariants(item?.product_variants);
                          } else {
                            handleSelectedFood(item);
                          }
                        }}
                        className="flex flex-col min-w-[152px] justify-center items-center "
                      >
                        {console.log("ITEM...,", item)}
                        <div
                          className={`overflow-hidden border-2 ${
                            item?.current_stock === 0
                              ? "border-[#ca1830]"
                              : item?.current_stock <= 5
                              ? "border-[#FBBC05]"
                              : "border-[#18CA29]"
                          } bg-white mr-[20px] shadow-sm rounded-[16px] single-product hover:scale-[1.2] hover:sticky hover:z-10  transform duration-300  relative md:mr-[25px]`}
                        >
                          {/* <img src={item.foodImg} alt="" /> */}
                          <img
                            src={item?.image_path ? item.image_path : shop_logo}
                            alt="categoryDymmyImaage"
                            className="w-[150px] object-contain rounded-tl-[16px] rounded-tr-[16px]"
                          />
                          <div className="mt-[10px] text-center flex justify-center items-center h-[62px] font-nunito text-sm px-1.5 w-[150px] font-bold">
                            <p className="break-words">
                              {item?.name?.length > 28
                                ? eclipse(item.name, 28)
                                : item.name}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>

          <ToastContainer />

          {/* {searchKeyword !== '' && modifiedFilteredProducts.length != 0 ? ( */}
          <div className="">
            <div className="flex flex-col mt-[0px] md:mt-[10px] mb-[20px] px-0 md:px-3">
              <div>
                {/* pagination component */}
                {user?.type !== "1" &&
                  user?.type !== "2" &&
                  user?.type !== "4" &&
                  shouldRenderPagination && (
                    <Pagination
                      lastPage={pagination.last_page}
                      currentPage={currentPage}
                      onPageChange={onPageChange}
                    />
                  )}
              </div>
              {/* {user?.type == 4 && (
                <div className="px-2 my-3 w-[800px]">
                  <div className="overflow-x-auto w-full">
                    <div className="flex items-center gap-2 whitespace-nowrap py-2 px-2 rounded-lg bg-gray-100 min-w-max">
                      {categoryList.map((cat) => (
                        <button
                          key={cat.id}
                          onClick={() =>
                            handleChangeSelectCategory("category_id", {
                              value: cat.id,
                              label: cat.name,
                            })
                          }
                          className={`px-3 py-1.5 text-sm rounded-full border transition-colors duration-200
                              ${
                                category === cat.id
                                  ? "bg-blue-600 text-white border-blue-600"
                                  : "bg-white text-gray-800 border-gray-300 hover:bg-blue-50"
                              }`}
                        >
                          {cat.name}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )} */}

              {/* Catogory section for restaurant */}
              {user?.type == "4" && (
                <div className="flex items-center justify-center max-w-full">
                  <div className="px-2 my-1 w-[45vw] overflow-x-auto">
                    <div className="flex items-stretch gap-3 whitespace-nowrap py-2 px-1">
                      {categoryList?.map((cat) => {
                        const isActive = category === cat.id;
                        const count = Array.isArray(cat?.sub_category)
                          ? cat.sub_category.length
                          : 0;
                        const imgSrc = cat?.image_url || cat?.banner;

                        return (
                          <button
                            key={cat.id}
                            onClick={() =>
                              handleChangeSelectCategory("category_id", {
                                value: cat.id,
                                label: cat.name,
                              })
                            }
                            aria-selected={isActive}
                            className={`flex-none inline-flex flex-col items-start justify-center min-w-[120px] px-4 py-3 rounded-2xl border shadow-sm transition-all
                ${
                  isActive
                    ? "bg-blue-50 border-blue-200 ring-2 ring-blue-300"
                    : "bg-white border-gray-200 hover:bg-gray-50"
                }`}
                          >
                            <div
                              className={`flex items-center justify-center w-10 h-10 rounded-lg overflow-hidden
                  ${
                    isActive
                      ? "bg-blue-100 text-blue-600"
                      : "bg-gray-100 text-gray-700"
                  }`}
                            >
                              {imgSrc ? (
                                <img
                                  src={imgSrc}
                                  alt={cat?.name || "Category"}
                                  className="w-full h-full object-cover"
                                />
                              ) : (
                                <svg
                                  className="w-5 h-5"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="1.8"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2zM7 17h10"
                                  />
                                </svg>
                              )}
                            </div>

                            <div
                              className={`mt-2 text-sm font-semibold ${
                                isActive ? "text-blue-700" : "text-gray-800"
                              }`}
                            >
                              {cat.name}
                            </div>
                            {/* <div className={`text-xs ${isActive ? "text-blue-600" : "text-gray-500"}`}>
                {count} Items
              </div> */}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

              {user?.type !== "1" &&
                user?.type !== "2" &&
                user?.type !== "4" && (
                  <>
                    <div className="flex justify-between">
                      <h4 className="text-[#000232] font-nunito text-[23px] font-bold">
                        Menu
                      </h4>
                      <h4
                        className={`${
                          !shouldRenderPagination && "right-0"
                        } text-[#00023252] ml-5 font-nunito text-lg font-bold px-3`}
                      >
                        {pagination && pagination.total} Results
                      </h4>
                    </div>
                  </>
                )}
            </div>
            <div className="foodList p-2.5 cursor-pointer">
              {
                isType4EditBillingView ? ((
                                  <Type4BillingGrid
                                    products={
                                      user?.type == "1" || user?.type == "2"
                                        ? filteredProducts
                                        : modifiedFilteredProducts
                                    }
                                    formatPrice={formatPrice}
                                    invoiceSetting={invoiceSetting}
                                    onItemClick={(item) =>
                                      item?.imeis?.length && type !== "purchase"
                                        ? handleSelectedImeis(item)
                                        : handleSelectedFood(item)
                                    }
                                    type={type}
                                  />
                                )) :
                (
                  <div className="flex flex-col sm:flex-row gap-[2%]">
                {(selectedFood?.have_product_variant == null ||
                  selectedFood?.have_product_variant == 0) && (
                  <div
                    // className={`w-[100%] sm:w-[47%] md:w-[47%] h-[561px] overflow-y-auto custom-scrollbar`}
                    // added by saif
                    className={`${
                      user?.type == "1" || user?.type == "2" || user?.type == "4"
                        ? "w-[100%]"
                        : "w-[100%] sm:w-[47%] md:w-[47%]"
                    } h-[561px] overflow-y-auto custom-scrollbar`}
                  >
                    {user?.type == "1" || user?.type == "2" ? (
                      <>
                        {/* Table layout for user types 1 & 2 (like the image) */}
                        <div className="w-full">
                          {/* Table Header */}
                          <div className="flex bg-gray-100 p-2 font-semibold text-sm border-b">
                            <div className="w-12">No.</div>
                            <div className="flex-1">Name</div>
                            <div className="w-20 text-center">Stock</div>
                            <div className="w-24 text-center">
                              Purchase Price
                            </div>
                            <div className="w-20 text-center">Price</div>
                          </div>

                          {/* Table Rows */}
                          {(user?.type == "2"
                            ? filteredProducts
                            : modifiedFilteredProducts
                          ).map((item, index) => (
                            <div
                              key={index}
                              onClick={() => handleSelectedFood(item)}
                              onMouseEnter={() => setSelectedSearchIndex(index)}
                              className={`flex items-center border-b py-2 cursor-pointer hover:bg-gray-50 ${
                                index === selectedSearchIndex
                                  ? "bg-blue-50 border-blue-200"
                                  : ""
                              }`}
                            >
                              <div className="w-12 px-2">{index + 1}</div>
                              <div className="flex-1 px-2 font-medium">
                                {item.name}
                              </div>
                              <div className="w-20 text-center">
                                {item.current_stock}
                              </div>
                              <div className="w-24 text-center">
                                {Number.parseFloat(item.purchase_price).toFixed(
                                  2
                                )}{" "}
                                BDT
                              </div>
                              <div className="w-20 text-center">
                                {Number.parseFloat(item.retails_price).toFixed(
                                  2
                                )}{" "}
                                BDT
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    ) : (
                      <div className="w-[96%] ml-[3px] mt-[3px]">
                        {/* Filtered Project list */}
                        {modifiedFilteredProducts.map((item, index) => {
                          let discount = 0;
                          if (
                            (item?.discount_type == "Percentage" ||
                              item?.discount_type == "2") &&
                            item?.discount
                          ) {
                            discount =
                              type === "purchase"
                                ? formatPrice(0)
                                : formatPrice(
                                    item.retails_price * (item.discount / 100)
                                  );
                          } else {
                            discount =
                              type === "purchase"
                                ? formatPrice(0)
                                : formatPrice(item?.discount);
                          }
                          return (
                            <div
                              onClick={() => {
                                handleSelectedFood(item);
                              }}
                              className={`${
                                selectedFood ? "w-[100%]" : "w-[100%]"
                              } flex align-top bg-transparent bg-base-100 mb-6 gap-2 rounded-[18px] p-2 shadow-none single-product-item border-2
                          ${
                            item?.current_stock === 0
                              ? "border-[#ca1830]"
                              : item?.current_stock <= 5
                              ? "border-[#FBBC05]"
                              : "border-[#18CA29]"
                          }`}
                              key={index}
                            >
                              {/* <div className="w-[90px] min-w-[90px] max-h[70px]"> */}
                              <div className="w-14 h-14">
                                <img
                                  // className="w-[90px] min-h-[70px] max-h-[70px] rounded-[16px] object-cover"
                                  className="h-full w-full rounded-lg object-contain"
                                  src={
                                    item?.image_path
                                      ? item.image_path
                                      : shop_logo
                                  }
                                  alt="Movie"
                                />
                              </div>

                              <div className="flex-1">
                                <div>
                                  <h2 className="text-[#000] font-nunito text-sm px-1 font-bold mb-[2px]">
                                    {/* {eclipse(item.name, 10)} */}
                                    {item.name}
                                  </h2>

                                  {item?.category?.name && (
                                    <p className="text-sm mb-[2px]">
                                      {item?.category?.name}
                                    </p>
                                  )}
                                </div>
                                <div className="flex flex-wrap gap-1 text-[#000] font-nunito text-xs font-bold">
                                  <div className="whitespace-nowrap">
                                    {formatPrice(
                                      type === "purchase"
                                        ? item.purchase_price - discount
                                        : item.retails_price - discount
                                    )}
                                    <span className="text-xs">
                                      {invoiceSetting?.currency_info?.code
                                        ? invoiceSetting.currency_info.code
                                        : "BDT"}
                                    </span>
                                  </div>
                                  {discount != 0 &&
                                    (type === "booking" ||
                                      type === "billing") && (
                                      <div className="flex gap-1 items-end pb-1 text-red-500 line-through text-xs whitespace-nowrap">
                                        {formatPrice(item.retails_price)}
                                        <span className="text-xs">
                                          {invoiceSetting?.currency_info?.code
                                            ? invoiceSetting.currency_info.code
                                            : "BDT"}
                                        </span>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
                {(selectedFood?.have_product_variant == null ||
                  selectedFood?.have_product_variant ==
                    0) /* && user?.type != 4 */ && (
                  <div
                    className={`${
                      user?.type == "1" || user?.type == "2" || user?.type == "4"
                        ? "hidden"
                        : "block"
                    } w-[100%] mt-[35px] sm:mt-0 sm:w-[53%] md:w-[53%] `}
                  >
                    {selectedFood
                      ? (() => {
                          let discount = 0;
                          if (
                            (selectedFood?.discount_type == "Percentage" ||
                              selectedFood?.discount_type == "2") &&
                            selectedFood?.discount
                          ) {
                            discount =
                              type === "purchase"
                                ? formatPrice(0)
                                : formatPrice(
                                    selectedFood.retails_price *
                                      (selectedFood.discount / 100)
                                  );
                          } else {
                            discount =
                              type === "purchase" ||
                              (type == "billing" && salesType == "wholesale")
                                ? 0
                                : selectedFood?.discount;
                          }
                          return (
                            (selectedFood?.have_product_variant == null ||
                              selectedFood?.have_product_variant == 0) && (
                              <div className="shadow-md h-[100%] rounded-[18px] bg-base-100 p-[10px] mb-3 single-product-item ">
                                <div className="block border-0">
                                  <div className="">
                                    <img
                                      className="w-full sm:max-w-[390px] 2xl:max-w-[442px] m-auto rounded-[16px] object-cover "
                                      src={
                                        selectedFood?.image_path &&
                                        selectedFoodImg
                                          ? selectedFoodImg
                                          : selectedFood?.image_path
                                          ? selectedFood.image_path
                                          : shop_logo
                                      }
                                      alt="Movie"
                                    />
                                  </div>
                                  {selectedFood?.image_path1 ||
                                  selectedFood?.image_path1 ? (
                                    <div className="flex gap-[2.5%] mt-[16px]">
                                      {selectedFood.image_path && (
                                        <img
                                          className="w-[90px] h-[62px] md:w-[60px] md:h-[50px] lg:w-[90px] lg:h-[62px] object-cover rounded-[8px]"
                                          src={selectedFood.image_path}
                                          onClick={() => {
                                            handleSelectedFoodImage(
                                              selectedFood.image_path
                                            );
                                          }}
                                          alt=""
                                        />
                                      )}

                                      {selectedFood.image_path1 && (
                                        <img
                                          className="w-[90px] h-[62px] md:w-[60px] md:h-[50px] lg:w-[90px] lg:h-[62px] object-cover rounded-[8px]"
                                          src={selectedFood.image_path1}
                                          alt=""
                                          onClick={() => {
                                            handleSelectedFoodImage(
                                              selectedFood.image_path1
                                            );
                                          }}
                                        />
                                      )}

                                      {selectedFood.image_path2 && (
                                        <img
                                          className="w-[90px] h-[62px] md:w-[60px] md:h-[50px] lg:w-[90px] lg:h-[62px] object-cover rounded-[8px]"
                                          src={selectedFood.image_path2}
                                          alt=""
                                          onClick={() => {
                                            handleSelectedFoodImage(
                                              selectedFood.image_path2
                                            );
                                          }}
                                        />
                                      )}
                                    </div>
                                  ) : null}

                                  <div className="w-[100%] mt-2.5">
                                    <div className="flex flex-row items-center gap-2">
                                      <p className="text-[#000] font-nunito text-[24px] font-bold mb-[2px]">
                                        {selectedFood.name}
                                      </p>

                                      {selectedFood?.brands?.name && (
                                        <p className="text-[16px] mb-[2px]">
                                          {selectedFood?.brands?.name}
                                        </p>
                                      )}
                                    </div>

                                    <div>
                                      {selectedFood?.category?.name && (
                                        <p className="text-base mb-[2px]">
                                          {selectedFood?.category?.name}
                                        </p>
                                      )}
                                    </div>

                                    <div>
                                      {selectedFood?.current_stock && (
                                        <p className="text-[16px] mb-[2px]">
                                          Quantity:{" "}
                                          <span className="font-bold">
                                            {Number.parseFloat(
                                              selectedFood?.current_stock
                                            ).toFixed(2)}{" "}
                                            {selectedFood?.unit?.name}
                                          </span>
                                        </p>
                                      )}
                                    </div>

                                    <div className="flex flex-wrap justify-between gap-1 text-[#000] font-nunito text-lg font-bold">
                                      <div className="flex gap-1">
                                        <span>
                                          {type == "billing" &&
                                          salesType == "wholesale"
                                            ? formatPrice(
                                                selectedFood?.wholesale_price
                                              )
                                            : formatPrice(
                                                selectedFood?.retails_price -
                                                  discount
                                              )}
                                        </span>
                                        <span className="text-xs pt-2">
                                          {invoiceSetting?.currency_info?.code
                                            ? invoiceSetting?.currency_info
                                                ?.code
                                            : "BDT"}
                                        </span>
                                        {discount != 0 &&
                                          (type === "booking" ||
                                            type === "billing") && (
                                            <>
                                              <span className="text-red-500 line-through text-xs pt-2">
                                                {" "}
                                                {formatPrice(
                                                  selectedFood.retails_price
                                                )}
                                              </span>
                                              <span className="text-xs pt-2">
                                                {invoiceSetting?.currency_info
                                                  ?.code
                                                  ? invoiceSetting
                                                      ?.currency_info?.code
                                                  : "BDT"}
                                              </span>
                                            </>
                                          )}
                                      </div>

                                      {/* <div className="flex flex-row gap-1">
                                    <img
                                      style={{ width: "20px", height: "20px" }}
                                      src={wholeSale}
                                      alt=""
                                    />
                                    {formatPrice(selectedFood.purchase_price)}
                                    <span className="text-xs pt-2">
                                      {invoiceSetting?.currency_info?.code
                                        ? invoiceSetting?.currency_info?.code
                                        : " BDT"}
                                    </span>
                                  </div> */}
                                    </div>
                                    <div className="py-2">
                                      {type !== "purchase" &&
                                      type === "billing" &&
                                      selectedFood?.imeis?.length > 0 ? (
                                        <div>
                                          <div className="rounded-[15px] border-[1px] border-solid border-[#F1F1FA] px-[12px] py-[15px] mb-[20px]">
                                            <div className="flex justify-between items-center mb-2 gap-3">
                                              <div className="font-lato font-[700] text-[12px] text-[#000232]">
                                                List Of Variations
                                              </div>

                                              <input
                                                type="text"
                                                placeholder="Search by IMEI"
                                                className="px-3 py-1 border-[1px] border-[#E7EBF4] rounded-[8px] text-[12px]"
                                                value={searchVarientItem}
                                                onChange={(e) =>
                                                  setSearchVarientItem(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </div>

                                            <div className="grid grid-cols-[min-content_1fr_1fr_1fr] gap-2 font-nunito font-bold text-[12px] text-[#000232] border-b-[1px] border-solid border-[#E7EBF4]">
                                              <div className="py-[5px]"></div>
                                              <div className="py-[5px]">
                                                Condition
                                              </div>
                                              <div className="py-[5px] text-center">
                                                Price
                                              </div>
                                              <div className="py-[5px]">
                                                IMEI/SL
                                              </div>
                                            </div>
                                            {filteredImeis.map(
                                              (imei, index) => (
                                                <div
                                                  key={index}
                                                  className={`grid grid-cols-[min-content_1fr_1fr_1fr] gap-2 font-nunito font-[400] text-[14px] text-[#000232] ${
                                                    index ===
                                                    filteredImeis.length - 1
                                                      ? ""
                                                      : "border-b-[1px]"
                                                  } border-solid border-[#E7EBF4]`}
                                                >
                                                  <div className="py-[4px] flex items-center justify-center">
                                                    <input
                                                      type="checkbox"
                                                      checked={selectedImeis.includes(
                                                        imei.id
                                                      )}
                                                      onChange={() => {
                                                        setSelectedImei(
                                                          imei.id
                                                        );
                                                        toggleImeiSelection(
                                                          imei
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="py-[5px] flex items-center">
                                                    {imei?.item_condition}
                                                  </div>
                                                  <div className="py-[5px] flex items-center justify-center">
                                                    {type === "billing"
                                                      ? imei?.currency_rate !==
                                                        null
                                                        ? Number.parseFloat(
                                                            imei?.sale_price
                                                          ).toFixed(2)
                                                        : Number.parseFloat(
                                                            imei?.sale_price
                                                          ).toFixed(2)
                                                      : imei?.currency_rate !==
                                                        null
                                                      ? Number.parseFloat(
                                                          imei?.purchase_price
                                                        ).toFixed(2)
                                                      : Number.parseFloat(
                                                          imei?.purchase_price
                                                        ).toFixed(2)}
                                                    {imei?.currency_rate !==
                                                    null
                                                      ? imei?.base_currency_code
                                                      : imei.purchase_currency_code}
                                                  </div>
                                                  <div className="py-[5px] flex items-center">
                                                    {imei?.imei}
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          );
                        })()
                      : null}
                  </div>
                )}
                {selectedFood?.have_product_variant == 1 &&
                  type != "purchase" && (
                    <div className="w-[100%] mt-[35px] sm:mt-0 sm:w-[100%] md:w-[100%]">
                      {console.log("SelectedFood SAYEM........ ", selectedFood)}
                      {console.log("orderList SAYEM........ ", orderList)}
                      <form className="space-y-3 max-h-[300px] overflow-y-auto px-2">
                        {selectedFood.product_variants?.map((variant) => (
                          <label
                            key={variant.id}
                            className="grid grid-cols-3 items-center gap-4 px-4 py-2 border rounded cursor-pointer hover:bg-gray-100"
                          >
                            {/* Variant name and price */}
                            <div>
                              <p className="font-medium">{variant.name}</p>
                              {variant.price && (
                                <p className="text-sm text-gray-500">
                                  Price: {variant.price}
                                </p>
                              )}
                            </div>

                            {/* Quantity */}
                            <div className="flex flex-col items-center">
                              <p className="font-medium">Quantity</p>
                              {variant.quantity && (
                                <p className="text-sm text-gray-500">
                                  {variant.quantity}
                                </p>
                              )}
                            </div>

                            {/* Checkbox */}
                            <div className="flex justify-end">
                              <input
                                type="checkbox"
                                checked={selectedVariantId === variant.id}
                                onChange={() =>
                                  handleSelectVariant(
                                    /////////////////////
                                    variant.id,
                                    variant.name,
                                    variant.price,
                                    variant.quantity
                                  )
                                }
                                className="w-5 h-5 text-blue-600 border-gray-300 rounded"
                              />
                            </div>
                          </label>
                        ))}
                      </form>
                    </div>
                  )}
              </div>
                )
              }
            </div>
          </div>
          {/* ): null} */}
        </div>
        {/* bill - right div */}
        <div className="w-full md:w-[40%] bg-[#fff] shadow-xs rounded-[15px] px-[15px] box-border relative">
          <h4 className="text-[#000232] font-nunito font-bold text-lg pt-[18px] pb-[12px] ">
            Bills
          </h4>
          <div className="mt-[10px] mb-5">
            {orderList &&
              orderList.length > 0 &&
              (user?.type == "1" || user?.type == "2") && (
                <div className="flex items-center bg-gray-100 p-1 font-semibold text-sm border-b">
                  <div className="w-8">#</div>
                  <div className="flex-1">Product Name</div>
                  <div
                    className={`w-24 ${
                      type === "billing" ? "text-center flex-1" : "text-center"
                    }`}
                  >
                    Quantity
                  </div>
                  <div className="w-20 text-center">
                    {type == "purchase" ? "Pur. Price" : "Price"}
                  </div>
                  <div className="w-20 text-center">Total Price</div>
                  {type === "purchase" && (
                    <div className="w-20 text-center">MRP</div>
                  )}
                  <div className="w-8"></div> {/* For remove button */}
                </div>
              )}
            <div
              className={`p-[5px] ${
                orderList.length > 4
                  ? "h-[400px] overflow-y-scroll overflow-x-hidden"
                  : "overflow-hidden"
              }`}
            >
              {orderList &&
                orderList.map((orderFood, inx) => {
                  let discount = 0;
                  // let subTotalPrice = 0;
                  if (
                    (orderFood?.product_info?.discount_type == "Percentage" ||
                      orderFood?.product_info?.discount_type == "2") &&
                    orderFood?.product_info?.discount
                  ) {
                    discount =
                      type === "purchase" ||
                      (type == "billing" && salesType == "wholesale")
                        ? formatPrice(0)
                        : formatPrice(
                            orderFood?.product_info?.retails_price *
                              (orderFood?.product_info?.discount / 100)
                          );
                  } // Check discount_type in orderFood if not found in product_info
                  else if (orderFood?.imeis) {
                  } else if (
                    (orderFood?.discount_type === "Percentage" ||
                      orderFood?.discount_type === "2") &&
                    orderFood?.discount
                  ) {
                    discount =
                      type === "purchase"
                        ? formatPrice(0)
                        : formatPrice(
                            orderFood?.retails_price *
                              (orderFood?.discount / 100)
                          );
                  } else {
                    discount =
                      type === "purchase"
                        ? 0
                        : (orderFood?.product_info?.discount ||
                            orderFood?.discount) ??
                          0;
                  }
                  //discount = orderFood.current_stock * orderFood.discount;
                  let subtotalPrice = 0;
                  if (type == "billing" && salesType == "wholesale" && (typeSaleEdit && !orderFood.isExchange)) {
                    console.log("Inside................1");
                    subtotalPrice = formatPrice(
                      orderFood.qty *
                        (orderFood?.product_info?.wholesale_price ||
                          orderFood?.wholesale_price)
                    );
                    subtotal += Number(subtotalPrice);
                  } else if (type == "purchase" && !typePurchase && (typeSaleEdit && !orderFood.isExchange)) {
                    console.log("Inside................2");
                    console.log("exec");
                    subtotalPrice = formatPrice(
                      orderFood.qty *
                        (orderFood?.invoice_id
                          ? orderFood?.product_info?.purchase_price
                          : orderFood?.purchase_price)
                    );
                    subtotal += Number(subtotalPrice);
                  } else if (type == "purchase" && typePurchase && (typeSaleEdit && !orderFood.isExchange)) {
                    console.log("Inside................3");
                    subtotalPrice = formatPrice(
                      orderFood.qty *
                        (orderFood?.invoice_id
                          ? orderFood?.price
                          : orderFood?.purchase_price)
                    );
                    subtotal += Number(subtotalPrice);
                  } /* else if((typeSaleEdit && orderFood.onExchange)){
                    console.log("Inside................ 2nd (typeSaleEdit && !orderFood.onExchange)")
                    subtotalPrice =  orderFood.onExchange
                      ? orderFood.qty * orderFood.price * -1
                      : orderFood.qty *
                            ((orderFood?.price || orderFood?.retails_price) -
                              discount)

                    console.log("subtotalPrice... ",subtotalPrice)

                    subtotal += Number(subtotalPrice);
                    console.log("subtotal... ",subtotal)
                  } */ else {
                    console.log("Inside................else");
                    subtotalPrice =  orderFood.onExchange
                      ? orderFood.qty * orderFood.price * -1
                      : orderFood.qty *
                            ((orderFood?.price || orderFood?.retails_price) -
                              discount)
                    console.log("subtotalPrice... ",subtotalPrice)
                    subtotal += Number(subtotalPrice);
                    console.log("subtotal... ",subtotal)
                  }
                  //vats = formatPrice(0.15 * subtotal);
                  //taxes = formatPrice(0.1 * subtotal);
                  const qty = `x${orderFood.qty}`;
                  if (user?.type == "1" || user?.type == "2") {
                    return (
                      <div
                        key={inx}
                        className="flex items-center justify-between w-full border-b-2 border-gray-200 py-2 text-sm font-nunito"
                      >
                        {/* No. Column */}
                        <div className="w-[5%] px-1 text-gray-500">
                          {inx + 1}
                        </div>

                        {/* Name Column */}
                        <div className="w-[36%] px-2">
                          <div className="flex flex-col">
                            <h4 className="font-medium break-words whitespace-normal">
                              {orderFood?.product_info?.name || orderFood?.name}
                              {orderFood?.product_variant_id && (
                                <span className="font-medium">
                                  {" "}
                                  {orderFood?.product_variant?.name}
                                </span>
                              )}
                            </h4>
                          </div>
                        </div>

                        {/* Quantity Column */}
                        <div className="w-[15%] mr-2">
                          <div className="flex items-center justify-center space-x-1">
                            <button
                              className="p-1 text-gray-500 bg-gray-100 rounded-md"
                              onClick={() =>
                                handleSelectedFood(
                                  orderFood,
                                  "decrement",
                                  user.type,
                                  "decrement",
                                  inx
                                )
                              }
                            >
                              <FontAwesomeIcon icon={faAngleLeft} />
                            </button>
                            <div className="bg-gray-100 px-1 rounded-md">
                              <input
                                tabIndex={
                                  user?.type == "1" || user?.type == "2"
                                    ? inx * (type == "purchase" ? 4 : 3) + 2
                                    : undefined
                                }
                                type="text"
                                value={`x${orderFood?.qty || ""}`}
                                className="w-[40px] py-1 text-center bg-transparent outline-none"
                                onChange={(e) =>
                                  handleSelectedItemQty129(orderFood, "qty", e)
                                }
                                onKeyDown={(e) => {
                                  if (
                                    (user?.type == "1" || user?.type == "2") &&
                                    (e.key === "Enter" ||
                                      e.key === "ArrowRight")
                                  ) {
                                    document
                                      .querySelector(
                                        `[tabindex="${
                                          inx * (type === "purchase" ? 4 : 3) +
                                          3
                                        }"]`
                                      )
                                      ?.focus();
                                  }
                                }}
                              />
                            </div>
                            <button
                              className="p-1 text-gray-500 bg-gray-100 rounded-md"
                              onClick={() =>
                                handleSelectedFood(
                                  orderFood,
                                  "increment",
                                  user.type,
                                  "increment",
                                  inx
                                )
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                            </button>
                          </div>
                        </div>

                        {/* Price Column */}
                        <div className="w-[19%] px-2">
                          {user?.type == "1" || user?.type == "2" ? (
                            <input
                              tabIndex={
                                user?.type == "1" || user?.type == "2"
                                  ? inx * (type === "purchase" ? 4 : 3) + 3
                                  : undefined
                              }
                              type="text"
                              value={
                                type === "purchase"
                                  ? editablePrices[orderFood.id] !== undefined
                                    ? editablePrices[orderFood.id]
                                    : orderFood?.purchase_price
                                    ? parseFloat(
                                        orderFood.purchase_price
                                      ).toFixed(2)
                                    : orderFood?.product_info?.purchase_price
                                    ? parseFloat(
                                        orderFood.product_info.purchase_price
                                      ).toFixed(2)
                                    : ""
                                  : editablePrices[orderFood.id] !== undefined
                                  ? editablePrices[orderFood.id]
                                  : orderFood?.price
                                  ? parseFloat(orderFood.price).toFixed(2)
                                  : ""
                              }
                              className="w-full text-right bg-gray-100 rounded-md px-2 py-1"
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (
                                  inputValue === "" ||
                                  inputValue.match(/^\d*\.?\d*$/)
                                ) {
                                  setEditablePrices((prev) => ({
                                    ...prev,
                                    [orderFood.id]: inputValue,
                                  }));
                                  const newPrice =
                                    inputValue === ""
                                      ? 0
                                      : Number.parseFloat(inputValue) || 0;
                                  handleSelectedFoodPrice(
                                    orderFood,
                                    newPrice,
                                    inx
                                  );
                                }
                              }}
                              onKeyDown={(e) => {
                                if (
                                  (user?.type == "1" || user?.type == "2") &&
                                  (e.key === "Enter" || e.key === "ArrowRight")
                                ) {
                                  document
                                    .querySelector(
                                      `[tabindex="${
                                        inx * (type === "purchase" ? 4 : 3) + 4
                                      }"]`
                                    )
                                    ?.focus();
                                }
                              }}
                              onFocus={(e) => e.target.select()}
                            />
                          ) : (
                            // Your existing price input for other user types
                            <input
                              type="text"
                              value={orderFood?.price || ""}
                              className="w-full text-right bg-gray-100 rounded-md px-2 py-1"
                              onChange={(e) =>
                                handleSelectedFoodPrice(
                                  orderFood,
                                  e.target.value,
                                  inx
                                )
                              }
                              onFocus={(e) => e.target.select()}
                            />
                          )}
                        </div>

                        {/* Subtotal Column */}
                        <div className="w-[15%] px-2 text-right font-medium">
                          {user?.type == "1" || user?.type == "2" ? (
                            <input
                              tabIndex={
                                user?.type == "1" || user?.type == "2"
                                  ? inx * (type === "purchase" ? 4 : 3) + 4
                                  : undefined
                              }
                              type="text"
                              value={
                                type === "purchase"
                                  ? editableSubtotals[orderFood.id] !==
                                    undefined
                                    ? editableSubtotals[orderFood.id]
                                    : (
                                        (orderFood.purchase_price ||
                                          orderFood.price) * orderFood.qty
                                      ).toFixed(2)
                                  : (
                                      orderFood.price * orderFood.qty || 0
                                    ).toFixed(2)
                              }
                              className="w-full text-right bg-gray-100 rounded-md px-2 py-1"
                              // onChange={(e) => {
                              //   const inputValue = e.target.value;
                              //   if (
                              //     inputValue === "" ||
                              //     inputValue.match(/^\d*\.?\d*$/)
                              //   ) {
                              //     if (type === "purchase") {
                              //       const newSubtotal =
                              //         inputValue === ""
                              //           ? 0
                              //           : Number.parseFloat(inputValue) || 0;
                              //       const newUnitPrice =
                              //         orderFood.qty > 0
                              //           ? newSubtotal / orderFood.qty
                              //           : 0;
                              //       setEditableSubtotals((prev) => ({
                              //         ...prev,
                              //         [orderFood.id]: inputValue,
                              //       }))

                              //       handleSelectedFoodPrice(
                              //         orderFood,
                              //         newUnitPrice,
                              //         inx
                              //       );
                              //     }
                              //   }
                              // }}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                // Validate input - only allow numbers and decimal point
                                if (
                                  inputValue === "" ||
                                  inputValue.match(/^\d*\.?\d*$/)
                                ) {
                                  if (type === "purchase") {
                                    const newSubtotal =
                                      inputValue === ""
                                        ? 0
                                        : Number.parseFloat(inputValue) || 0;
                                    const newUnitPrice =
                                      orderFood.qty > 0
                                        ? newSubtotal / orderFood.qty
                                        : 0;

                                    // Update the editable subtotals state
                                    setEditableSubtotals((prev) => ({
                                      ...prev,
                                      [orderFood.id]: inputValue, // Store the actual input value
                                    }));

                                    // Update the orderList with new purchase price
                                    const updatedOrderList = [...orderList];
                                    updatedOrderList[inx].purchase_price =
                                      newUnitPrice;

                                    // Also update product_info if it exists
                                    if (updatedOrderList[inx].product_info) {
                                      updatedOrderList[
                                        inx
                                      ].product_info.purchase_price =
                                        newUnitPrice;
                                    }

                                    // Update the price field as well for consistency
                                    updatedOrderList[inx].price = newUnitPrice;

                                    setOrderList(updatedOrderList);

                                    // Clear the price edit state to show updated calculated price
                                    setEditablePrices((prev) => ({
                                      ...prev,
                                      [orderFood.id]: undefined,
                                    }));
                                  } else {
                                    // For billing type - existing logic
                                    const newSubtotal =
                                      inputValue === ""
                                        ? 0
                                        : Number.parseFloat(inputValue) || 0;
                                    const newUnitPrice =
                                      orderFood.qty > 0
                                        ? newSubtotal / orderFood.qty
                                        : 0;

                                    const updatedOrderList = [...orderList];
                                    updatedOrderList[inx].price = newUnitPrice;
                                    updatedOrderList[inx].retails_price =
                                      newUnitPrice;

                                    if (updatedOrderList[inx].product_info) {
                                      updatedOrderList[
                                        inx
                                      ].product_info.retails_price =
                                        newUnitPrice;
                                    }

                                    setOrderList(updatedOrderList);
                                  }
                                }
                              }}
                              onKeyDown={(e) => {
                                if (
                                  (user?.type == "1" || user?.type == "2") &&
                                  (e.key === "Enter" || e.key === "ArrowRight")
                                ) {
                                  if (type === "purchase") {
                                    document
                                      .querySelector(
                                        `[tabindex="${inx * 4 + 5}"]`
                                      )
                                      ?.focus();
                                  } else {
                                    document
                                      .querySelector('[tabindex="1"]')
                                      ?.focus();
                                  }
                                }
                              }}
                              onFocus={(e) => e.target.select()}
                            />
                          ) : (
                            <span>
                              {(orderFood.price * orderFood.qty || 0).toFixed(
                                2
                              )}
                            </span>
                          )}
                        </div>

                        {/* MRP Column - Only for purchase and user types 1 & 2 */}
                        {(user?.type == "1" || user?.type == "2") &&
                          type == "purchase" && (
                            <div className="w-[15%] px-2 text-right font-medium">
                              <input
                                tabIndex={
                                  user?.type == "1" || user?.type == "2"
                                    ? inx * 4 + 5
                                    : undefined
                                }
                                type="number"
                                step="0.01"
                                value={
                                  orderFood?.product_info?.retails_price ||
                                  orderFood?.retails_price ||
                                  ""
                                }
                                // onChange={(e) => {
                                //   const updatedOrderList = [...orderList];
                                //   updatedOrderList[
                                //     inx
                                //   ].product_info.retails_price =
                                //     parseFloat(e.target.value) || 0;
                                //   setOrderList(updatedOrderList);
                                // }}
                                // In the MRP input onChange, also update the main orderList item:
                                // In the MRP input field onChange:
                                onChange={(e) => {
                                  const newRetailsPrice =
                                    parseFloat(e.target.value) || 0;
                                  const updatedOrderList = [...orderList];

                                  // Update both retails_price and product_info.retails_price
                                  updatedOrderList[inx].retails_price =
                                    newRetailsPrice;

                                  if (updatedOrderList[inx].product_info) {
                                    updatedOrderList[
                                      inx
                                    ].product_info.retails_price =
                                      newRetailsPrice;
                                  } else {
                                    // If product_info doesn't exist (newly added item), create it
                                    updatedOrderList[inx].product_info = {
                                      ...updatedOrderList[inx].product_info,
                                      retails_price: newRetailsPrice,
                                    };
                                  }

                                  setOrderList(updatedOrderList);
                                }}
                                className="w-full text-right bg-gray-100 rounded-md px-2 py-1"
                                placeholder="0.00"
                                onKeyDown={(e) => {
                                  if (
                                    (user?.type == "1" || user?.type == "2") &&
                                    (e.key === "Enter" ||
                                      e.key === "ArrowRight")
                                  ) {
                                    document
                                      .querySelector('[tabindex="1"]')
                                      ?.focus();
                                  }
                                }}
                                onFocus={(e) => e.target.select()}
                              />
                            </div>
                          )}

                        {/* Delete Button */}
                        <div className="w-[10%] px-2 flex justify-end">
                          <p
                            className="w-[23px] bg-[#FF0303] rounded-[5px] p-1 h-6 cursor-pointer"
                            onClick={() => handleDelete(inx)}
                          >
                            <MdClose className="text-[#FFFFFF]"></MdClose>
                          </p>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        key={inx}
                        className="flex items-center justify-between rounded-[16px] bg-[#fff] px-[0px] custom_shadow p-2 box-border mb-[15px]"
                      >
                        {/* first col */}
                        <div className="flex gap-2 w-3/6 items-center">
                          {/* image */}
                          <div className="w-[50px] h-[50px]">
                            <img
                              className="w-full h-full rounded-md object-contain"
                              src={
                                orderFood?.product_info?.image_path
                                  ? orderFood?.product_info?.image_path
                                  : orderFood?.image_path
                                  ? orderFood?.image_path
                                  : shop_logo
                              }
                              alt=""
                            />
                          </div>
                          {/* product name & discount */}
                          <div className="space-y-[2px]">
                            <h4 className="text-sm">
                              {console.log("ORDERFOOD IN EDIT....", orderFood)}
                              {orderFood?.product_info?.name?.length > 40 ||
                              orderFood?.name?.length > 40 ? (
                                <>
                                  {orderFood?.product_info
                                    ? orderFood?.product_info?.name.slice(0, 35)
                                    : orderFood?.name
                                    ? orderFood?.name.slice(0, 35)
                                    : "" + "..."}
                                </>
                              ) : orderFood?.product_info?.name.length > 0 ? (
                                orderFood?.product_info?.name
                              ) : orderFood?.name.length > 0 ? (
                                orderFood?.name
                              ) : (
                                ""
                              )}
                              {orderFood?.onExchange && (
                                <span className="text-red-500 text-[10px] ml-2">
                                  (Exchange Purchase)
                                </span>
                              )}
                            </h4>
                            {orderFood?.product_variant_id && (
                              <span className="text-sm ">
                                {" "}
                                {orderFood?.product_variant?.name}
                              </span>
                            )}

                            {typePurchase && (
                              <span className="text-xs font-semibold">
                                {orderFood?.product_imei
                                  ? orderFood?.product_imei[0]?.imei
                                  : null}
                              </span>
                            )}
                            <div className="flex gap-1 items-center">
                              {/* discount info */}
                              {((type == "billing" &&
                                salesType != "wholesale") ||
                                type == "booking") && (
                                <p className="text-[#00B894] w-fit text-[7px] font-nunito font-bold px-2 pt-[4px] pb-[2px] bg-[#00B8941a] text-center rounded-[5px]">
                                  {orderFood?.product_info?.discount
                                    ? orderFood?.product_info?.discount +
                                      " " +
                                      (orderFood?.product_info
                                        ?.discount_type === "Percentage" ||
                                      orderFood?.product_info?.discount_type ===
                                        "2"
                                        ? "%"
                                        : invoiceSetting?.currency_info?.code ||
                                          "BDT")
                                    : orderFood?.discount
                                    ? orderFood?.discount +
                                      " " +
                                      (orderFood?.discount_type ===
                                        "Percentage" ||
                                      orderFood?.discount_type === "2"
                                        ? "%"
                                        : invoiceSetting?.currency_info?.code ||
                                          "BDT")
                                    : null}{" "}
                                  off
                                </p>
                              )}
                              {orderFood?.product_info?.have_variant === 0 ||
                              orderFood?.product_info?.have_variant === null ? (
                                // Warranty modal button
                                <label
                                  htmlFor="my_modal_warranty"
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setWarrantyModal(true);
                                    setSelectedItem(orderFood.product_info);
                                  }}
                                >
                                  <img
                                    src={warrantyIcon}
                                    alt="warrantyIcon"
                                    className="w-5"
                                  />
                                </label>
                              ) : (
                                // Product variation modal button
                                <label
                                  htmlFor="my_modal_productVariation"
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setProductVariation(true);
                                    setSelectedItem(orderFood);
                                    setOrderIndex(inx);
                                  }}
                                >
                                  {console.log(
                                    "OrderFood Sateemmmmmmmm ",
                                    orderFood
                                  )}
                                  {console.log(
                                    "OrderList Sateemmmmmmmm ",
                                    orderList
                                  )}
                                  <img
                                    src={ProductVariationIcon}
                                    alt="productVariation"
                                    className="w-5"
                                  />
                                </label>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* second col */}

                        <div className="w-2/6 ">
                          {/* {
                          user?.id === 129 ?
                          <p className="text-[#000232] font-nunito font-semibold text-xs flex-grow p-2">
                              <input
                                type="text"
                                value={parseFloat(subtotalPrice)}
                                className="w-[100px] mb-1 text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-[6px]"
                                onChange={(e) =>
                                  handleSelectedFoodPrice(
                                    orderFood,
                                    e.target.value,
                                    qty
                                  )
                                }
                              />
                            </p>
                            :

                          type == "purchase" ?
                          <p className="text-[#000232] font-nunito font-semibold text-xs flex-grow p-2">
                            <input
                              type="text"
                              value={orderFood?.purchase_price}
                              value={
                                orderFood?.product129Price
                                  ? orderFood?.product129Qty
                                    ? orderFood.product129Price *
                                      orderFood.product129Qty
                                    : orderFood.product129Price
                                  : ""
                              }
                              className="w-[100px] mb-1 text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-[6px]"
                              onChange={
                                (e) =>
                                  handleSelectedItemQty129(
                                    orderFood,
                                    "price",
                                    e
                                  )
                                handleSelectedFoodPrice(
                                  orderFood,
                                  e.target.value,
                                  qty
                                )
                              }
                              onChange={() => handleSelectedFoodPrice(orderFood,e.target.value,qty)}
                            />

                           :

                            <input
                              type="text"
                              value={orderFood?.retails_price}
                              value={
                                orderFood?.product129Price
                                  ? orderFood?.product129Qty
                                    ? orderFood.product129Price *
                                      orderFood.product129Qty
                                    : orderFood.product129Price
                                  : ""
                              }
                              className="w-[100px] mb-1 text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-[6px]"
                              onChange={
                                (e) =>
                                  handleSelectedItemQty129(
                                    orderFood,
                                    "price",
                                    e
                                  )
                                handleSelectedFoodPrice(
                                  orderFood,
                                  e.target.value,
                                  qty
                                )
                              }
                              onChange={() => handleSelectedFoodPrice(orderFood,e.target.value,qty)}
                            />
                          </p>

                          <p className="flex justify-center gap-x-1 text-[#00023280] font-nunito text-xs font-bold ">
                              <span>{subtotalPrice}</span>
                              <span className="text-[7px]">
                                {invoiceSetting?.currency_info?.code
                                  ? invoiceSetting?.currency_info?.code
                                  : "BDT"}
                              </span>
                            </p>
                        } */}
                          {console.log("OrderFood ", orderFood)}
                          {type === "purchase" && !typePurchase ? (
                            <p className="text-[#000232] font-nunito font-semibold text-xs flex-grow p-2">
                              <input
                                type="text"
                                value={
                                  orderFood?.invoice_id
                                    ? orderFood?.product_info?.purchase_price
                                      ? orderFood.product_info.purchase_price *
                                        orderFood.qty
                                      : orderFood.price
                                    : orderFood.purchase_price
                                    ? orderFood.purchase_price * orderFood.qty
                                    : ""
                                }
                                className="w-[100px] mb-1 text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-[6px]"
                                onChange={(e) =>
                                  handleSelectedFoodPrice(
                                    orderFood,
                                    e.target.value,
                                    qty
                                  )
                                }
                              />
                            </p>
                          ) : type === "purchase" && typePurchase ? (
                            <p className="text-[#000232] font-nunito font-semibold text-xs flex-grow p-2">
                              {console.log("inTypePurchase........")}
                              {console.log("OrderFood ", orderFood)}
                              <input
                                type="text"
                                value={
                                  orderFood?.invoice_id
                                    ? orderFood?.price
                                      ? orderFood.price * orderFood.qty
                                      : orderFood.product_info.purchase_price
                                    : orderFood.purchase_price
                                    ? orderFood.purchase_price * orderFood.qty
                                    : ""
                                }
                                className="w-[100px] mb-1 text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-[6px]"
                                onChange={(e) =>
                                  handleSelectedFoodPrice(
                                    orderFood,
                                    e.target.value,
                                    inx
                                  )
                                }
                              />
                            </p>
                          ) : // product_imei    needs to add two or three conditions here
                          user.type == 8 ? (
                            orderFood?.product_imei?.length > 0 ? (
                              <p className="text-[#000232] font-nunito font-semibold text-xs flex-grow p-2">
                                <input
                                  type="text"
                                  value={
                                    orderFood?.price ? orderFood?.price : ""
                                  }
                                  className="w-[100px] mb-1 text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-[6px]"
                                  onChange={(e) =>
                                    handleSelectedFoodPrice(
                                      orderFood,
                                      e.target.value
                                    )
                                  }
                                  // needs to modify or create function
                                />
                              </p>
                            ) : (
                              <p className="text-[#000232] font-nunito font-semibold text-xs flex-grow p-2">
                                <input
                                  type="text"
                                  value={
                                    orderFood?.price
                                      ? orderFood?.qty
                                        ? orderFood?.price * orderFood?.qty
                                        : orderFood?.price
                                      : ""
                                  }
                                  className="w-[100px] mb-1 text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-[6px]"
                                  onChange={(e) =>
                                    handleSelectedItemQty129(
                                      orderFood,
                                      "price",
                                      e
                                    )
                                  }
                                />
                              </p>
                            )
                          ) : orderFood?.product_imei &&
                            orderFood?.product_imei?.length > 0 ? (
                            <p className="text-[#000232] font-nunito font-semibold text-xs flex-grow p-2">
                              <input
                                type="text"
                                value={orderFood?.price ? orderFood?.price : ""}
                                className="w-[100px] mb-1 text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-[6px]"
                                onChange={(e) => {
                                  handleSelectedFoodPrice(
                                    orderFood,
                                    e.target.value
                                  );
                                }}
                              />
                            </p>
                          ) : orderFood?.imeis &&
                            orderFood?.imeis.length > 0 ? (
                            <p className="text-[#000232] font-nunito font-semibold text-xs flex-grow p-2">
                              <input
                                type="text"
                                value={parseInt(subtotalPrice)}
                                className="w-[100px] mb-1 text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-[6px]"
                                onChange={(e) => {
                                  handleSelectedFoodPrice(
                                    orderFood,
                                    e.target.value,
                                    inx
                                  );
                                }}
                              />
                            </p>
                          ) : (
                            <p className="text-[#000232] font-nunito font-semibold text-xs flex-grow p-2">
                              <input
                                type="text"
                                value={
                                  orderFood?.price
                                    ? orderFood.price && orderFood?.qty
                                      ? orderFood.price * orderFood.qty
                                      : orderFood.price
                                    : ""
                                }
                                className="w-[100px] mb-1 text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-[6px]"
                                onChange={(e) =>
                                  handleSelectedItemQty129(
                                    orderFood,
                                    "price",
                                    e
                                  )
                                }
                              />
                            </p>
                          )}

                          <div className="flex items-center gap-x-1 w-[75px] h-[20px]">
                            <button
                              className="quantity-decrement"
                              onClick={() => {
                                handleSelectedFood(orderFood, "decrement");
                              }}
                            >
                              <FontAwesomeIcon icon={faAngleLeft} />
                            </button>
                            <p className="text-[#000232] font-nunito font-semibold text-xs flex-grow">
                              {/* <input
                              type="text"
                              value={qty}
                              className="text-center bg-white pb-[3px] pl-[2px] pr-[0px] pt-[3px] w-[100%]"
                              onChange={(e) =>
                                handleSelectedFoodQty(orderFood, e)
                              }
                            /> */}
                              {console.log(
                                "orderfood................ Before increment..",
                                orderFood
                              )}
                              {type !== "purchase" &&
                              orderFood?.product_info?.have_variant == 1 ? (
                                <input
                                  type="text"
                                  value={qty}
                                  className="text-center bg-white pb-[3px] pl-[2px] pr-[0px] pt-[3px] w-[100%]"
                                />
                              ) : (
                                <input
                                  type="text"
                                  value={`x${
                                    orderFood?.qty ? orderFood.qty : ""
                                  }`}
                                  className="text-center bg-white pb-[3px] pl-[2px] pr-[0px] pt-[3px] w-[100%]"
                                  onChange={(e) =>
                                    // handleSelectedFoodQty(orderFood, e)
                                    handleSelectedItemQty129(
                                      orderFood,
                                      "qty",
                                      e
                                    )
                                  }
                                />
                              )}
                            </p>
                            {/* <button
                            className="quantity-increment"
                            onClick={() => {
                              handleSelectedFood(orderFood, "increment");
                            }}
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                          </button> */}
                            {type !== "purchase" &&
                            orderFood?.product_info?.have_variant == 1 ? (
                              <button className="quantity-increment">
                                <FontAwesomeIcon icon={faAngleRight} />
                              </button>
                            ) : (
                              <button
                                className="quantity-increment"
                                onClick={() => {
                                  handleSelectedFood(orderFood, "increment");
                                }}
                                // onClick={ orderFood?.imeis?.length ? "" : () => {handleSelectedFood(orderFood, "increment")}}
                              >
                                <FontAwesomeIcon icon={faAngleRight} />
                              </button>
                            )}
                          </div>
                        </div>

                        {/* third col */}
                        <p
                          className="w-[23px] bg-[#FF0303] rounded-[5px] p-1 h-6"
                          onClick={() => {
                            handleDelete(inx);
                          }}
                        >
                          <MdClose className="text-[#FFFFFF]"></MdClose>
                        </p>
                      </div>
                    );
                  }
                })}
            </div>
            <div>
              <button
                onClick={() => setIsShowModal(true)}
                className="bg-[#407BFF] text-white w-full py-1 rounded-lg text-sm font-semibold"
              >
                View Customer Info
              </button>
              {isShowModal && (
                <CustomerInfoModal
                  onClose={handleCloseModal}
                  customerName={
                    invoiceData?.delivery_customer_name ||
                    invoiceData?.customer_name
                  }
                  customerPhone={
                    invoiceData?.delivery_customer_phone ||
                    invoiceData?.customer_phone
                  }
                  customerAddress={
                    invoiceData?.delivery_customer_address ||
                    invoiceData?.customer_address
                  }
                  title={"Customer Info"}
                  reference={reference}
                  setReference={setReference}
                />
              )}
            </div>
            <div className="flex w-full mt-3">
              <div className="w-1/2">
                {(type === "booking" || type === "billing") && (
              <div className=" flex ">
                <div className="w-2/3 relative">
                  <select
                    name="discount_type"
                    onChange={handleChangeDiscountType}
                    className="select w-full text-[#102048] font-normal placeholder:text-[#91919F] bg-transparent outline-none pl-[15px]  text-sm rounded-s-[10px] rounded-e-none border border-[#C1CFEF] focus:outline-none"
                  >
                    <option disabled=""> Discount Type</option>
                    {discountType.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
                <input
                  type="text"
                  className={`w-1/3 text-[#102048] font-normal placeholder:text-[#91919F] bg-transparent outline-none pl-[15px]  text-sm rounded-s-none rounded-e-[10px] border border-[#C1CFEF] focus:outline-none`}
                  placeholder="Discount"
                  value={initialDiscount}
                  onChange={(e) => handleChangeDiscount(e.target.value)}
                  name={"discount"}
                />
              </div>
            )}


              </div>
            <div className="w-1/2">
              {(type === "booking" || type === "billing") && (
                <div
                  className="flex items-center justify-center  gap-3 ps-3 pe-0"
                  onClick={() => setMethodIndex(0)}
                >
                  <ItemSelectBox
                    name="delivery_id"
                    options={deliveryList}
                    value={deliveryFormData.deliveryId}
                    onChange={handleChangeSelect.bind(this, "delivery_id")}
                    label={"Delivery Method"}
                    placeholder={deliveryFormData.deliveryName}
                    style={{ maxHeight: "300px", overflowY: "scroll" }}
                  />
                </div>
              )}

              {deliveryFormData?.deliveryName?.toLowerCase() === "pathao" && (
                <div
                  className="flex items-center justify-center py-2 gap-3 px-3 "
                  onClick={() => setMethodIndex(0)}
                >
                  <ItemSelectBox2
                    name="store_id"
                    options={pathaoStores}
                    value={pathaoStore?.store_id}
                    onChange={handlePathaoStoreChangeSelect.bind(
                      this,
                      "store_id"
                    )}
                    label={"Pathao Store"}
                    placeholder={pathaoStore?.store_name}
                    style={{ maxHeight: "300px", overflowY: "scroll" }}
                  />
                </div>
              )}

              {deliveryFormData?.deliveryName?.toLowerCase() === "pathao" && (
                <div
                  className="flex items-center justify-center py-2 gap-3 px-3 "
                  onClick={() => setMethodIndex(0)}
                >
                  {console.log("pathao Cities... ", pathaoCities)}
                  <ItemSelectBox2
                    name="city_id"
                    options={pathaoCities}
                    value={pathaoCity.city_id || matchedCityId}
                    onChange={handlePathaoCityChangeSelect.bind(
                      this,
                      "city_id"
                    )}
                    label={"Pathao City"}
                    placeholder={
                      pathaoCities.find((c) => c.city_id === matchedCityId)
                        ?.city_name ||
                      pathaoCity.city_name ||
                      "Select Pathao City"
                    }
                    style={{ maxHeight: "300px", overflowY: "scroll" }}
                  />
                </div>
              )}

              {deliveryFormData?.deliveryName?.toLowerCase() === "pathao" &&
                pathaoCity.city_id != "" && (
                  <div
                    className="flex items-center justify-center py-2 gap-3 px-3 "
                    onClick={() => setMethodIndex(0)}
                  >
                    {console.log("pathao Zones... ", pathaoZones)}
                    {console.log(
                      "pathao Zone matchedZoneId / name ... ",
                      matchedZoneId,
                      pathaoZone.zone_name
                    )}
                    <ItemSelectBox2
                      name="zone_id"
                      options={pathaoZones}
                      value={pathaoZone.zone_id || matchedZoneId}
                      onChange={handlePathaoZoneChangeSelect.bind(
                        this,
                        "zone_id"
                      )}
                      label={"Pathao Zone"}
                      placeholder={
                        pathaoZones.find((z) => z.zone_id === matchedZoneId)
                          ?.zone_name ||
                        pathaoZone.zone_name ||
                        "Select Pathao Zone"
                      }
                      style={{ maxHeight: "300px", overflowY: "scroll" }}
                    />
                  </div>
                )}
            </div>

            </div>
            <div className="flex justify-between items-start mt-3 ">
              <div className="relative border-[#C1CFEF] py-2.5 border w-full flex-1 rounded-xl">
                <DatePicker
                  selected={transactionDate}
                  onChange={(date) => setTransactionDate(date)}
                  dateFormat="dd/MM/yyyy"
                  className="w-full px-2 focus:outline-none"
                />
                <span className="bg-white absolute left-2 font-semibold px-1 text-xs top-0 text-[#102048] translate-y-[-50%]">
                  Transaction Date
                </span>
                {/* <span className={`${startDate && startDate.toLocaleDateString() === "DD / MM / YYYY" ? "text-[#91919F]" : "text-[#232324]"} absolute left-[6px] px-1  text-sm lg:text-base bg-white`}>
              {startDate && startDate.toLocaleDateString()}
            </span> */}
              </div>
            </div>
            {user.type == 4 && (
              <>
                <div className="flex justify-between items-start mt-3 ">
                  {console.log(restaurantTables)}
                  <SelectBox2
                    name="table_id"
                    options={restaurantTables}
                    value={selectedTable}
                    onChange={(selected) => setSelectedTable(selected?.value)} // selected is in this format { value: 1, label: "Table 1" }
                    isSearchable={true}
                    placeholder="Select Table"
                    className="px-[0] select w-full rounded-2xl mb-[15px] bg-white"
                    label="Restaurant Table"
                  />
                </div>
              </>
            )}
            <div className="flex justify-between items-start mt-3 border-b border-dashed border-[#7F8098]">
              {/* Left Labels */}
              <div className="space-y-2">
                <h4 className="text-[#000232] font-nunito font-bold text-base">
                  Subtotal
                </h4>
                <p className="text-[#7F8098] font-nunito font-medium text-sm">
                  Vat ({(type === "purchase" ? 0 : vat) + "%"})
                </p>
                <p className="text-[#7F8098] font-nunito font-medium text-sm">
                  Tax ({(type === "purchase" ? 0 : tax) + "%"})
                </p>
                {(type === "booking" ||
                  type === "billing" ||
                  type === "wholesale") && (
                  <h4 className="text-[#000232] font-nunito font-bold text-base">
                    Delivery Fee
                  </h4>
                )}

                <p className="text-[#7F8098] font-nunito font-medium text-sm">
                  Discount ({moreDiscount + (selectedDiscountType === 'Percentage' ? '%' : (invoiceSetting?.currency_info?.code || 'BDT'))})
                </p>

              </div>

              {/* Right Values */}
              <div className="text-right space-y-2">
                {/* Subtotal */}
                <p className="text-[#000232] font-nunito font-semibold text-base">
                  {formatPrice(subTotalNew)}{" "}
                  <span className="text-xs text-[#7F8098]">
                    {" "}
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : "BDT"}
                  </span>
                </p>
                {/* Vat */}
                <p className="text-[#7F8098] font-nunito font-medium text-sm">
                  {formatPrice(
                    vat && vat > 0 ? (vat / 100) * Number(subTotalNew) : 0
                  )}{" "}
                  <span className="text-xs text-[#7F8098]">
                    {" "}
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : "BDT"}
                  </span>
                </p>

                {/* Tax */}
                <p className="text-[#7F8098] font-nunito font-medium text-sm">
                  {formatPrice(
                    tax && tax > 0 ? (tax / 100) * Number(subTotalNew) : 0
                  )}{" "}
                  <span className="text-xs text-[#7F8098]">
                    {" "}
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : "BDT"}
                  </span>
                </p>
                {(type === "booking" ||
                  type === "billing" ||
                  type === "wholesale") && (
                  <p className="text-[#7F8098] font-nunito font-medium text-sm flex items-center justify-end gap-1">
                    {deliveryFormData?.deliveryName?.toLowerCase() !=
                    "hand-to-hand" ? (
                      <input
                        type="text"
                        // disabled={ (deliveryFormData?.deliveryName).toLowerCase()=='hand-to-hand' ? true : false }
                        className={`w-[70px] text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded border border-[#C1CFEF] p-1.5`}
                        placeholder="0.00"
                        value={deliveryAmount}
                        // style={inputStyle}
                        onChange={(e) =>
                          handleChangeDeliveryAmount(e.target.value)
                        }
                        name={"delivery_fee"}
                      />
                    ) : (
                      <span>{deliveryAmount}</span>
                    )}
                    <span className="text-xs text-[#7F8098]">
                      {" "}
                      {invoiceSetting?.currency_info?.code
                        ? invoiceSetting?.currency_info?.code
                        : "BDT"}
                    </span>
                  </p>
                )}
                <p className="text-[#7F8098] font-nunito font-bold text-lg mb-[15px]">
                  {totalMoreDiscount} <span className="text-[13px]"> {invoiceSetting?.currency_info?.code ? invoiceSetting?.currency_info?.code : 'BDT'}</span>
                </p>
              </div>
            </div>

            {/* === Grand Total & Payment Section === */}
            <div className="flex justify-between items-start border-b border-dashed border-[#7F8098] pb-2 pt-1">
              {/* Labels */}
              <div  className="space-y-2">
                <h4 className="text-[#000232] font-nunito font-bold text-base">
                  Grand Total
                </h4>
                {(type === "booking" ||
                  type === "billing" ||
                  type == "purchase") && (
                  <h4 className="text-[#000232] font-nunito font-bold text-base">
                    Paid Amount
                  </h4>
                )}
                <h4 className="text-[#000232] font-nunito font-bold text-base">
                  Payment History
                </h4>
              </div>




                {/* Values */}

              <div className="text-right space-y-2">

                {/* Grand Total */}
                <p className="text-[#000232] font-nunito font-semibold text-base">
                  {grandTotalAfterDiscount}{" "}
                  <span className="text-xs text-[#7F8098]">
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : "BDT"}
                  </span>
                </p>
                {/* Paid Amount (display for booking/billing/purchase/wholesale) */}
                {(type === "booking" || type === "billing") && (
                  <p className="text-[#7F8098] font-nunito font-medium text-sm">
                    {/* <input
                      type="text"
                      className={`w-[80px] text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-2`}
                      placeholder="0.00"
                      value={
                        paidAmount
                          // ? paidAmount
                          // :
                          // Number(grandTotalAfterDiscount) - due
                      }
                      style={inputStyle}
                      // onChange={(e) => handleChangePaidAmount(e.target.value)}
                      name={"paid_amount"}
                    /> */}
                    <p className="">
                      {Number.parseFloat(paidAmount).toFixed(2)}{" "}
                      <span className="text-xs text-[#7F8098]">
                        {invoiceSetting?.currency_info?.code
                          ? invoiceSetting?.currency_info?.code
                          : "BDT"}
                      </span>
                    </p>
                    {/* <span className="text-[13px]">
                      {invoiceSetting?.currency_info?.code
                        ? invoiceSetting?.currency_info?.code
                        : "BDT"}
                    </span> */}
                  </p>
                )}

                {invoiceData?.multiple_payment?.map((item, index) => (
                  <div key={index} className="text-right mb-2">

                    {/* Payment Type */}
                    <p className="font-semibold text-[#102048]">
                      {item?.payment_type?.type_name || ""}
                    </p>

                    {/* Category List */}
                    {item?.payment_type?.payment_type_category?.map((cat, i) => (
                      <p key={i} className="text-sm text-[#7F8098]">
                        {cat?.payment_category_name || ""}
                        {cat?.account_number ? ` (${cat.account_number})` : ""}
                      </p>
                    ))}

                    {/* Amount */}
                    <p className="text-sm font-bold text-[#102048]">
                      {item?.payment_amount}{" "}
                      {invoiceSetting?.currency_info?.code || "BDT"}
                    </p>
                  </div>
                ))}

                {type == "purchase" && (
                  <p className="text-[#7F8098] font-nunito font-bold text-lg mb-[15px] text-right">
                    <input
                      type="text"
                      className={`w-[80px] text-right text-[#102048] font-semibold placeholder:text-[#91919F] bg-transparent outline-none text-sm rounded-[5px] border border-[#C1CFEF] focus:outline-none p-2`}
                      placeholder="0.00"
                      value={
                        paidAmount
                          ? paidAmount
                          : Number(grandTotalAfterDiscount) - due
                      }
                      // style={inputStyle}
                      onChange={(e) => handleChangePaidAmount(e.target.value)}
                      name={"paid_amount"}
                    />
                    <span className="text-[13px]">
                      {invoiceSetting?.currency_info?.code
                        ? invoiceSetting?.currency_info?.code
                        : "BDT"}
                    </span>
                  </p>
                )}
              </div>
            </div>

            {(type === "booking" || type === "billing") && (
              <div className="flex justify-between items-center">
                <div>
                  {parseInt(user.type) === 4 ? (
                    <h4 className="text-[#000232] font-nunito font-bold text-lg mb-[15px]">
                      {" "}
                      Change Amount
                    </h4>
                  ) : (
                    <h4 className="text-[#000232] font-nunito font-bold text-lg mb-[15px]">
                      {" "}
                      Due Amount
                    </h4>
                  )}
                </div>
                <div>
                  {parseInt(user.type) === 4 ? (
                    <p className="text-[#7F8098] font-nunito font-bold text-lg mb-[15px]">
                      {Number.parseFloat(cashChange).toFixed(2) < 0
                        ? Number.parseFloat(cashChange).toFixed(2) * -1
                        : Number.parseFloat(cashChange).toFixed(2)}{" "}
                      <span className="text-[13px]">
                        {invoiceSetting?.currency_info?.code
                          ? invoiceSetting?.currency_info?.code
                          : "BDT"}
                      </span>
                    </p>
                  ) : (
                    <p className="text-[#7F8098] font-nunito font-bold text-lg mb-[15px]">
                      {Number.parseFloat(due).toFixed(2) < 0
                        ? Number.parseFloat(due).toFixed(2) * -1
                        : Number.parseFloat(due).toFixed(2)}{" "}
                      <span className="text-[13px]">
                        {invoiceSetting?.currency_info?.code
                          ? invoiceSetting?.currency_info?.code
                          : "BDT"}
                      </span>
                    </p>
                  )}
                </div>
              </div>
            )}
            {type == "purchase" && (
              <div className="flex justify-between items-center">
                <div>
                  <h4 className="text-[#000232] font-nunito font-bold text-lg mb-[15px]">
                    {" "}
                    Due Amount
                  </h4>
                </div>
                <div>
                  <p className="text-[#7F8098] font-nunito font-bold text-lg mb-[15px]">
                    {Number.parseFloat(due).toFixed(2)}{" "}
                    <span className="text-[13px]">
                      {invoiceSetting?.currency_info?.code
                        ? invoiceSetting?.currency_info?.code
                        : "BDT"}
                    </span>
                  </p>
                </div>
              </div>
            )}


            <div className="mt-[10px] ">


              {(type === "booking" ||
                type === "billing" ||
                type == "purchase") && (
                <div className="flex justify-center items-center pt-2">
                  <div className="grid grid-cols-6 gap-3 w-full">
                    {paymentList.map((items, index) => (
                      // <label
                      //   htmlFor="my_modal_payment"
                      //   onClick={() => handleClicks(items)}
                      //   className={`${
                      //     money === items?.type_name && orderList.length > 0
                      //       ? " bg-[#29B170] text-[#fff]"
                      //       : "opacity-50 bg-[#2e509b1a] text-blue-700"
                      //   } cursor-pointer w-[80%] h-[109px] flex justify-center mx-auto items-center rounded-[13px] break-words overflow-hidden`}
                      // >
                      //   <div
                      //     className={` flex flex-col justify-center w-full items-center gap-y-2 p-2`}
                      //   >
                      //     <h2 className={`font-bold text-3xl`}>
                      //       {items.icon_letter}
                      //     </h2>
                      //     <p className="text-sm  text-center font-nunito font-bold w-[90%]">
                      //       {items?.type_name}
                      //     </p>
                      //   </div>
                      // </label>
                      <label
                        htmlFor="my_modal_payment"
                        onClick={(e) => handleClicks(e, items)}
                        // className={`${
                        //   items.icon_image
                        //     ? "bg-white" // Set background to white if icon_image exists
                        //     : money === items?.type_name && orderList.length > 0
                        //     ? "bg-gradient-to-r from-green-500 to-green-700 text-white"
                        //     : "bg-blue-100 text-blue-700"
                        // } cursor-pointer w-[80%] h-[120px] flex justify-center mx-auto items-center rounded-lg shadow-md transition-transform transform hover:scale-105 overflow-hidden`}
                        className={`${
                          items.icon_image
                            ? "bg-white"
                            : money === items?.type_name && orderList.length > 0
                            ? "bg-gradient-to-r from-green-500 to-green-700 text-white"
                            : "bg-blue-100 text-blue-700"
                        } cursor-pointer w-[75px] h-[75px] flex flex-col justify-center items-center
                          rounded-md shadow-sm transition-transform transform hover:scale-105 overflow-hidden`}
                      >
                        <div
                          className={`flex flex-col justify-center w-full items-center p-0`}
                        >
                          {items.icon_image ? (
                            // Render the image if `items.icon_image` exists
                            <img
                              src={items.icon_image}
                              alt="Icon"
                              width="100%"
                              height="120px"
                              className={`object-cover rounded-lg`}
                            />
                          ) : (
                            // Render the original structure if `items.icon_image` does not exist
                            <>
                              <h2
                                className={`font-bold text-4xl text-gray-800`}
                              >
                                {items.icon_letter}
                              </h2>
                              <p className="text-sm text-center font-nunito font-bold w-[90%] text-gray-600">
                                {items.type_name === "cash"
                                  ? "Cash"
                                  : items.type_name}
                              </p>
                            </>
                          )}
                        </div>
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {isExchange && (
                  <div className="w-full my-3 flex flex-col items-center">
                    <label className="text-gray-700 font-nunito font-bold text-sm mb-1 w-[80%] text-left">
                      Select Payment Method for Purchase
                    </label>
                    {console.log("selectedPaymentAccountListForExchange........ ",selectedPaymentAccountListForExchange)}
                    <select
                      className="w-[80%] p-3 border border-gray-300 rounded-lg shadow-md bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={
                        selectedPaymentAccountListForExchange?.type_name ||
                        defaultPayment?.type_name
                      }
                      onChange={(e) => {
                        const selectedPayment = paymentList.find(
                          (item) => item.type_name === e.target.value
                        );
                        setSelectedPaymentAccountListForExchange(
                          selectedPayment || defaultPayment
                        );
                      }}
                    >
                      {paymentList.map((items, index) => (
                        <option key={index} value={items.type_name}>
                          {items.type_name.toLowerCase() == "cash"
                            ? "Cash"
                            : items.type_name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}


              {warningMessage && (
                <div className="warning-message">something wrong!</div>
              )}
              {flashMessage && (
                <div
                  className={`font-bold text-2xl text-center font-nunito mb-3 ${getFlashMessageStyle(
                    flashMessage.type
                  )}`}
                >
                  {flashMessage.text}
                </div>
              )}

              {/*
              {( type === "billing") ?
                (<div className='flex items-center justify-center py-5 gap-3 px-3' onClick={()=>setMethodIndex(0)}>
                  <ItemSelectBox
                    name="delivery_id"
                    options={deliveryList}
                    value={deliveryFormData.deliveryId}
                    onChange={handleChangeSelect.bind(this, 'delivery_id')}
                    label={"Delivery Method"}
                    placeholder={deliveryFormData.deliveryName }
                    style={{ maxHeight: '300px', overflowY: 'scroll' }}
                  />
                </div>
              ) : null } */}

              {warrantyModal ? (
                <Modal
                  state={state}
                  isOpen={warrantyModal}
                  setOpen={setWarrantyModal}
                  filteredProducts={filteredProducts}
                  setWarningMessage={setWarningMessage}
                  selectedProductWarrantyList={selectedProductWarrantyList}
                  setSelectedProductWarrantyList={
                    setSelectedProductWarrantyList
                  }
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  orderList={orderList}
                  title="Warranty Info"
                  formId="my_modal_warranty"
                  loadingCallback={loadingCallback}
                  navigate={navigate}
                  type="warranty"
                />
              ) : null}

              {productVariation && selectedItem.qty >= 1 ? (
                <Modal
                  state={state}
                  isOpen={productVariation}
                  setOpen={setProductVariation}
                  // variationData={variationData}
                  // seteVariationData={seteVariationData}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  orderList={orderList}
                  setOrderList={setOrderList}
                  title={selectedItem.name}
                  formId="my_modal_productVariation"
                  loadingCallback={loadingCallback}
                  navigate={navigate}
                  type="productVariation"
                  billType={type}
                  typePurchase={typePurchase}
                  typeSaleEdit={typeSaleEdit}
                  orderIndex={orderIndex}
                  handleSelectedFoodPrice={handleSelectedFoodPrice}
                />
              ) : null}

              {productVariantListModal ? (
                <Modal
                  isOpen={productVariantListModal}
                  setOpen={setProductVariantListModal}
                  productVariants={productVariants}
                  orderList={orderList}
                  setOrderList={setOrderList}
                  title={selectedItem.name}
                  formId={"product_variant_modal"}
                  type="product_variant"
                  billType={type}
                  productVariantIndex={productVariantIndex}
                />
              ) : null}

              {showPaymentModal ? (
                <Modal
                  isOpen={showPaymentModal}
                  setOpen={setShowPaymentModal}
                  getData={paymentData}
                  listData={paymentList}
                  formData={formData}
                  setFormData={setFormData}
                  paymentAccountList={paymentAccountList}
                  setData={setPaymentData}
                  filteredAccountList={filteredAccountList}
                  setPaidAmount={setPaidAmount}
                  paidAmount={paidAmount}
                  setFilteredAccountList={setFilteredAccountList}
                  setSelectedAccountList={setSelectedPaymentAccountList}
                  setWarningMessage={setWarningMessage}
                  title="Payment Info"
                  formId="my_modal_payment"
                  loadingCallback={loadingCallback}
                  navigate={navigate}
                  grandTotalAfterDiscount={grandTotalAfterDiscount}
                  type="payment"
                  isPriceChanged={isPriceChanged}
                  cashChange={cashChange}
                  setCashChange={setCashChange}
                />
              ) : null}

              {/* Modal One  */}
              {showModal ? (
                <Modal
                  isOpen={showModal}
                  setOpen={setShowModal}
                  setData={setCustomer}
                  setDeliveryFormData={setDeliveryFormData}
                  setWarningMessage={setWarningMessage}
                  title="Customer Info"
                  formId="my_modal_2"
                  loadingCallback={loadingCallback}
                  navigate={navigate}
                  type="customer"
                  filteredCustomers={filteredCustomers}
                  setFilteredCustomers={setFilteredCustomers}
                  notify={notify}
                />
              ) : null}
              {/* Modal Two  */}
              {showModalSeller ? (
                <Modal
                  isOpen={showModalSeller}
                  setOpen={setShowModalSeller}
                  setData={setSeller}
                  setWarningMessage={setWarningMessage}
                  title="Seller Info"
                  formId="my_modal_seller"
                  loadingCallback={loadingCallback}
                  navigate={navigate}
                  type="seller"
                  filteredSeller={filteredSeller}
                  setFilteredSeller={setFilteredSeller}
                />
              ) : null}
              {showModalVendor ? (
                <Modal
                  isOpen={showModalVendor}
                  setOpen={setShowModalVendor}
                  setData={setVendor}
                  setWarningMessage={setWarningMessage}
                  title="Vendor Info"
                  formId="my_modal_vendor"
                  loadingCallback={loadingCallback}
                  navigate={navigate}
                  type="vendor"
                />
              ) : null}
              {showQuickProductAddForm ? (
                <Modal
                  isOpen={showQuickProductAddForm}
                  setOpen={setShowQuickProductAddForm}
                  setData={setVendor}
                  setWarningMessage={setWarningMessage}
                  title="Quick Entry"
                  formId="my_modal_product"
                  loadingCallback={loadingCallback}
                  navigate={navigate}
                  type="product"
                  saleType={type}
                  updateBrandList={updateBrandList}
                  getTopSaleProductlist={getTopSaleProductlist}
                />
              ) : null}

              {(type === "booking" || type === "billing") &&
              orderList &&
              orderList.length > 0 &&
              money != "" ? (
                <label
                  htmlFor="my_modal_2"
                  onClick={handleOpen}
                  className="mt-[22px] bg-[#034AFF] p-2 w-full font-nunito font-semibold text-lg text-center text-[#FCFCFC] cursor-pointer rounded-[5px] capitalize"
                >
                  Add Customer
                </label>
              ) : null}
              {console.log("Type ========== ", type)}
              {console.log("showSeller ========== ", showSeller)}
              {console.log("orderList.length ========== ", orderList.length)}
              {console.log("money ========== ", money)}
              {showSeller &&
              (type === "booking" || type === "billing") &&
              orderList &&
              orderList.length > 0 &&
              money != "" ? (
                <label
                  htmlFor="my_modal_seller"
                  onClick={handleOpenSeller}
                  className="mt-[22px] bg-[#034AFF] p-2 w-full font-nunito font-semibold text-lg text-center text-[#FCFCFC] cursor-pointer rounded-[5px] capitalize"
                >
                  Add Seller
                </label>
              ) : null}
              {type === "purchase" ||
              (vendor && orderList && orderList.length > 0 && money != "") ? (
                <label
                  htmlFor="my_modal_vendor"
                  onClick={handleOpenVendor}
                  className="mt-[22px] bg-[#034AFF] p-2 w-full font-nunito font-semibold text-lg text-center text-[#FCFCFC] cursor-pointer rounded-[5px] capitalize"
                >
                  {`${
                    vendor ? "Added vendor is: " + vendor.name : "Add Vendor"
                  }`}
                </label>
              ) : null}

              {type === "billing" ||
              vendor ||
              customer ||
              (type === "booking" && (vendor || customer)) ? (
                <EditFormPayment
                  formId="PaymentForm"
                  isEdit={true}
                  setIsSave={setIsSave}
                  invoiceData={invoiceData}
                  status={status}
                  deliveryList={deliveryList}
                  deliveryAccountList={deliveryAccountList}
                  setStatus={setStatus}
                  subtotal={subTotalNew}
                  deliveryFormData={deliveryFormData}
                  setDeliveryFormData={setDeliveryFormData}
                  invoice={invoice}
                  vats={formatPrice(
                    vat && vat > 0 ? (vat / 100) * Number(subTotalNew) : 0
                  )}
                  type={type}
                  taxes={formatPrice(
                    tax && tax > 0 ? (tax / 100) * Number(subTotalNew) : 0
                  )}
                  customer={customer}
                  seller={seller}
                  vendor={vendor}
                  grandTotal={grandTotalAfterDiscount}
                  currentUser={currentUser ? currentUser : null}
                  product={orderList ? orderList : null}
                  discount={totalMoreDiscount}
                  onOrderSubmit={handleSubmitOrder}
                  setInvoice={setInvoice}
                  setWarningMessage={setWarningMessage}
                  selectedValue={selectedValue}
                  handleSelectChange={handleSelectChange}
                />
              ) : null}
            </div>
          </div>

          <div className="absolute top-0 right-0 pr-[18px] pt-[18px] pb-[12px]">
            <p className="text-[#7F8098] font-nunito font-bold text-lg mb-[15px]">
              {grandTotalAfterDiscount}{" "}
              <span className="text-[13px]">
                {invoiceSetting?.currency_info?.code
                  ? invoiceSetting?.currency_info?.code
                  : "BDT"}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditOrderProduct;
